/** 
 * [Ref] - Denotes Pseudo Code Reference
 * Author: Chandrasekar
 * Created Date: 07/30/2020
 * 
 * Import the necessary node-modules. If any of the nodes modules are not avaialble then 
 * install the node modules using the npm install command.
 * 
 * Ref: MN_PC_01
*/
// WW-1336 - Relevant Type Ahead Suggestions - [3/14/2025] - K Surya 
import React, { Component, createRef } from 'react';
import * as $ from 'jquery';
import Image from 'react-image-resizer';
import swal from 'sweetalert';
import * as MenuAction from '../actions/MenuAction';
import MenuStore from '../stores/MenuStore';
import HomepageStore from '../stores/HomepageStore';// PC_A1QA-179 A1QA-179 Pavithra R Help Page 
import * as HomepageAction from '../actions/HomepageAction';// PC_A1QA-179 A1QA-179 Pavithra R Help Page
import * as CookieService from '../CookieService';
import SDIConstants, { ConvertToEst } from '../SDIConstants';
import { BreadCrumpData, SearchBreadCrumpData } from '../stores/BreadCrumpStore';
import IdleTimer from 'react-idle-timer';
import Autocomplete from 'react-autocomplete';
import { string } from 'prop-types';
import { withTranslation, Trans } from 'react-i18next';
//import { countries } from 'country-flag-icons'
import Select, { components } from "react-select";
//import i18n from '../i18n';
//import i18n from './i18n';
import { useTranslation } from "react-i18next";
//import i18n from 'i18next';
import i18n from '../i18n';
import { initReactI18next } from 'react-i18next';
import { RotatingLines } from 'react-loader-spinner'
import { withAuth0 } from "@auth0/auth0-react"; //
import AlterpartsComponent from '../components/AltPartDetails';
//import Joyride from 'react-joyride';
//import { isSafari, isChrome } from 'react-device-detect';

//const Joyride = React.lazy(() => import('react-joyride'));
const availableMenu = SDIConstants.availablePages;

//const { t, i18n } = useTranslation('ns1', { i18n });
//const { t, i18n, ready } = useTranslation('ns1', { useSuspense: false });
let time;
let isFirstTimeLoaded = false;
let currentPath = "";
let isFromLink = false;
let strurlParams = "";
let IsImageSearch = false;
let qp = ""
let currentPagePath;
let mob_Session_USERID = ""
let mob_Session_BUSUNIT = ""
let Token = ""
let Password = ""
let cartDelete = false; //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
let mixCartChkFromFavOrder = false; //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
/*[08/22/22 , PC_04]Accessing STKIssueCart and RMA from mobile for web view - Priyanka D*/
const urlParams = window.location.search;
if (urlParams.includes("?qp_mob")) {
    strurlParams = urlParams.toString()
    if (strurlParams.includes("?qp_mob")) {

        let StrURL = strurlParams.split("?qp_mob=")
        let DecodedQueryparams = StrURL[1].toString();
        qp = atob(DecodedQueryparams);
        let QueryParams = qp.split("&")
        mob_Session_USERID = QueryParams[0].replace("mob_Session_USERID=", "");
        mob_Session_BUSUNIT = QueryParams[1].replace("mob_Session_BUSUNIT=", "");
        Password = QueryParams[2].replace("Password=", "");
        Token = QueryParams[3].replace("Token=", "");
        if (mob_Session_USERID || mob_Session_BUSUNIT || Token) {
            isFromLink = true;

            //Update the User ID and Token in cookie to invoke secure controller
            CookieService.updateLocalStorageValues("Session_UserID", mob_Session_USERID)
            CookieService.setCookieValues(SDIConstants.access_token, Token)
        }
    }
}
const options = [
    {
        value: 'en', label: 'English', icon:
            "http://purecatamphetamine.github.io/country-flag-icons/3x2/US.svg"
    },
    {
        value: 'es', label: 'Español', icon: "http://purecatamphetamine.github.io/country-flag-icons/3x2/MX.svg"
    },
    {
        value: 'fr', label: 'Français', icon: "http://purecatamphetamine.github.io/country-flag-icons/3x2/FR.svg"
    }
]

const { Option } = components;
const IconOption = props => (
    <Option {...props}>
        <img
            src={props.data.icon}
            alt={props.data.label}
            style={{ "width": "12px" }}
        />
        {" "}
        {props.data.label}
    </Option>
);

class MenuComponent extends Component {
    _isMounted = false;
    /**
  * Ref: LN_PC_04
  * Define the constructor that takes props as parameter
  * 
  * @param props
  */
    constructor(props) {
        super(props);
        this.assignUserMenu = this.assignUserMenu.bind(this);
        this.menuNavigation = this.menuNavigation.bind(this);
        this.showChild = this.showChild.bind(this);
        this.showParent = this.showParent.bind(this);
        this.hideHamBurger = this.hideHamBurger.bind(this);
        this.assignMasterData = this.assignMasterData.bind(this);
        this.noncatClick = this.noncatClick.bind(this);
        this.interactiveClick = this.interactiveClick.bind(this);
        this.noncat = this.noncat.bind(this);
        this.WorkOrderFail = this.WorkOrderFail.bind(this);
        this.WONumChange = this.WONumChange.bind(this);
        this.ClearWO = this.ClearWO.bind(this);
        this.KeyPress = this.KeyPress.bind(this);
        this.ValidateWO = this.ValidateWO.bind(this);
        this.WOClose = this.WOClose.bind(this);
        this.WorkOrderResponse = this.WorkOrderResponse.bind(this);
        this.headerRedirect = this.headerRedirect.bind(this);
        this.favPagelinkClick = this.favPagelinkClick.bind(this);
        this.addFavItemsToCart = this.addFavItemsToCart.bind(this);
        this.selectFavItem = this.selectFavItem.bind(this);
        this.addFavOrderItemsToCart = this.addFavOrderItemsToCart.bind(this);
        this.selectFavOrderItem = this.selectFavOrderItem.bind(this);
        this.idleTimer = null;
        this.onAction = this._onAction.bind(this);
        this.onActive = this._onActive.bind(this);
        this.onIdle = this._onIdle.bind(this);
        this.logout = this.logout.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onSelect = this.onSelect.bind(this);
        this.getItemValue = this.getItemValue.bind(this);
        this.renderItem = this.renderItem.bind(this);
        this.sessionTimeoutMethod = this.sessionTimeoutMethod.bind(this);
        this.retrieveDataAsynchronously = this.retrieveDataAsynchronously.bind(this);
        this.megaMenuAssigment = this.megaMenuAssigment.bind(this);
        this.searchKeyPress = this.searchKeyPress.bind(this);
        this.searchClick = this.searchClick.bind(this);
        this.WorkOrderResponse = this.WorkOrderResponse.bind(this);
        this.fileInputRef = React.createRef();
        // WW-1336 - Relevant Type Ahead Suggestions - [3/14/2025] - K Surya 
        this.wrapperRef = createRef();
        this.wrapperRefMobile = createRef();
        this.changeRequestCount(true);
        this.state = {
            userMenu: [], headerMenu: [], childMenu: [], currentHeader: "",
            childComponents: null, hasFavItem: false,
            hasReqApproval: false, hasOrderApproval: false, hasFavOrder: false, hasMyAccount: false, hasOrderStatus: false, hasManageForms: false,
            cartCount: -1, notificationCount: -1, requestorApprovalCount: 0, orderApprovalCount: 0, myAccQS: "", favPages: [], logo: "/Images/sdi-logo.png"
            , AnswerlabVisible: false, lblTest: "", lblTestVisible: false, lblVersion: "", favitems: [], allSelected: false, favorders: [], cartItems: [],
            favItemsCount: 0, favOrdersCount: 0, favOrderLineItems: [], favOrderLineItemImgs: [], VersionData: CookieService.getLocalStorageValues("VersionData") != null && CookieService.getLocalStorageValues("VersionData") != undefined ? JSON.parse(decodeURIComponent(CookieService.getLocalStorageValues("VersionData"))) : [], CurrentBuildDate: CookieService.getLocalStorageValues("CurrentBuildDate") != null && CookieService.getLocalStorageValues("CurrentBuildDate") != undefined ? CookieService.getLocalStorageValues("CurrentBuildDate") : "", CurrentBuildName: CookieService.getLocalStorageValues("CurrentBuildName") != null && CookieService.getLocalStorageValues("CurrentBuildName") != undefined ? CookieService.getLocalStorageValues("CurrentBuildName") : "Web Version:3.2.0.4", CurrentVersion: CookieService.getLocalStorageValues("currentversion") != null && CookieService.getLocalStorageValues("currentversion") != undefined ? CookieService.getLocalStorageValues("currentversion") : "4.3.6",
            autoCompleteValue: (this.props?.location?.pathname === '/searchresults' && CookieService.getLocalStorageValues("searchKey") && CookieService.getLocalStorageValues("IsProblemCodeSearch") == false)
                ? CookieService.getLocalStorageValues("searchKey")
                : "",  //WW-1378_WW-1382- Update search properties to search key when it in Search results - Nandhini L
            autocompleteData: [],
            // WW-1336 - Relevant Type Ahead Suggestions - [3/14/2025] - K Surya 
            productData: [],
            suggestionData: [],
            timeout: 1000 * 60 * SDIConstants.sessionTimeout,
            showModal: false,
            userLoggedIn: false,
            isTimedOut: false,
            loading: false,
            breadCrumpDetails: [],
            megaMenuCategories: [],
            PrivSubMenuList: [],
            PrivSuggMenuList: [],
            pickupCheck: false,
            deliveryShipTo: true,
            altDetails: [], Altdet: false,
            flagTable: [], AlternatePartdetail: [], filteredFlagTable: [],
            Wal_Phone_Num: CookieService.getLocalStorageValues("WAL_PHONE_NUM") != null && CookieService.getLocalStorageValues("WAL_PHONE_NUM") != undefined ? CookieService.getLocalStorageValues("WAL_PHONE_NUM") : "",
            Wal_Email_Id: CookieService.getLocalStorageValues("WAL_EMAIL_ID") != null && CookieService.getLocalStorageValues("WAL_EMAIL_ID") != undefined ? CookieService.getLocalStorageValues("WAL_EMAIL_ID") : "",
            Wal_Contact_Flag: CookieService.getLocalStorageValues("WAL_CONTACT_FLAG") != undefined ? CookieService.getLocalStorageValues("WAL_CONTACT_FLAG") : "",
            //WW-394 To Add Search In SDIZ Menu - Deepthi
            megaMenuHeader: [], SuggestionMenu: [], isHelpAccess: false,
            megaMenuList: [],
            UserMenuData: [],
            ActualMenuSugg: [],
            SelectedMenuName: "",
            apiURL: "", availablepages: [], FavItemCategory: [], FavItemSubMenu: [], favItemline: [], favitemcatcount: 0, language: CookieService.getLocalStorageValues("newlanguage") != null && CookieService.getLocalStorageValues("newlanguage") != undefined && CookieService.getLocalStorageValues("newlanguage") != false ? CookieService.getLocalStorageValues("newlanguage") : options[0], DefaultLang: options[0],
            DupSubMenuList: [], PrivList: [], FavOrderInv: [], FavItemInv: [], //CPW-167_PC_11
            WOErrorMsg: "",
            cartConfirmationPopupTxt: "", //[12/06/2024, WW-1221 PreveassignCartDatantive work order -Vishwa S]
            //WW-1229 Home tiles -Nandhini L
            userTiles: [],
            NSTKcartItems: [], NSTKCartCount: -1, runTour: false, //[WW-1325 Interactive Non-stock Cart -Vishwa S]
            // WW-1336 - Relevant Type Ahead Suggestions - [3/14/2025] - K Surya 
            elementIsShow: false,
            elementIsShowMobile: false,
            TransferCartCount: -1, SearchType: CookieService.getLocalStorageValues("SearchType") ? CookieService.getLocalStorageValues("SearchType") : "All",

        };
        console.log("menustatenewlang", CookieService.getLocalStorageValues("newlanguage"));
        //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
        cartDelete = false;
        mixCartChkFromFavOrder = false;
    };
    /*
     * To Get API URL from Controller
     */
    setAPIURL = () => {
        let cachedURL = sessionStorage.getItem("serviceURL");
        if (!cachedURL || cachedURL == "") {
            $.ajax({
                type: "GET",
                url: SDIConstants.localService
            }).then((data) => {
                this.setState({ apiURL: data });
                console.log("ThroughCall", data);
                sessionStorage.setItem("serviceURL", data);
            });

        } else {
            console.log("ThroughCache", sessionStorage.getItem("serviceURL"));
            this.setState({ apiURL: sessionStorage.getItem("serviceURL") });
        }
    };

    returnAPIURL = async () => {
        let response = await $.ajax({
            type: "GET",
            url: SDIConstants.localService
        });
        return response;
    }
    componentWillUnmount() {
        $('#Altdet').modal('hide');
        // WW-1336 - Relevant Type Ahead Suggestions - [3/14/2025] - K Surya 
        document.removeEventListener('mousedown', this.handleClickOutside);
        document.removeEventListener('mousedown', this.handleClickOutsideMoble);
        //document.removeEventListener('click', this.handleClickOutside);
        MenuStore.removeListener('load', this.assignUserMenu);
        MenuStore.removeListener('masterData', this.assignMasterData);
        MenuStore.removeListener('envData', this.assignEnvData);
        MenuStore.removeListener('addFav', this.cartInsertSuccess);
        MenuStore.removeListener('addFavOrder', this.cartOrderSuccess);
        MenuStore.removeListener('tokenExpired', this.sessionTimeoutMethod);
        MenuStore.removeListener('workordercheckresponsemenu', this.WorkOrderResponse);
        MenuStore.removeListener('WOfailmenu', this.WorkOrderFail);
        this._isMounted = false;
    };

    //handleClickOutside = (event) => {
    //    if (this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
    //        this.setState({ elementIsShow: false })
    //    }
    //};

    /**
    * Updates the state of the autocomplete data with the remote data obtained via AJAX.
    * 
    * @param {String} searchText content of the input that will filter the autocomplete data.
    * @return {Nothing} The state is updated but no value is returned
    */
    retrieveDataAsynchronously = async (searchText) => {
        let searchBO = {
            keywordStartsWith: searchText,
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
            Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
            Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
            Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
            Session_SDICAT: CookieService.getLocalStorageValues("Session_SDICAT"),
            Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
            Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
            Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
            Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
            Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
            Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
            Session_CplusDbSQL: CookieService.getLocalStorageValues("Session_CplusDbSQL"),
            Session_CARTTAXEXMPTFLAG: CookieService.getLocalStorageValues("Session_CARTTAXEXMPTFLAG"),
            Session_ZEUSNOCATALOGSITE: CookieService.getLocalStorageValues("Session_ZEUSNOCATALOGSITE"),
            Session_ZEUS_SITE: CookieService.getLocalStorageValues("Session_ZEUS_SITE"),
            SearchType: CookieService.getLocalStorageValues("SearchType") === "Sup P.#" ? "supplier part #" : CookieService.getLocalStorageValues("SearchType") === "MFG P.#" ? "manufacturer part #" : "all",
        }

        let responseData = await MenuAction.getSearchSuggestions(searchBO);
        let autoCompleteDataRes = [];
        let suggestionsStr = []
        if (responseData != "") {
            responseData = JSON.parse(responseData);
            // WW-1336 - Relevant Type Ahead Suggestions - [3/14/2025] - K Surya 
            const productArray = [];
            const suggestionArray = [];
            //debugger;
            responseData.forEach(item => {
                if (item.Header === 'ProductSuggestions') {
                    productArray.push({ label: item.SuggestionsValue, value: item.SuggestionsValue });
                } else if (item.Header === 'Suggestions') {
                    suggestionArray.push({ label: item.SuggestionsValue, value: item.SuggestionsValue });
                }
            });

            //suggestionsStr = responseData.filter((item) => item != null);

            //suggestionsStr.forEach((sugg, index) => {
            //    autoCompleteDataRes.push({ label: sugg, value: sugg });
            //});
            //let test = $('#Shipment_Method').hasClass('show')
            //if (!test) {
            this.setState({ productData: productArray, suggestionData: suggestionArray });
            //}
        }
    }

    // WW-1336 - Relevant Type Ahead Suggestions - [3/14/2025] - K Surya 
    displaySuggestions = () => {
        if (this.state.productData && this.state.suggestionData && this.state.productData.length > 0 && this.state.suggestionData.length > 0) {
            //if (this.state.productData.length > 0 && this.state.suggestionData.length > 0) {
            // Display both product suggestions and general suggestions
            return (

                <div class="search-suggestion-menu-container menusearch">
                    <div class="search-suggestion-title-container w-100">
                        <h3 class="search-suggestion-title m-0">Previously Purchased Items</h3>
                    </div>
                    <ul class="search-suggestion-menu-items Purchase-suggestion-menu-items mb-2">
                        {this.state.productData.map((product, index) => (
                            <li key={`product-${index}`} onClick={(e) => this.onSelect(product.value)} ><button class="btn">{product.value}</button></li>
                        ))}
                    </ul>

                    <div class="search-suggestion-divider-section">
                    </div>
                    <div class="search-suggestion-title-container w-100">
                        <h3 class="search-suggestion-title m-0">Suggestions</h3>
                    </div>

                    <ul class="search-suggestion-menu-items Purchase-suggestion-menu-items mb-2">
                        {this.state.suggestionData.map((suggestion, index) => (
                            <li key={`suggestion-${index}`} onClick={(e) => this.onSelect(suggestion.value)} ><button class="btn">{suggestion.value}</button></li>
                        ))}
                    </ul>
                </div>


            );
            //}
        } else if (this.state.suggestionData && this.state.suggestionData.length > 0) {
            //if (this.state.suggestionData.length > 0) {

            // Display only general suggestions
            return (
                //<div class="container-fluid mt-4">
                <div class="search-suggestion-menu-container menusearch">
                    <div class="search-suggestion-title-container w-100">
                        <h3 class="search-suggestion-title m-0">Suggestions</h3>
                    </div>
                    <ul class="search-suggestion-menu-items Purchase-suggestion-menu-items mb-2">
                        {this.state.suggestionData.map((suggestion, index) => (
                            <li key={`suggestion-${index}`} onClick={(e) => this.onSelect(suggestion.value)}><button class="btn">{suggestion.value}</button></li>
                        ))}
                    </ul>
                </div>
                //</div>

            );
            //}
        } else if (this.state.productData && this.state.productData.length > 0) {
            //if (this.state.productData.length > 0) {
            // Display only product suggestions
            return (
                //<div class="container-fluid mt-4">
                <div class="search-suggestion-menu-container menusearch">
                    <div class="search-suggestion-title-container w-100">
                        <h3 class="search-suggestion-title m-0">Previously Purchased Items</h3>
                    </div>
                    <ul class="search-suggestion-menu-items Purchase-suggestion-menu-items mb-2">
                        {this.state.productData.map((product, index) => (
                            <li key={`product-${index}`} onClick={(e) => this.onSelect(product.value)}><button class="btn">{product.value}</button></li>
                        ))}
                    </ul>
                </div>
                //</div>

            );
            //}
        } else {
            // No suggestions available
            return <div></div>;
        }

    }
    /**
     * Callback triggered when the user types in the autocomplete field
     * 
     * @param {Event} e JavaScript Event
     * @return {Event} Event of JavaScript can be used as usual.
     */
    onChange(e) {


        let test = $('#Shipment_Method').hasClass('show')
        if (!test) {
            this.setState({
                autoCompleteValue: e.target.value
            });
            if (e.target.value.length > 0) {
                this.retrieveDataAsynchronously(e.target.value);
            }

        }


        /**
         * Handle the remote request with the current text !
         */


    }
    /**
   * Callback triggered when the autocomplete input changes.
   * 
   * @param {Object} val Value returned by the getItemValue function.
   * @return {Nothing} No value is returned
   */
    // WW-1336 - Relevant Type Ahead Suggestions - [3/14/2025] - K Surya 
    onSelect(val) {
        this.setState({
            autoCompleteValue: val, productData: [], suggestionData: []
        });

    }
    /**
 * Define the markup of every rendered item of the autocomplete.
 * 
 * @param {Object} item Single object from the data that can be shown inside the autocomplete
 * @param {Boolean} isHighlighted declares wheter the item has been highlighted or not.
 * @return {Markup} Component
 */
    renderItem(item, isHighlighted) {
        return (
            <div key={item.label} style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
                {item.label}
            </div>
        );

    }
    /**
   * Define which property of the autocomplete source will be show to the user.
   * 
   * @param {Object} item Single object from the data that can be shown inside the autocomplete
   * @return {String} val
   */
    getItemValue(item) {
        // You can obviously only return the Label or the component you need to show
        // In this case we are going to show the value and the label that shows in the input
        // something like "1 - Microsoft"
        return `${item.value}`;
    }
    //WW-394 To Add Search In SDIZ Menu - Deepthi
    rendermenuItem(item, isHighlighted) {
        //const { t} = this.props
        return (

            <div key={item.label} style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
                <Trans>{item.label}</Trans>
            </div>
        );

    }
    //WW-394 To Add Search In SDIZ Menu - Deepthi
    getItemMenuValue(item) {

        return `${item.value}`;
    }
    //WW-394 To Add Search In SDIZ Menu - Deepthi
    onChangeItem(e) {
        //debugger
        const { t } = this.props
        let val = e.target.value.toUpperCase()
        let len = e.target.value;
        if (e.target.value == "") {
            //let result = this.state.autocompleteItemData.filter(name => name.label.toUpperCase().includes(val))
            this.setState({
                SelectedMenuName: e.target.value, SuggestionMenu: []
            });

        }
        else if (len.length <= 40) {
            //WW-703 Menu Revamping-Deepthi N H
            let result = this.state.ActualMenuSugg.filter(name => t(name.label).toUpperCase().includes(val))
            //let ind = result.findIndex(item => item.value.trim().toLowerCase() == "manage forms")
            //if (this.state.hasManageForms == false && ind > -1) {
            //    result.splice(ind, 1)
            //}
            this.setState({
                SelectedMenuName: e.target.value, SuggestionMenu: result
            });
        }
    }
    onSelectItem = (event) => {
        //debugger
        this.setState({
            SelectedMenuName: event
        });
        this.MenuSearchClick(event)
    }

    /**
   * MN_PC_53
   * This listener method gets the response from Store 
   * after adding Favorite order line item into cart
   */
    cartOrderSuccess = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let addFavOrderdataRes = JSON.parse(MenuStore.cartOrderSuccess);
        if (addFavOrderdataRes) {
            if (addFavOrderdataRes.Table1.length > 0) {
                addFavOrderdataRes = addFavOrderdataRes.Table1[0];
                if (addFavOrderdataRes.is_Success == "True") {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        // text: "Items " + favItemInCat + " are addded to cart"
                        text: "Item successfully added to cart"
                    });
                    if (currentPath.toLowerCase() == "/shoppingcart") {
                        window.location.reload();
                    } else {
                        this.props.history.push({
                            pathname: '/shoppingcart',
                        });
                    }
                } else {
                    console.log("Problem in adding items to cart");
                    CookieService.updateLocalStorageValues("Session_CARTFAIL", addFavOrderdataRes.Session_CARTFAIL);
                }
            }
        }
    }



    /**
    * MN_PC_53
    * This listener method gets the response from Store 
    * after adding Favorite item into cart
    */
    //[1/25/23, WW-542_PC_28, Dhevanesam R]
    cartInsertSuccess = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let { favitems } = this.state;
        favitems.map((item, index) => {
            favitems[index].checked = false
        })
        this.setState({ favitems })
        let addFavdataRes = JSON.parse(MenuStore.cartSuccess);
        let FlagTable = addFavdataRes.FlagTable;
        let AlternatePartdetail = addFavdataRes.AltPartDetails
        let AlternatePartdetailFlag = addFavdataRes.AltPartDetailsFlag
        let favItemRes = [];
        let favItemNotInCat = [];
        let favItemInCat = [];
        let session_gotNSTKArr = [];
        let session_CARTFAILArr = [];
        let favItemNotInCatItemID = "";
        let message = "";
        let unAvailItems = FlagTable.filter((x) => x.is_Success == "False")
        MenuAction.refreshMasterData();

        if (FlagTable.length > 0) {
            favItemRes = FlagTable
            favItemRes.forEach((value, index) => {
                session_gotNSTKArr.push(value.Session_gotNSTK)
                if (value.is_Success == "False") {
                    favItemNotInCat.push(value.Item_ID)
                    session_CARTFAILArr.push(value.Session_CARTFAIL)
                }
                else {
                    favItemInCat.push(value.Item_ID)
                }

            });
            CookieService.updateLocalStorageValues("Session_gotNSTK", session_gotNSTKArr);

            if (favItemNotInCat.length > 0) {
                favItemNotInCatItemID = favItemNotInCat.join(",")
            }
            if (!unAvailItems.length > 0) {
                if (favItemInCat.length == 1) {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        // text: "Item " + favItemInCat + " is addded to cart"
                        text: "Item successfully added to cart"
                    });

                    if (currentPath.toLowerCase() == "/shoppingcart") {
                        window.location.reload();
                    } else {
                        this.props.history.push({
                            pathname: '/shoppingcart',
                        });
                    }


                    return;
                } else if (favItemInCat.length > 0) {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        // text: "Items " + favItemInCat + " are addded to cart"
                        text: "Items successfully added to cart"
                    });
                    if (currentPath.toLowerCase() == "/shoppingcart") {
                        window.location.reload();
                    } else {
                        this.props.history.push({
                            pathname: '/shoppingcart',
                        });
                    }
                    return;
                }
            } else {
                if (AlternatePartdetail != undefined && AlternatePartdetail != null) {
                    if (AlternatePartdetail.length > 0) {
                        AlternatePartdetail.map((val, index) => {
                            val.IsSelected = false
                        })
                        unAvailItems.map((val, index) => {
                            val.startIndex = 0
                        });
                        AlternatePartdetail.map((val, index) => {
                            val.IsSelected = false
                            val.QuantityOrdered = val.min_order_qty;
                        });
                        this.setState({ AlternatePartdetail: AlternatePartdetail, filteredFlagTable: unAvailItems, Altdet: true })

                        $('#Altdet').modal('show');
                    } else {
                        if (favItemNotInCat.length == 1) {
                            swal({
                                allowOutsideClick: false,
                                closeOnClickOutside: false,
                                text: "Item " + favItemNotInCatItemID + " is not available in catalog"
                            });
                            return;
                        } else if (favItemNotInCat.length > 0) {
                            swal({
                                allowOutsideClick: false,
                                closeOnClickOutside: false,
                                text: "Items " + favItemNotInCatItemID + " are not available in catalog"
                            });


                        }

                        CookieService.updateLocalStorageValues("Session_CARTFAIL", session_CARTFAILArr);

                    }
                } else {
                    if (favItemInCat.length == 1) {
                        swal({
                            allowOutsideClick: false,
                            closeOnClickOutside: false,
                            text: "Item " + favItemNotInCatItemID + " is not available in catalog"
                        });
                        return;
                    } else if (favItemInCat.length > 0) {
                        swal({
                            allowOutsideClick: false,
                            closeOnClickOutside: false,
                            text: "Items " + favItemNotInCatItemID + " are not available in catalog"
                        });

                    }
                }
                // WW-685 PC_685_03 Display label for unavaialable item 5/26/2023 Pavithra 
                let { favitems } = this.state;
                // let griddata = this.state.favitems;
                favitems.forEach((value, index) => {
                    let alpartFlag = AlternatePartdetailFlag.filter(x => (value.CLIENT_MFG_PART.toUpperCase() == x.MFGPartNum.toUpperCase() && value.ISA_CP_ITEM_ID.toUpperCase() == x.ItemID.toUpperCase() && value.MANUFACTURER.toUpperCase() == x.Manufacturer.toUpperCase() && value.SUPPLIER_ID == x.SupplierID))
                    if (alpartFlag.length > 0) {
                        favitems[index].ISA_COMMENTS = alpartFlag[0].ISA_COMMENTS;

                    }
                })
                this.setState(favitems);


            }
        }


    }
    /**
    * Predefined React method, will be called once the HTML elements are renderd
    * on pageload
    */
    componentDidMount() {
        //debugger

        console.log("cc", CookieService.getLocalStorageValues("newlanguage"))
        let isTokenPresent = CookieService.getCookieValue(SDIConstants.access_token);
        if (isTokenPresent == "") {
            localStorage.clear();
            this.props.history.push({
                pathname: '/',
            });
            return false;
        }
        //*****NEW*******wal-158***
        let locpage = [];
        SDIConstants.availablePages.map((x) => {
            let loc = { page: x.pageURL }
            locpage.push(loc)
        })

        //*********END**
        this.setAPIURL();
        this._isMounted = true;
        //WW-1378_WW-1382- Update the currentPath to the variable PrevPath - Nandhini L
        let PrevPath = currentPath ? currentPath : CookieService.getLocalStorageValues("PrevPath");
        CookieService.updateLocalStorageValues("PrevPath", PrevPath)
        currentPath = this.props.location.pathname;
        currentPath = currentPath.indexOf("?") >= 0 ? currentPath.split("?")[0] : currentPath;
        let FieldInventory_cleardata = CookieService.getLocalStorageValues("FieldInventory_cleardata");
        let clear = currentPath.toLowerCase() !== "/fieldinventoryworkbench";
        if (!clear && FieldInventory_cleardata) {
            CookieService.updateLocalStorageValues("FieldInventory_PageLoadData", []);
            CookieService.updateLocalStorageValues("FieldInventory_RegionDD", []);
            CookieService.updateLocalStorageValues("FieldInventory_SubRegionDD", []);
            CookieService.updateLocalStorageValues("FieldInventory_TruckidDD", []);
            CookieService.updateLocalStorageValues("FieldInventory_TechNameDD", []);
            CookieService.updateLocalStorageValues("FieldInventory_RegionValue", '');
            CookieService.updateLocalStorageValues("FieldInventory_SubRegionValue", '');
            CookieService.updateLocalStorageValues("FieldInventory_TruckidValue", '');
            CookieService.updateLocalStorageValues("FieldInventory_TechNameValue", '');
            CookieService.updateLocalStorageValues("FieldInventory_SearchTxt", '');
            CookieService.updateLocalStorageValues("FieldInventory_UserId", '');
            CookieService.updateLocalStorageValues("FieldInventory_IncludeZeroCheck", '');
        }


        if (!localStorage.getItem("SDIMenu")) {
            let menuBO = {
                Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
                Session_MenuUpdated: "False",
                Session_SDIMenu: "",
                Session_BARCODE: CookieService.getLocalStorageValues("Session_BARCODE") ? CookieService.getLocalStorageValues("Session_BARCODE") : "",
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                Session_USERTYPE: CookieService.getLocalStorageValues("Session_USERTYPE"),
                Session_DEFAULTPAGE: CookieService.getLocalStorageValues("Session_DEFAULTPAGE"),
                Session_CONAME: CookieService.getLocalStorageValues("Session_CONAME"),
                Session_CUSTID: CookieService.getLocalStorageValues("Session_CUSTID"),
                Session_SITEBU: CookieService.getLocalStorageValues("Session_SITEBU"),
                Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
                Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
                Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
                Session_AGENTUSERNAME: CookieService.getLocalStorageValues("Session_AGENTUSERNAME") ? CookieService.getLocalStorageValues("Session_AGENTUSERNAME") : "",
                Session_USERNAME: CookieService.getLocalStorageValues("Session_USERNAME"),
                Source: 'Web',
                Version_No: this.state.CurrentVersion
            }
            MenuAction.getMenuItems(menuBO);
            console.log("API");
            isFirstTimeLoaded = true;
        } else {
            //WW-703 Menu Revamping-Deepthi N H
            let MenuData = [];
            let SuggData = [];
            let megaMenuList = [];
            let CatWithChild = [];
            let ParentWithChild = [];
            let WithoutParent = [];
            let PrivlegeList;
            let isHelpAccess = false;
            //WW-1229 Home tiles -Nandhini L
            let userTiles = [];
            let menuResponse = localStorage.getItem("SDIMenu");
            //WW-1229 Home tiles -Nandhini L
            let HomemenuResponse = localStorage.getItem("SDIHomeMenu");
            HomemenuResponse = JSON.parse(HomemenuResponse);
            if (HomemenuResponse != null && HomemenuResponse != undefined) {
                HomemenuResponse = HomemenuResponse.filter((x) => x.SITE_NAME.includes("W"));
            }

            menuResponse = JSON.parse(menuResponse);
            menuResponse = menuResponse.filter((x) => x.SITE_NAME.includes("W"));
            //WW-1229 Home tiles -Nandhini L
            if (menuResponse.length > 0 || HomemenuResponse.length > 0) {
                //WW-703 Menu Revamping-Deepthi N H
                MenuData = menuResponse;
                PrivlegeList = MenuData;
                //WW-1229 Home tiles -Nandhini L
                userTiles = HomemenuResponse;
                PrivlegeList = MenuData;
                let SDI_Emp = "";
                let User_Div = "";
                //WW-981/WW-1007 - As a Walmart Home Office Buyer, I want the Sourced Non-Catalog view to Indicate Unit and Extended Price, Standardized Mfg. Part #s and required Attachment - Deepthi N H
                if (CookieService.getLocalStorageValues("Session_SDIEMP") != null && CookieService.getLocalStorageValues("Session_SDIEMP") != undefined) {
                    SDI_Emp = CookieService.getLocalStorageValues("Session_SDIEMP")
                }
                if (CookieService.getLocalStorageValues("Session_User_Division") != null && CookieService.getLocalStorageValues("Session_User_Division") != undefined) {
                    User_Div = CookieService.getLocalStorageValues("Session_User_Division")

                }
                MenuData = MenuData.filter((x) => x.ISA_IDENTIFIER != 1 && x.ISA_IDENTIFIER != 156 && x.ISA_IDENTIFIER != 162 && x.ISA_IDENTIFIER != 296 && x.ISA_IDENTIFIER != 298 && x.ISA_IDENTIFIER != 319 && x.ISA_IDENTIFIER != 320);
                CatWithChild = MenuData.filter((x) => x.ISA_CATEGORY_ID != null && x.ISA_CATEGORY_ID != "");
                megaMenuList = CatWithChild.filter((v, i, a) => a.findIndex(t => (t.ISA_CATEGORY_ID === v.ISA_CATEGORY_ID)) === i);
                megaMenuList.forEach((catVal, catInd) => {
                    ParentWithChild = CatWithChild.filter((x) => x.ISA_CATEGORY_ID == catVal.ISA_CATEGORY_ID && x.ISA_PARENT_IDENT != null && x.ISA_PARENT_IDENT != "");
                    WithoutParent = CatWithChild.filter((x) => x.ISA_CATEGORY_ID == catVal.ISA_CATEGORY_ID && (x.ISA_PARENT_IDENT == null || x.ISA_PARENT_IDENT == ""));
                    if (ParentWithChild.length > 0) {
                        ParentWithChild.forEach((parVal, parInd) => {
                            let parObj = {
                                value: parVal.ISA_PARENT_NAME,
                                label: parVal.ISA_PARENT_NAME
                            }
                            let ParPresent = SuggData.some((x) => x.label == parVal.ISA_PARENT_NAME);
                            if (SuggData.length == 0 || ParPresent == false) {
                                SuggData.push(parObj);
                            }

                            let childObj = {
                                value: parVal.ISA_IDENTIFIER_NAME,
                                label: parVal.ISA_IDENTIFIER_NAME
                            }
                            let ChildPresent = SuggData.some((x) => x.label == parVal.ISA_IDENTIFIER_NAME);
                            if (SuggData.length == 0 || ChildPresent == false) {
                                SuggData.push(childObj);
                            }

                        });
                    }
                    if (WithoutParent.length > 0) {
                        WithoutParent.forEach((parVal, parInd) => {
                            let parObj = {
                                value: parVal.ISA_IDENTIFIER_NAME,
                                label: parVal.ISA_IDENTIFIER_NAME
                            }
                            let ParPresent = SuggData.some((x) => x.label == parVal.ISA_PARENT_NAME);
                            if (SuggData.length == 0 || ParPresent == false) {
                                SuggData.push(parObj);
                            }

                        });
                    }
                });
                let DirectMenuItems = MenuData.filter((x) => x.ISA_CATEGORY_ID == null || x.ISA_CATEGORY_ID == "");
                DirectMenuItems.forEach((dirVal, dirInd) => {
                    if (dirVal.ISA_IDENTIFIER == 341 || dirVal.ISA_IDENTIFIER == 357) {
                        isHelpAccess = true;
                    }
                    else {
                        megaMenuList.push(dirVal);
                    }

                })

            }
            //WW-1229 Home tiles -Nandhini L
            this.menuAssigment(MenuData, userTiles);
            isFirstTimeLoaded = false;
            //WW-1229 Home tiles -Nandhini L
            this.setState({ UserMenuData: MenuData, userTiles: userTiles, ActualMenuSugg: SuggData, megaMenuList: megaMenuList, PrivList: PrivlegeList, isHelpAccess: isHelpAccess });
        }
        if (!localStorage.getItem("SDIEnvironmentData")) {
            let environmentBO = {
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
                Session_ZEUS_SITE: CookieService.getLocalStorageValues("Session_ZEUS_SITE"),
                AbsoluteUri: window.location.hostname,
                Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
                Session_TESTMODE: CookieService.getLocalStorageValues("Session_TESTMODE"),
                Session_ClientLogoImagePath: CookieService.getLocalStorageValues("Session_ClientLogoImagePath"),
                Session_ISACrossSiteAcc: CookieService.getLocalStorageValues("Session_ISACrossSiteAcc")
            }
            MenuAction.getEnvironmentDetails(environmentBO);
        } else {
            this.assignEnvData();
        }
        //document.addEventListener('click', this.handleClickOutside);
        HomepageStore.on('PassThroughAuthe', this.PassThroughAutheResponse);
        MenuStore.on('load', this.assignUserMenu);
        MenuStore.on('masterData', this.assignMasterData);
        /*[05/10/22,WW-243-Cart Counter Updation, Priyanka D */
        MenuStore.on('CartCount', this.assignCartData);
        MenuStore.on('envData', this.assignEnvData);
        MenuStore.on('addFav', this.cartInsertSuccess);
        MenuStore.on('addFavOrder', this.cartOrderSuccess);
        MenuStore.on('tokenExpired', this.sessionTimeoutMethod);
        MenuStore.on('workordercheckresponsemenu', this.WorkOrderResponse);
        MenuStore.on('WOfailmenu', this.WorkOrderFail);
        //$(document).on('click', function (event) {
        //    if (!$(event.target).closest('#hamburger-canvas').length) {
        //        $('#hamburger-canvas').hide();
        //    }
        //});
        $('#hamburgermenu').show();
        $('#hamburgermenu').click(function () {
            $('#non-catalog').hide();
            $('#hamburger-menu-container-background').addClass('hmenu-opaque');
            $('#hamburger-menu-container').addClass('showvisible');
        });
        $('#hamgurgerhide').click(function () {
            $('#hamburger-menu-container-background').removeClass('hmenu-opaque');
            $('#hamburger-menu-container').removeClass('showvisible');
        });
        $('#non-catalog').hide();

        //WW-1378_WW-1382- update the currentPath to 'SearchAndItemDetail'
        if ((window.location.pathname === '/forms' || window.location.pathname === '/suppliersuggestionpage')
            && PrevPath != '/searchresults'
            && CookieService.getLocalStorageValues('SearchUrl') && CookieService.getLocalStorageValues('itemDetailUrl')) {
            PrevPath = 'SearchAndItemDetail'
        }
        //WW-1378_WW-1382- update the PrevPage and currentPageProps
        let PrevPage = PrevPath === 'SearchAndItemDetail' ? PrevPath
            : PrevPath ? availableMenu.filter((page) => page.pageURL.toLowerCase() == PrevPath.toLowerCase()) : "";
        let currentPageProps = availableMenu.filter((page) => page.pageURL.toLowerCase() == currentPath.toLowerCase());
        document.title = currentPageProps.length > 0 ? currentPageProps[0].pageTitle : "ZEUS";
        //WW-1378_WW-1382- Declare the variable breadCrumpDetails
        let breadCrumpDetails;
        let UpdatedPage = false;
        CookieService.updateLocalStorageValues("PrevPage", "");

        let breadCrumpfromfield = this.props.location.state ? this.props.location.state.isFromFieldInventory : false;

        if ((PrevPage && PrevPage !== '' &&
            (window.location.pathname === '/itemdetailnew' && (PrevPage[0].pageName == "SearchResults" || PrevPage[0].pageName == "ItemDetail" ||
                PrevPage[0].pageName == "SupplierSuggestion" || PrevPage[0].pageName == "Forms")))) {
            CookieService.updateLocalStorageValues("SearchKeyWord", CookieService.getLocalStorageValues("searchKey"));
        } else {
            CookieService.updateLocalStorageValues("SearchKeyWord", "");
        }

        // WW-1378_WW-1382- Update the breadCrumpDetails
        if (PrevPage && PrevPage !== '' &&
            ((window.location.pathname === '/itemdetailnew' && (PrevPage[0].pageName == "SearchResults" || PrevPage[0].pageName == "ItemDetail" ||
                PrevPage[0].pageName == "ShoppingCart" || (CookieService.getLocalStorageValues('SearchUrl') && PrevPage[0].pageName == "SupplierSuggestion" || PrevPage[0].pageName == "Forms")))
                || window.location.pathname === '/forms' || window.location.pathname === '/suppliersuggestionpage')) {

            if (CookieService.getLocalStorageValues('SearchUrl')) {
                if (PrevPage[0].pageName != "ShoppingCart" && window.location.pathname === '/itemdetailnew') {
                    CookieService.updateLocalStorageValues("PrevPage", "Search");
                }
                if ((PrevPage[0].pageName != "ShoppingCart" && window.location.pathname === '/itemdetailnew') ||
                    (!CookieService.getLocalStorageValues('itemDetailUrl') && PrevPage[0].pageName == "SupplierSuggestion" && window.location.pathname === '/forms')) {
                    PrevPage = "SearchResults"
                    UpdatedPage = true
                }
            }

            const PrevPageName = (PrevPage === 'SearchAndItemDetail' || UpdatedPage) ? PrevPage : PrevPage[0].pageName;
            const CurrentPageName = currentPageProps[0].pageName;

            breadCrumpDetails = SearchBreadCrumpData[CurrentPageName][PrevPageName];
        }
        else if (currentPageProps && currentPageProps.length > 0) {
            if (breadCrumpfromfield) {
                breadCrumpDetails = [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Field Invetory Workbench", pageURL: "/fieldInventoryWorkbench" }]
                if (currentPath) {
                    breadCrumpDetails.push({ pageName: currentPageProps[0].pageName, pageURL: "/" });
                }
            } else {
                breadCrumpDetails = BreadCrumpData[currentPageProps[0].pageName];
            }
        }

        if (breadCrumpDetails && this._isMounted) {
            this.setState({ breadCrumpDetails });
        }
        // WW-1336 - Relevant Type Ahead Suggestions - [3/14/2025] - K Surya 
        document.addEventListener('mousedown', this.handleClickOutside);

        document.addEventListener('mousedown', this.handleClickOutsideMoble);

    };
    //WW-703 Menu Revamping - Out side click issue
    handleOutsideClick = (event) => {
        //debugger;
        $('#non-catalog').hide();
        this.hideHamBurger();

    }
    // WW-1336 - Relevant Type Ahead Suggestions - [3/14/2025] - K Surya 
    handleClickOutside = (event) => {
        let { elementIsShow, autoCompleteValue } = this.state

        if (this.wrapperRef.current && (!this.wrapperRef.current.contains(event.target) || event?.target?.id == "filterButton")) {
            elementIsShow = false
        }

        if (event.target.id == "PcToggleInput" || event.target.id == "PcToggleSpan") {
            autoCompleteValue = ""
            CookieService.updateLocalStorageValues("searchKey", "");
        }

        this.setState({ elementIsShow, autoCompleteValue })
    };

    handleClickOutsideMoble = (event) => {
        if (this.wrapperRefMobile.current && (!this.wrapperRefMobile.current.contains(event.target) || event ?.target ?.id == "filterButton")) {
            this.setState({ elementIsShowMobile: false })
        }
    };
    handleShowElement = () => {
        this.setState({ elementIsShow: true })
    }

    handleShowElementMobile = () => {
        this.setState({ elementIsShowMobile: true })
    }

    /**
    * MN_PC_54
    * This method returns the Breadcrump of page
    * from the BreadCrumpStore
    */
    bindBreadCrump = () => {


        return this.state.breadCrumpDetails.map((breadCrump, index) => {
            let activeClass = ""
            let breadCrumpContent = (<a href="#" onClick={(event) => this.headerRedirect(event, breadCrump.pageURL)}><Trans>{breadCrump.pageName}</Trans></a>);
            console.log("breadCrump.pageName", this.state.breadCrumpDetails)
            if (index == this.state.breadCrumpDetails.length - 1) {
                activeClass = "active"
                breadCrumpContent = breadCrump.pageName;
            }
            return (<li key={index} className={`breadcrumb-item ${activeClass}`} aria-current="page" ><Trans>{breadCrumpContent}</Trans></li>)
        });
    }
    /**
   * MN_PC_20
   * This method will be called on log out button click
   * and clears the cookies and localStorage values
   */
    logout = (event) => {
        //debugger
        event.preventDefault();
        let newlang = CookieService.getLocalStorageValues("newlanguage");
        let lastversion = CookieService.getLocalStorageValues("lastVersion");
        CookieService.setCookieValues(SDIConstants.access_token, "", -1);
        localStorage.clear();
        CookieService.updateLocalStorageValues("lastVersion", lastversion);
        let lv = CookieService.getLocalStorageValues("lastVersion");
        CookieService.updateLocalStorageValues("newlanguage", newlang);
        //[12/20/2022]WW-456 Adding SSOClick and isLogout cookies to track SSO login and logout 
        CookieService.updateLocalStorageValues("isSSOClick", false);
        CookieService.updateLocalStorageValues("isLogout", true);
        //WW-721_PC_06 -to logout from SSO
        const { logout } = this.props.auth0;
        logout({ returnTo: window.location.origin });
        //this.props.history.push({
        //    pathname: '/',
        //});
    }

    /**
    * MN_PC_51
    * This listner method will be called for getting environment and log data from store
    * or from localStorage
    */
    assignEnvData = async () => {
        let environmentDataResponse;
        //debugger
        if (!localStorage.getItem("SDIEnvironmentData")) {
            environmentDataResponse = JSON.parse(MenuStore.environmentData).EnvironmentDetails;
            localStorage.setItem("SDIEnvironmentData", JSON.stringify(environmentDataResponse));
        } else {
            environmentDataResponse = JSON.parse(localStorage.getItem("SDIEnvironmentData"));
        }
        if (environmentDataResponse.length > 0) {
            environmentDataResponse = environmentDataResponse[0];
            let version = environmentDataResponse.lblVersion.split("::")
            console.log("environmentDataResponse", environmentDataResponse);
            CookieService.updateLocalStorageValues("Session_IOLServer", environmentDataResponse.Session_WEBSITEID);
            let logoURL = this.state.logo;
            let { apiURL } = this.state;
            if (!apiURL) {
                apiURL = await this.returnAPIURL();
            };
            if (environmentDataResponse.imgCustomerLogoVisible == "True")
                logoURL = apiURL + (environmentDataResponse.imgCustomerLogoURL.indexOf("~") >= 0 ? environmentDataResponse.imgCustomerLogoURL.slice(environmentDataResponse.imgCustomerLogoURL.indexOf("~")) : environmentDataResponse.imgCustomerLogoURL)
            else if (environmentDataResponse.imgClientLogoVisible == "True")
                logoURL = apiURL + (environmentDataResponse.imgClientLogoUrl.indexOf("~") >= 0 ? environmentDataResponse.imgClientLogoUrl.slice(environmentDataResponse.imgClientLogoUrl.indexOf("~")) : environmentDataResponse.imgClientLogoUrl);
            else if (environmentDataResponse.imgLogoVisible == "True")
                logoURL = apiURL + (environmentDataResponse.imgLogoURL.indexOf("~") >= 0 ? environmentDataResponse.imgLogoURL.slice(environmentDataResponse.imgLogoURL.indexOf("~")) : environmentDataResponse.imgLogoURL);
            if (this._isMounted) {
                this.setState({
                    logo: logoURL, AnswerlabVisible: environmentDataResponse.AnswerlabVisible.toLowerCase() == "true",
                    lblTestVisible: environmentDataResponse.lblTestVisible.toLowerCase() == "true", lblTest: environmentDataResponse.lblTest, lblVersion: version[1] + " :: " + "3.4.2"
                });
            }

        }
    };
    /**
     * MN_PC_37/MN_PC_38/MN_PC_39/MN_PC_40/MN_PC_41/MN_PC_42/MN_PC_43/MN_PC_44
     * 
     * This listner method will get the data of  Get the Notification count,
     * Cart data, Cart count, Fav Order and Fav Item flags, 
     * Fav Order data, Fav item data, Fav Pages data, 
     * Requestor approval Count and Order Approval Count
     */
    /*[05/10/22,WW-243-Cart Counter Updation, Priyanka D */


    handleImageClk = () => {
        let Shipment_Method = CookieService.getLocalStorageValues("Shipment_Method")// Custom validation function for shipment
        if (Shipment_Method) {

            this.fileInputRef.current.click();

        } else {
            IsImageSearch = true
            $('#Shipment_Method').modal('show');
        }
    }
    handleFileChangeClick = (event) => {
        //debugger
        let file = event.target.files;

        //WW-1374 Update problem code search as false while image search - Nandhini L 
        CookieService.updateLocalStorageValues("IsProblemCodeSearch", false);
        this.setState({ IsProblemCodeSearch: false });

        let files = "";
        if (file) {
            if (file.length == 1) {
                CookieService.updateLocalStorageValues("Shipment_Method", true)
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                files = event.target.files[0]

                //WW-1378_WW-1382- Update search properties to new state - Nandhini L
                CookieService.updateLocalStorageValues('fromSearch', false);
                CookieService.updateLocalStorageValues('pageNo', "");
                CookieService.updateLocalStorageValues('GridType', "");
                CookieService.updateLocalStorageValues('pageCount', "");
                CookieService.updateLocalStorageValues("searchKey", "");
                CookieService.updateLocalStorageValues("ImageSearch", "");
                CookieService.updateLocalStorageValues("FilePath", "");
                CookieService.updateLocalStorageValues("FileName", "");
                CookieService.updateLocalStorageValues("SearchUrl", "");

                localStorage.setItem("pageNo", 1)
                this.props.history.push({
                    pathname: `/searchresults`,
                    search: `?key=`,
                    state: { ImageSearch: true, ImageFiles: file, image: files }

                });
                // let searchkeyvalue = this.state.autoCompleteValue.replace(/&/g, "%26") //WW-875_PC_01
                //  searchkeyvalue = searchkeyvalue.replace(/#/g, "%23")
                if (currentPath.toLowerCase() == "/searchresults") {

                    window.location.reload()


                }





                //this.props.history.push({
                //    pathname: `/searchresults`,
                //    search: `?key=ImgScr&Make=&Model=&AssetId=&`,
                //    state: { ImageSearch: true, ImageFiles: file, image: files }
                //});
                //    NonCatalogAction.addAttachment(file);
            } else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "You can choose only one Image"
                });

            }
        }
        else {
            // Handle cancel click here

        }


    }
    assignCartData = () => {
        //debugger
        let CartDataresponse = JSON.parse(MenuStore.CartCount);
        console.log("CartDataresponse", CartDataresponse);
        let cartCountRes = CartDataresponse.CartCount.length > 0 ? CartDataresponse.CartCount[0].totalCount : 0;
        //let NSTKCartCountRes = CartDataresponse.NSTKCartCount.length > 0 ? CartDataresponse.NSTKCartCount[0].NSTKtotalCount : 0;
        const uniqueOrderData = new Map();

        CartDataresponse.TransferCartCount.forEach((item) => {
            if (!uniqueOrderData.has(item.ORDER_NO)) {
                uniqueOrderData.set(item.ORDER_NO, item);
            }
        })

        const distinctCartData = Array.from(uniqueOrderData.values());
        let TransferCartCountRes = distinctCartData.length && distinctCartData.length > 0 ? distinctCartData.length : 0;
        this.setState({
            cartCount: cartCountRes,
            cartItems: CartDataresponse.CartData,
            //NSTKCartCount: NSTKCartCountRes,
            //NSTKCartItems: CartDataresponse.NSTKCartData,
            TransferCartCount: TransferCartCountRes,
        });
        localStorage.setItem('CartStorage', JSON.stringify(CartDataresponse.CartData));
        //localStorage.setItem('NSTKCartStorage', JSON.stringify(CartDataresponse.NSTKCartData));
    }
    assignMasterData = () => {
        //debugger
        let masterDataResponse = JSON.parse(MenuStore.masterData);
        console.log("masterDataResponse", masterDataResponse);
        let requestorApprovalCountRes = 0;
        let orderApprovalCountRes = 0;
        let notificationCountRes = masterDataResponse.NotificationCount.length > 0 ? masterDataResponse.NotificationCount[0].NotificationCount : 0;
        let cartCountRes = masterDataResponse.CartCount.length > 0 ? masterDataResponse.CartCount[0].totalCount : 0;
        //WW-1325 Nonstock cart Icon on Topnavigation bar -Vishwa S
        //let NSTKCartCountRes = masterDataResponse.NSTKCartCount.length != undefined && masterDataResponse.NSTKCartCount.length != null && masterDataResponse.NSTKCartCount.length > 0 ? masterDataResponse.NSTKCartCount[0].NSTKtotalCount : 0;
        //WW-1331 Accpet Transfer icon count - Nandhini L
        const uniqueOrderData = new Map();

        masterDataResponse.TransferCartCount.forEach((item) => {
            if (!uniqueOrderData.has(item.ORDER_NO)) {
                uniqueOrderData.set(item.ORDER_NO, item);
            }
        })

        const distinctCartData = Array.from(uniqueOrderData.values());
        let TransferCartCountRes = distinctCartData.length && distinctCartData.length > 0 ? distinctCartData.length : 0;

        if (this.state.hasReqApproval)
            requestorApprovalCountRes = masterDataResponse.RequestorApprovalCount.length > 0 ? masterDataResponse.RequestorApprovalCount[0].TOTAL_COUNT : 0;
        if (this.state.hasOrderApproval) {
            console.log("orderapproval", masterDataResponse.OrderApprovalCount)
            orderApprovalCountRes = masterDataResponse.OrderApprovalCount.length > 0 ? masterDataResponse.OrderApprovalCount[0].TOTAL_COUNT : 0;
        }
        console.log("FavPages", masterDataResponse.FavPages);
        let cartOrginalData = [];
        masterDataResponse.CartData = masterDataResponse.CartData.reverse();
        cartOrginalData = cartOrginalData.concat(masterDataResponse.CartData);
        console.log("cartData", cartOrginalData);
        //*****NEW****favitemcat*****(6/2/2021)****
        let favmenucat = masterDataResponse.FavMenu
        let favmenusub = masterDataResponse.FavSubMenu
        let catlen = 0;
        if (masterDataResponse.FavMenu) {
            if (masterDataResponse.FavMenu.length > 0) {
                catlen = masterDataResponse.FavMenu.length;
            }
        }
        let data = []
        data = masterDataResponse.CartData
        console.log('cartitems', data);
        let locfavmenucat = [];
        if (favmenucat) {
            if (favmenucat.length > 0) {
                favmenucat.forEach((value, index) => {
                    if (value.FavText == " " || value.FavText == "" || value.FavText == null || value.FavText == undefined || value.FavText == "UNCLASSIFIED") {
                        value.FavText = "UNCLASSIFIED"
                    }
                });
            }

            locfavmenucat = favmenucat.filter((v, i, a) => a.findIndex(t => (t.FavText === v.FavText)) === i)
        }
        console.log("locfavmenucat", locfavmenucat);
        console.log("favmenucat", favmenucat);
        localStorage.setItem('CartStorage', JSON.stringify(masterDataResponse.CartData));
        //localStorage.setItem('NSTKCartStorage', JSON.stringify(masterDataResponse.NSTKCartData));

        //*****END******************
        //*NEW*(1/6/2021)**REMOVED***
        //if (masterDataResponse.CartData.length > 5) {
        //    masterDataResponse.CartData.length = 5;
        //}
        //********END
        if (this._isMounted) {
            //$(`#${SDIConstants.SDILoader}`).addClass('hide');
            this.setState({
                notificationCount: notificationCountRes,
                cartCount: cartCountRes,
                requestorApprovalCount: requestorApprovalCountRes,
                orderApprovalCount: orderApprovalCountRes,
                favPages: masterDataResponse.FavPages,
                cartItems: masterDataResponse.CartData,
                FavItemCategory: locfavmenucat, FavItemSubMenu: favmenusub, favitemcatcount: catlen,
                //NSTKCartItems: masterDataResponse.NSTKCartData != undefined && masterDataResponse.NSTKCartData != null ? masterDataResponse.NSTKCartData : [], //WW-1325 -Vishwa S
                //NSTKCartCount: NSTKCartCountRes, //WW-1325 -Vishwa S
                TransferCartCount: TransferCartCountRes         //WW-1331 Accpet Transfer icon count - Nandhini L
            });

        }
        localStorage.setItem("requestorApprovalCount", requestorApprovalCountRes);
        this.changeRequestCount(false);
        //ww-643- search pikup [3/13/2023]-PAVITHRA R
        let pickUp = false
        let deliveryShipTo = false
        let delivery_optn = CookieService.getLocalStorageValues("Shipment_Method")
        let pick_up = localStorage.getItem("pickupcheck")
        if (delivery_optn != null || delivery_optn != undefined) {
            if (delivery_optn == true) {
                if (pick_up == null || pick_up == undefined || pick_up == "false") {
                    pickUp = false
                    deliveryShipTo = true
                }
                else {
                    pickUp = true
                    deliveryShipTo = false
                }
                this.setState({ pickupCheck: pickUp, deliveryShipTo: deliveryShipTo })


            }
        }
        console.log("catlen", catlen)
        let favOrdersArray = null;
        let favItemArray = null
        let favFlags = masterDataResponse.FavFlags;
        if (favFlags.length > 0) {
            favFlags = favFlags[0];
            if (this.state.hasFavOrder || favFlags.ORDER_FLAG != 0) {
                //if (favFlags.ORDER_FLAG != 0) {
                favOrdersArray = masterDataResponse.FavOrderdata;
                if (favOrdersArray.length > 0) {
                    if (favOrdersArray[0].data.length > 0) { //WW-866_PC_01 -Aparna 
                        favOrdersArray = JSON.parse(favOrdersArray[0].data);
                        console.log("Orderflag");
                        localStorage.setItem("SDIFavOrders", JSON.stringify(favOrdersArray));
                    }
                    else {
                        localStorage.setItem("SDIFavOrders", "");
                    }
                }
                //} else {
                //    console.log("cacheOrderflag");
                //    favOrdersArray = JSON.parse(localStorage.getItem("SDIFavOrders"));
                //}
                if (favOrdersArray) {
                    if (favOrdersArray.LineItemData) {
                        favOrdersArray.LineItemData.forEach((item, index) => {
                            item.checked = false;
                            let filteredItem = [];
                            if (favOrdersArray.LineItemImgData)
                                filteredItem = favOrdersArray.LineItemImgData.filter((x) => x.ORDER_NO == item.ORDER_NO && x.BUSINESS_UNIT_OM == item.BUSINESS_UNIT_OM && x.ISA_INTFC_LN == item.ISA_INTFC_LN);
                            if (filteredItem.length > 0) {
                                item.INV_ITEM_ID = filteredItem[0].ISA_ITEM;
                            }
                        });
                    }
                    if (this._isMounted) {
                        //$(`#${SDIConstants.SDILoader}`).addClass('hide');
                        // if (favOrdersArray.HeaderData != undefined) {
                        this.setState({
                            favorders: favOrdersArray.HeaderData,
                            favOrdersCount: favOrdersArray.TotalCount.length > 0 ? favOrdersArray.TotalCount[0].TOTAL_COUNT : 0,
                            favOrderLineItems: favOrdersArray.LineItemData,
                            favOrderLineItemImgs: favOrdersArray.LineItemImgData,
                            FavOrderInv: favOrdersArray.FavOrderInv //CPW-167_PC_12
                        });
                        //  }

                    }
                }
            } else {
                if (this._isMounted) {
                    //$(`#${SDIConstants.SDILoader}`).addClass('hide');
                    this.setState({
                        favorders: [],
                        favOrdersCount: 0,
                        favOrderLineItems: [],
                        favOrderLineItemImgs: [],
                        FavOrderInv: []
                    });
                }
            }
            if (this.state.hasFavItem || favFlags.ITEM_FLAG != 0) {
                //if (favFlags.ITEM_FLAG != 0) { // WW-488_PC_07 (9/12/2022) -Aparna
                favItemArray = masterDataResponse.FavItemData;
                if (favItemArray.length > 0) {
                    //WW-866_PC_01 -Aparna 
                    if (favItemArray[0].data.length > 0) {
                        favItemArray = JSON.parse(favItemArray[0].data);
                        localStorage.setItem("SDIFavItems", JSON.stringify(favItemArray));
                    } else {
                        localStorage.setItem("SDIFavItems", "");
                    }



                }
                //} else {
                //    favItemArray = JSON.parse(localStorage.getItem("SDIFavItems"));
                //};
                if (favItemArray) {
                    if (favItemArray.FavItemData) {
                        favItemArray.FavItemData.forEach((value, index) => {
                            value.checked = false;
                        });
                    } else {
                        favItemArray.FavItemData = [];
                    }
                    if (this._isMounted) {
                        //$(`#${SDIConstants.SDILoader}`).addClass('hide');
                        this.setState({
                            favitems: favItemArray.FavItemData,
                            favItemsCount: favItemArray.TotalCount.length > 0 ? favItemArray.TotalCount[0].TOTAL_COUNT : 0,
                            FavItemInv: favItemArray.FavItemInv
                        });
                    }
                }
            } else {
                if (this._isMounted) {
                    //$(`#${SDIConstants.SDILoader}`).addClass('hide');
                    this.setState({
                        favitems: [],
                        favItemsCount: 0,
                        FavItemInv: []
                    });
                }
            }
        } else {
            if (this.state.hasFavOrder || favFlags.ORDER_FLAG != 0) { // WW-488_PC_07 (9/12/2022) -Aparna
                favOrdersArray = JSON.parse(localStorage.getItem("SDIFavOrders"));
                if (favOrdersArray) {
                    if (favOrdersArray.LineItemData) {
                        favOrdersArray.LineItemData.forEach((item, index) => {
                            item.checked = false;
                            let filteredItem = [];
                            if (favOrdersArray.LineItemImgData)
                                filteredItem = favOrdersArray.LineItemImgData.filter((x) => x.ORDER_NO == item.ORDER_NO && x.BUSINESS_UNIT_OM == item.BUSINESS_UNIT_OM && x.ISA_INTFC_LN == item.ISA_INTFC_LN);
                            if (filteredItem.length > 0) {
                                item.INV_ITEM_ID = filteredItem[0].ISA_ITEM;
                            }
                        });
                    }
                    if (this._isMounted) {
                        //$(`#${SDIConstants.SDILoader}`).addClass('hide');
                        this.setState({
                            favorders: favOrdersArray.HeaderData,
                            favOrdersCount: favOrdersArray.TotalCount.length > 0 ? favOrdersArray.TotalCount[0].TOTAL_COUNT : 0,
                            favOrderLineItems: favOrdersArray.LineItemData,
                            favOrderLineItemImgs: favOrdersArray.LineItemImgData,
                            FavOrderInv: favOrdersArray.FavOrderInv
                        });
                    }
                }

            }
            if (this.state.hasFavItem) { // WW-488_PC_07 (9/12/2022) -Aparna
                favItemArray = JSON.parse(localStorage.getItem("SDIFavItems"));
                if (favItemArray) {
                    if (favItemArray.FavItemData) {
                        favItemArray.FavItemData.forEach((value, index) => {
                            value.checked = false;
                        });
                    } else {
                        favItemArray.FavItemData = [];
                    }
                    if (this._isMounted) {
                        //$(`#${SDIConstants.SDILoader}`).addClass('hide');
                        this.setState({
                            favitems: favItemArray.FavItemData,
                            favItemsCount: favItemArray.TotalCount.length > 0 ? favItemArray.TotalCount[0].TOTAL_COUNT : 0,
                            FavItemInv: favItemArray.FavItemInv
                        });
                    }

                }
            }
        }
        //Removing double click issue fix for loading problem in RMA WW-333  -Aparna
        //10/11/22 - WAL - Picking page load loader issue fix - Dhevanesam R 
        if (CookieService.getLocalStorageValues("Session_PageName") != null && CookieService.getLocalStorageValues("Session_PageName") != undefined) {
            //Loader issue in WW-388 -Priyanka d
            //Loader issue in WW-389 -Priyanka d and Item details
            let isPage = CookieService.getLocalStorageValues("IsProfilePageLoad");
            let a = CookieService.getLocalStorageValues("Session_PageName").toLowerCase();
            if (CookieService.getLocalStorageValues("IsProfilePageLoad") == true && CookieService.getLocalStorageValues("Session_PageName").toLowerCase() == '/profile') {
                //Don not close the loader if it is profile pageload
            }
            else if (CookieService.getLocalStorageValues("Session_PageName").toLowerCase() == window.location.pathname.toLowerCase() && window.location.pathname.toLowerCase() != "/searchresults" &&
                window.location.pathname.toLowerCase() != "/needapprove" && window.location.pathname.toLowerCase() != "/favorites" && window.location.pathname.toLowerCase() != "/favorder" && window.location.pathname.toLowerCase() != "/interactivediagram" && window.location.pathname.toLowerCase() != "/transselect"
                && window.location.pathname.toLowerCase() != "/punchout" && window.location.pathname.toLowerCase() != "/homepage" && window.location.pathname.toLowerCase() != "/itemdetailnew" && window.location.pathname.toLowerCase() != "/orderstatus2" && window.location.pathname.toLowerCase() != "/shoppingcart" && window.location.pathname.toLowerCase() != "/pickingassignto" && window.location.pathname.toLowerCase() != "supplierorderentry" && window.location.pathname.toLowerCase() != "/manualstockadj" && window.location.pathname.toLowerCase() != "/manageforms" && window.location.pathname.toLowerCase() != "/addforms"
                && window.location.pathname.toLowerCase() != "/addstockitems" && window.location.pathname.toLowerCase() != "/binlabelprinting" && window.location.pathname.toLowerCase() != "/reprintpackn1" && window.location.pathname.toLowerCase() != "/fedexshipping" && window.location.pathname.toLowerCase() != "/trackingnumberupd" && window.location.pathname.toLowerCase() != "/Equipments" && window.location.pathname.toLowerCase() != "/expedite" && window.location.pathname.toLowerCase() != "/stkissuescart" && window.location.pathname.toLowerCase() != "/bintobintransfer" && window.location.pathname.toLowerCase() != "/fieldinventoryworkbench"
                && window.location.pathname.toLowerCase() != "/mobileinventorymanagement") {
                //console.log("test", window.location.pathname.toLowerCase() )
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
            }
        }
        //WW-368_SuggestionCat_for_favItem_PC_01
        let favitmcat = []
        let locsugg = []
        let FavItemCatSubCat = []
        /*[05/04/22,Tile Not showing In PROD issue], Priyanka D */
        if (favItemArray != null) {
            if (favItemArray.FavItemData != null && favItemArray.FavItemData != undefined) {
                CookieService.updateLocalStorageValues("Fav_Item", favItemArray.FavItemData);
                FavItemCatSubCat = favItemArray.FavItemData.map(({ ISA_FAVS_CATEGORY, ISA_FAVS_SUBCATEGORY }) => ({ ISA_FAVS_CATEGORY, ISA_FAVS_SUBCATEGORY }))
                CookieService.updateLocalStorageValues("FavItem_Cat_SubCat", FavItemCatSubCat);
                locsugg = favItemArray.FavItemData.filter((v, i, a) => a.findIndex(t => (t.ISA_FAVS_CATEGORY.toUpperCase() === v.ISA_FAVS_CATEGORY.toUpperCase() && t.ISA_FAVS_CATEGORY != null && t.ISA_FAVS_CATEGORY != " ")) === i)
                console.log("locsugg", locsugg)
                CookieService.updateLocalStorageValues("Fav_Item_Cat", locsugg);
                console.log("Fav_Item_Cat locsugg", CookieService.getLocalStorageValues("Fav_Item_Cat"))
            }
            else {
                CookieService.updateLocalStorageValues("Fav_Item_Cat", favitmcat);
            }
        }
        console.log("CookieService", CookieService.getLocalStorageValues("Fav_Item_Cat"))
    };
    changeRequestCount = (flage) => {
        if (flage) {
            $('#request-loader').removeClass('d-none');
            $('#request-count').addClass('d-none');
        } else {
            $('#request-count').removeClass('d-none');
            $('#request-loader').addClass('d-none');
            let n = localStorage.getItem("requestorApprovalCount");
            let digit = n.toString().split('').length;
            console.log("r-digit", digit);
            if (digit == 1) {
                $('#request-count').removeClass('threedigit-count');
                $('#request-count').addClass('null-count');
            } else if (digit == 3) {
                $('#request-count').removeClass('null-count');
                $('#request-count').addClass('threedigit-count');
            } else {
                $('#request-count').removeClass('null-count');
                $('#request-count').removeClass('threedigit-count');
            }
            $('#request-count').text(localStorage.getItem("requestorApprovalCount"));
        }
    }
    /**
     * Reusable method for finding page level entitlement of the user
     */

    pageLevelEnt = (menu, pagePath) => {
        if (pagePath !== "/") {
            //pagePath = pagePath.substring(1) + ".aspx";
            return menu.filter((item) => item.ISA_NAVIGATIONURL.toLowerCase().indexOf(pagePath.toLowerCase()) >= 0).length > 0 ? true : false;
        }
    }
    megaMenuAssigment = (megaMenuResponse, megaMenuCategories) => {
        //debugger
        console.log("megaMenuCategories", megaMenuCategories);
        console.log("megaMenuResponse", megaMenuResponse);
        if (megaMenuCategories) {
            megaMenuCategories = megaMenuCategories.filter(
                function (x) {
                    return this.findIndex((y) => y.CATAGORY_ID == x.CATAGORY_ID) >= 0;
                },
                megaMenuResponse
            );
            this.setState({ megaMenuCategories: megaMenuCategories });
            return megaMenuCategories

        }
    };
    checkDefaultPages = (currentPagePath) => {
        //debugger
        let defaultPages = ["/itemdetailnew",
            "/approvequote",
            "/shoppingcart",
            "/testpage",
            "/underconstruction",
            "/accessdenied",
            "/usernotification",
            "/homepage",
            "/searchresults",
            "/favorites",
            "/favorder",
            "/suppliersuggestionpage",
            //"/pickingassignto",
            //"/cyclecount",
            //"/cyclecountrecon",
            //"/stockvaluerpt",
            //"/CycleCntReconRpt",
            //"/InsiteonlineSTKIS",
            ///*[05/06/22, PC_WW-243_03]Priyanka D*/
            //"/labelsbyloc",
            "/kenstanform",
            //"/ExpressPutawayLocation",
            //"/ManualStockAdj",
            ///*[2/24/22, PC_DP_02, Priyanka.D]*/
            //"/PutawayPickingLocations",
            "/enersysform",
            //"/fedexshipping",
            "/doorform",
            //"/refsitemaintenance",
            //"/advancedsupplierorderentry",
            ////9/21/22, Bug - 2659, To add fav item panel as default, Dhevanesam R]
            //"/favorites",
            //"/suppliersuggestionpage",
            ////[12/15/22], PC_WW-552_FE_3, Dhevanesam R
            "/forms",
            //"/manageforms",
            "/addforms",
            //"/trackingnumberupd",
            //"/interactivediagram/",
            "/buildversionhistory",
            //"/srcnoncatalog",
            //"/releasenotesmaintenance",
            "/addversioncomponent",
            "/profile",
            "/walmartrfqentry"
        ];
        let a = defaultPages.indexOf(currentPagePath.toLowerCase()) >= 0 ? true : false;
        return a;
    }
    /**
     * Reusable method for assigning menu response from API and from localStorage
     */
    //WW-703 Menu Revamping-Deepthi N H
    //WW-1229 Home tiles -Nandhini L
    menuAssigment = (menuResponse, userTiles) => {
        //debugger
        let currentPath = this.props.location.pathname;
        //currentPath = currentPath.indexOf("?") >= 0 ? currentPath.split("?")[0] : currentPath;
        console.log("menuResponse", menuResponse);
        let isPageExists = this.pageLevelEnt(menuResponse, currentPath);
        //WW-1229 Home tiles -Nandhini L
        let isHomeTileExists = this.pageLevelEnt(userTiles, currentPath);
        if (isPageExists || isHomeTileExists || this.checkDefaultPages(currentPath)) {
            let hasOrderStatusCheck = this.filterPage(menuResponse, "Order Status Report");
            let hasReqApprovalCheck = this.filterPage(menuResponse, "Requestor Approval");
            let hasOrderApprovalCheck = this.filterPage(menuResponse, "Approve Orders");
            if (this._isMounted) {
                this.setState({
                    hasFavItem: true, hasReqApproval: hasReqApprovalCheck,
                    hasOrderApproval: hasOrderApprovalCheck, hasFavOrder: true, hasOrderStatus: hasOrderStatusCheck
                });
            }
            CookieService.updateLocalStorageValues("hasReqApprovalCheck", hasReqApprovalCheck);
            CookieService.updateLocalStorageValues("hasOrderApprovalCheck", hasOrderApprovalCheck);
            CookieService.updateLocalStorageValues("hasOrderStatus", hasOrderStatusCheck);


            CookieService.updateLocalStorageValues("hasFavItemCheck", true);
            CookieService.updateLocalStorageValues("hasFavOrderCheck", true);
            //*NEW Menucal in masterBO added
            let masterBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
                Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
                WorkOrderPnchInA: CookieService.getLocalStorageValues("Session_WorkOrderPnchInA") ? CookieService.getLocalStorageValues("Session_WorkOrderPnchInA") : "",
                isRequestorApproval: hasReqApprovalCheck,
                isOrderApproval: hasOrderApprovalCheck,
                isFavItem: true,
                isFavOrder: true,//hasFavOrderCheck
                isFirstTime: isFirstTimeLoaded,//isFirstTimeLoaded
                Menucall: true,
                User_Type: CookieService.getLocalStorageValues("Session_USERTYPE") ? CookieService.getLocalStorageValues("Session_USERTYPE") : "",
                IsWeb: true,
                HOME_STORE: CookieService.getLocalStorageValues("HOME_STORE"), //CPW-167_PC_13
            };

            if (this._isMounted) {
                console.log("masterBO", masterBO);
                MenuAction.getMasterData(masterBO);
            }
        }
        else {
            this.props.history.push({
                pathname: "/accessdenied",
            });
        }

    }




    /**
     * MN_PC_33
     * This listner method will get the data of user menu,
     */
    assignUserMenu = () => {
        //debugger;
        let MenuData = [];
        let SuggData = [];
        let megaMenuList = [];
        let CatWithChild = [];
        let ParentWithChild = [];
        let WithoutParent = [];
        let PrivlegeList = [];
        let isHelpAccess = false;
        //WW-1229 Home tiles -Nandhini L
        let userTiles = [];
        let menuResponse = JSON.parse(MenuStore.userMenuData);
        //WW-1229 Home tiles -Nandhini L
        if (menuResponse.r_result_usertiles) {
            userTiles = menuResponse.r_result_tiles
        }
        if (menuResponse.UserMenu || userTiles) {
            if (menuResponse.UserMenu.length > 0 || userTiles.length > 0) {
                //WW-703 Menu Revamping-Deepthi N H
                MenuData = menuResponse.UserMenu;
                MenuData = MenuData.filter((x) => x.SITE_NAME.includes("W"));
                //WW-1229 Home tiles -Nandhini L
                userTiles = userTiles.filter((x) => x.SITE_NAME.includes("W"));
                PrivlegeList = MenuData;
                //WW-981/WW-1007 - As a Walmart Home Office Buyer, I want the Sourced Non-Catalog view to Indicate Unit and Extended Price, Standardized Mfg. Part #s and required Attachment - Deepthi N H
                let SDI_Emp = "";
                let User_Div = "";
                if (CookieService.getLocalStorageValues("Session_SDIEMP") != null && CookieService.getLocalStorageValues("Session_SDIEMP") != undefined) {
                    SDI_Emp = CookieService.getLocalStorageValues("Session_SDIEMP")
                }
                if (CookieService.getLocalStorageValues("Session_User_Division") != null && CookieService.getLocalStorageValues("Session_User_Division") != undefined) {
                    User_Div = CookieService.getLocalStorageValues("Session_User_Division")
                }
                MenuData = MenuData.filter((x) => x.ISA_IDENTIFIER != 1 && x.ISA_IDENTIFIER != 156 && x.ISA_IDENTIFIER != 162 && x.ISA_IDENTIFIER != 296 && x.ISA_IDENTIFIER != 298 && x.ISA_IDENTIFIER != 319 && x.ISA_IDENTIFIER != 320);
                CatWithChild = MenuData.filter((x) => x.ISA_CATEGORY_ID != null && x.ISA_CATEGORY_ID != "");
                megaMenuList = CatWithChild.filter((v, i, a) => a.findIndex(t => (t.ISA_CATEGORY_ID === v.ISA_CATEGORY_ID)) === i);
                megaMenuList.forEach((catVal, catInd) => {
                    ParentWithChild = CatWithChild.filter((x) => x.ISA_CATEGORY_ID == catVal.ISA_CATEGORY_ID && x.ISA_PARENT_IDENT != null && x.ISA_PARENT_IDENT != "");
                    WithoutParent = CatWithChild.filter((x) => x.ISA_CATEGORY_ID == catVal.ISA_CATEGORY_ID && (x.ISA_PARENT_IDENT == null || x.ISA_PARENT_IDENT == ""));
                    if (ParentWithChild.length > 0) {
                        ParentWithChild.forEach((parVal, parInd) => {
                            let parObj = {
                                value: parVal.ISA_PARENT_NAME,
                                label: parVal.ISA_PARENT_NAME
                            }
                            let ParPresent = SuggData.some((x) => x.label == parVal.ISA_PARENT_NAME);
                            if (SuggData.length == 0 || ParPresent == false) {
                                SuggData.push(parObj);
                            }

                            let childObj = {
                                value: parVal.ISA_IDENTIFIER_NAME,
                                label: parVal.ISA_IDENTIFIER_NAME
                            }
                            let childPresent = SuggData.some((x) => x.label == parVal.ISA_IDENTIFIER_NAME);
                            if (SuggData.length == 0 || childPresent == false) {
                                SuggData.push(childObj);
                            }
                        });
                    }
                    if (WithoutParent.length > 0) {
                        WithoutParent.forEach((parVal, parInd) => {
                            let parObj = {
                                value: parVal.ISA_IDENTIFIER_NAME,
                                label: parVal.ISA_IDENTIFIER_NAME
                            }
                            let ParPresent = SuggData.some((x) => x.label == parVal.ISA_PARENT_NAME);
                            if (SuggData.length == 0 || ParPresent == false) {
                                SuggData.push(parObj);
                            }
                        });
                    }
                });
                let DirectMenuItems = MenuData.filter((x) => x.ISA_CATEGORY_ID == null || x.ISA_CATEGORY_ID == "");
                DirectMenuItems.forEach((dirVal, dirInd) => {
                    if (dirVal.ISA_IDENTIFIER == 341 || dirVal.ISA_IDENTIFIER == 357) {
                        isHelpAccess = true;
                    }
                    else {
                        megaMenuList.push(dirVal);
                    }

                })
            }
        }
        //WW-1229 Home tiles -Nandhini L
        this.menuAssigment(MenuData, userTiles);
        localStorage.setItem("SDIMenu", JSON.stringify(menuResponse.UserMenu));
        localStorage.setItem("SDIHomeMenu", JSON.stringify(userTiles));
        //WW-1229 Home tiles -Nandhini L
        this.setState({ UserMenuData: MenuData, userTiles: userTiles, ActualMenuSugg: SuggData, megaMenuList: megaMenuList, PrivList: PrivlegeList, isHelpAccess: isHelpAccess });
        let lastversion = CookieService.getLocalStorageValues("lastVersion");
        let currentversion = CookieService.getLocalStorageValues("currentversion");
        let VersionArray = menuResponse.VersionTable;
        if (VersionArray != undefined) {
            if (VersionArray.length > 0) {
                let buildDate = VersionArray[0].ADD_DTTM;
                let date;
                let month;
                let year;
                let FullDate = new Date(buildDate);
                year = FullDate.getFullYear();
                month = FullDate.toLocaleString("default", { month: "long" });
                date = FullDate.getDate()
                buildDate = month + " " + date + ", " + year;
                let VersionName = "Web Version:" + VersionArray[0].VERSION_NO;
                CookieService.updateLocalStorageValues("VersionData", encodeURIComponent(JSON.stringify(VersionArray)));
                CookieService.updateLocalStorageValues("CurrentBuildDate", buildDate);
                CookieService.updateLocalStorageValues("CurrentBuildName", VersionName);
                this.setState({ VersionData: VersionArray, CurrentBuildDate: buildDate, CurrentBuildName: VersionName });
            }
        }
        if (lastversion != currentversion) {
            CookieService.updateLocalStorageValues("lastVersion", currentversion);
            //WW-1325 Nonstock cart Icon on Topnavigation bar -Vishwa S
            //CookieService.updateLocalStorageValues("NSTKCartIconAlert", true);
            //$(`#${SDIConstants.SDILoader}`).addClass('hide');
            //this.setState({ runTour: true })
            $('#BuildDetailsPopUp').modal('show');
        }

    }
    bindReleaseNotesTasks = () => {
        let locBuildTaskArray = this.state.VersionData;
        return locBuildTaskArray.map((value, index) => {
            return (<li>{value.TASK_TITLE}</li>)

        });
    }
    onClickWebVersion = (e) => {
        e.preventDefault();
        $('#hamburger-menu-container-background').removeClass('hmenu-opaque');
        $('#hamburger-menu-container').removeClass('showvisible');
        $('#BuildDetailsPopUp').modal('show');
    }
    closeReleaseNotes = () => {
        //WW-1325 Nonstock cart Icon on Topnavigation bar -Vishwa S
        //let NSTKCartIconAlert = CookieService.getLocalStorageValues("NSTKCartIconAlert");
        //if (NSTKCartIconAlert != undefined && NSTKCartIconAlert == true) {
        //    this.setState({ runTour: true }); 
        //}
        $('#BuildDetailsPopUp').modal('hide');
    };

    //WW-1325 Method to close the alert -Vishwa S
    //closeNSTKCartAlert = () => {
    //    CookieService.updateLocalStorageValues("NSTKCartIconAlert", false);
    //    this.setState({ runTour: false });
    //    $('#BuildDetailsPopUp').modal('show');
    //}
    onClickHistoryIcon = (e) => {
        e.preventDefault();
        $('#BuildDetailsPopUp').modal('hide');
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        this.props.history.push({
            pathname: `/buildversionhistory`,
        });
    };
    /**
    * Reusable method for checking whether the header link is present in user menu
    */

    filterPage = (menu, pageName) => {
        return menu.filter((item) => item.ISA_IDENTIFIER_NAME == pageName).length > 0 ? true : false;
    }
    /**
     * Reusable method for formation of Header menu
     */
    filterHeaderMenu = (menu) => {
        return menu.filter((item) => item.ISA_PARENT_IDENT == null && item.PROGRAMNAME.toLowerCase() != "my account");
    }
    /**
     * Reusable method for formation of child menu
     */
    filterChildMenu = (menu, currentMenu) => {
        return menu.filter((item) => item.ISA_PARENT_IDENT == currentMenu.ISA_IDENTIFIER);
    }
    /**
     * Reusable method for menu navigation
     */
    menuNavigation = (e, pagePath) => {
        //debugger
        //WW-703 Menu Revamping-Deepthi N H
        e.preventDefault();
        //if (menu.ISA_NAVIGATIONURL) {
        //    let lastindexofSlash = menu.ISA_NAVIGATIONURL.lastIndexOf("/");
        //    let subStr = menu.ISA_NAVIGATIONURL.substring(lastindexofSlash, menu.ISA_NAVIGATIONURL.length);
        //    subStr = subStr.split(".")[0];
        //    //PARMLIST
        //    let queryParams = menu.PARMLIST.toLowerCase() == "emptyparam" ? "" : menu.PARMLIST.indexOf("?") >= 0 ? menu.PARMLIST : "?" + menu.PARMLIST;
        //    let routePath = subStr + queryParams;
        //    routePath = availableMenu.findIndex(x => x.pageURL.toLowerCase().includes(subStr.toLowerCase())) >= 0 ? routePath : "/underconstruction";
        //    let queryParamindex = routePath.indexOf("?");
        //    let pagePath = routePath;
        //    let queryParamsVal = "";
        //    if (queryParamindex > 0) {
        //        pagePath = routePath.substring(0, queryParamindex);
        //        queryParamsVal = routePath.substring(queryParamindex, routePath.length);
        //    };
        //    this.props.history.push({
        //        pathname: pagePath,
        //        search: queryParamsVal
        //    });
        //}
        if (pagePath == "/interactivediagram") {
            pagePath = "/interactivediagram/"
        }
        if (pagePath.toLowerCase() == "/rfqentry") {
            this.noncatClick(e)
        }
        else if (pagePath.toLowerCase() == "/interactivediagram/") {
            this.interactiveClick(e)
        }
        else if (pagePath.toLowerCase() == "/equipments") {
            this.equipmentClick(e)
        }
        else {
            this.props.history.push({
                pathname: pagePath
            });
        }

    };
    /**
     * Reusable method for click of header link navigation
     */
    headerRedirect = (event, pageName) => {
        //debugger
        if (event) {
            event.preventDefault();
        }
        let pagePath = ""
        let queryParamindex = pageName.indexOf("?");
        if (pageName.toLowerCase() == "/suppliercallin") {
            pagePath = "/supplierorderentry"
        } else {
            pagePath = pageName;
        }
        if (pagePath == "/interactivediagram") {
            pagePath = "/interactivediagram/"
        }
        let queryParams = "";
        if (queryParamindex > 0) {
            pagePath = pageName.substring(0, queryParamindex);
            queryParams = pageName.substring(queryParamindex, pageName.length);
        };
        //WW-1229 Home tiles - Navigation 
        let hasPrivHomeTile = this.state.userTiles.filter((x) => {
            const normalizedURL = x.ISA_NAVIGATIONURL.toLowerCase();
            const normalizedPagePath = pagePath.toLowerCase();

            if (normalizedURL.includes('?cnt=-99')) {
                // Check only the path part (before `?`)
                const urlPathPart = normalizedURL.split('?')[0];
                return urlPathPart === normalizedPagePath.split('?')[0];
            } else {
                // Check full URL
                return normalizedURL === normalizedPagePath;
            }
        });

        //WW-1382_WW-1378 Item details and serch results navigation - Nandhini L
        if (pagePath == "/itemdetailnew") {
            let ItemDetailUrl = CookieService.getLocalStorageValues("itemDetailUrl") ? CookieService.getLocalStorageValues("itemDetailUrl") : "";
            let ItemDetailParam = ItemDetailUrl ? ItemDetailUrl.split("itemdetailnew?")[1] : ""

            this.props.history.push({
                pathname: `\itemdetailnew`,
                search: ItemDetailParam,
                state: { WO: localStorage.getItem("WONum"), ItemData: CookieService.getLocalStorageValues("ItemData"), Suggesstions: false, AlternateParts: CookieService.getLocalStorageValues("IsAltPart") }
            });
            return
        }
        else if (pagePath == "/searchresults") {
            let SearchUrl = CookieService.getLocalStorageValues("SearchUrl") ? CookieService.getLocalStorageValues("SearchUrl") : "";
            let SearchParam = SearchUrl.split("searchresults?")[1]

            this.props.history.push({
                pathname: `/searchresults`,
                search: SearchParam
            });
            return
        }

        let hasPriv = this.state.PrivList.filter((x) => x.ISA_NAVIGATIONURL.toLowerCase() == pagePath.toLowerCase());
        if (hasPriv.length > 0 || hasPrivHomeTile.length > 0 || pagePath.toLowerCase().includes("homepage") || pagePath.toLowerCase().includes("profile") || pagePath.toLowerCase().includes("usernotification") || pagePath.toLowerCase().includes("favorder") || pagePath.toLowerCase().includes("favorites") || pagePath.toLowerCase().includes("shoppingcart")) {
            this.props.history.push({
                pathname: pagePath,
                search: queryParams
            });
        }
        else if (pageName == "/RFQEntry" || pageName == "/WalmartRFQEntry") {
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            this.props.history.push({
                pathname: pagePath,
                search: queryParams
            });
        }

        else {
            this.props.history.push({
                pathname: "/accessdenied"
            });
        }


    };
    /**
        * HTML method for Hide/show of Parent/Child methods in Hamburgermenu
        */
    showChild = (event, parentMenu, arrowClass) => {
        event.preventDefault();
        if (arrowClass != "") {
            $(`#non-catalog`).show();
            this.bindChildElements(parentMenu)
        } else {
            this.menuNavigation(parentMenu);
        }
    };
    /**
    * Local method to bind the Fav pages in Hamburger menu
    */
    favPagelinkClick = (event) => {

        event.preventDefault();
        $(`#non-catalog`).show();
        let UserMenuData = this.state.UserMenuData;
        let childComponents = this.state.favPages.map((page, pageIndex) => {
            let isPageExists = this.pageLevelEnt(UserMenuData, page.PAGE_URL);
            if (isPageExists || this.checkDefaultPages(page.PAGE_URL)) {
                return (<a href="#" key={pageIndex} className="list-group-item list-group-item-action border-0" onClick={(event) => this.headerRedirect(event, page.PAGE_URL)}><Trans>{page.PAGE_TITLE}</Trans></a>);
            }
        });
        if (this._isMounted) {
            this.setState({ currentHeader: "Favorite Pages", childComponents: childComponents });
        }
    }
    /**
    * Local method to redirect the page in Hamburger child menu
    */
    childMenuClick = (event, childMenu) => {
        event.preventDefault();
        this.menuNavigation(childMenu);

    };
    /**
     * HTML method to Hide/show of Parent/Child methods in Hamburgermenu
     */
    showParent = (event) => {
        //debugger
        //WW-703 Menu Revamping-Deepthi N H
        let CurrentParent = this.state.currentHeader;
        if (CurrentParent.toUpperCase() == "FAVORITE PAGES") {
            event.preventDefault();
            $(`#non-catalog`).hide();
        }
        else {
            //WW-703 Menu Revamping-Deepthi N H
            let IsParent = this.state.UserMenuData.filter((x) => x.ISA_PARENT_NAME == CurrentParent);
            let IsCat = this.state.UserMenuData.filter((x) => x.ISA_CATEGORY_NAME == CurrentParent);
            if (IsParent.length > 0) {
                $(`#non-catalog`).show();
                this.showNewChild(event, IsParent[0].ISA_CATEGORY_ID, IsParent[0].ISA_CATEGORY_NAME);
                CurrentParent = IsParent[0].ISA_CATEGORY_NAME;
            }
            else if (IsCat.length > 0) {
                event.preventDefault();
                $(`#non-catalog`).hide();
            }
            this.setState({ currentHeader: CurrentParent, SelectedMenuName: "", SuggestionMenu: [] });
        }

    }
    //showParent = (event) => {
    //    //debugger
    //    let NotMainMenu = false;
    //    let ParentName = "";
    //    this.state.PrivSubMenuList.forEach((item, index) => {
    //        if (item.Label.trim().toUpperCase() == this.state.currentHeader.trim().toUpperCase()) {
    //            let ParentMenu = {
    //                CATAGORY_NAME: item.CATAGORY_NAME,
    //                CATAGORY_ID: item.Cat_ID
    //            }
    //            NotMainMenu = true;
    //            ParentName = item.CATAGORY_NAME;
    //            $(`#non-catalog`).show();
    //            this.bindChildNewElements(ParentMenu);
    //        }
    //        else {
    //            let child = item.Child;
    //            if (child != undefined) {
    //                if (child.length > 0) {
    //                    child.forEach((childitem, childindex) => {
    //                        if (childitem.label.trim().toUpperCase() == this.state.currentHeader.trim().toUpperCase()) {
    //                            let childmenu = item;
    //                            NotMainMenu = true;
    //                            ParentName = childitem.label;
    //                            $(`#non-catalog`).show();
    //                            this.showSubChild(event, childmenu);
    //                        }
    //                    })
    //                }
    //            }
    //        }
    //    })
    //    if (NotMainMenu == false) {
    //        event.preventDefault();
    //        $(`#non-catalog`).hide();
    //    }
    //    this.setState({ currentHeader: ParentName });
    //}
    /**
     * HTML method to Hide/show Hamburgermenu
     */
    hideHamBurger = () => {
        $('#hamburger-menu-container-background').removeClass('hmenu-opaque');
        $('#hamburger-menu-container').removeClass('showvisible');
        // WW-1336 - Relevant Type Ahead Suggestions - [3/14/2025] - K Surya 
        this.setState({
            SelectedMenuName: "", SuggestionMenu: []
        });
    }
    /**
     * MN_PC_36
     * This method binds the parent elements in Hamburgermenu
     */
    bindHeaderElements = () => {
        let hm = this.state.headerMenu.sort((a, b) => (a.PROGRAMNAME > b.PROGRAMNAME) ? 1 : -1)
        return hm.map((menu, index) => {
            let arrowClass = "";
            //******NEW***wal-158****
            //let menucheck = false;
            //availableMenu.map((x) => {
            //    if (menu.FULLPATH.includes(x.pageURL) ) {
            //        menucheck = true;
            //    }
            //})
            //availableMenu.filter((page) => page.pageURL == currentPath.toLowerCase())
            console.log("SDIConstants.availablePages.pageURL", SDIConstants.availablePages)
            console.log("heardermenu", this.state.headerMenu)
            //if (menucheck) { 
            //*****END******
            console.log("true case", menu.PROGRAMNAME)
            if (this.filterChildMenu(this.state.userMenu, menu).length > 0)
                arrowClass = "menu-arrow";

            return (<a href="#" key={index} className={`list-group-item list-group-item-action border-0 ${arrowClass}`} id={`${menu.PROGRAMNAME}id`} onClick={(event) => this.showChild(event, menu, arrowClass)} ><Trans>{menu.PROGRAMNAME}</Trans></a>)
            //}
        });

    }
    //menu_PC_03 (4/26/2022)-Aparna
    bindHeaderNewElements = () => {
        //WW-703 Menu Revamping-Deepthi N H
        const { t } = this.props;
        //WW-703 Menu Revamping-Deepthi N H
        return this.state.megaMenuList.map((header, headerIndex) => {

            return (<>{header.ISA_CATEGORY_ID != null && header.ISA_CATEGORY_ID != "" ? <a href="#" key={headerIndex} className={`list-group-item list-group-item-action border-0 menu-arrow`} id={`${header.ISA_CATEGORY_NAME}id`} onClick={(event) => this.showNewChild(event, header.ISA_CATEGORY_ID, header.ISA_CATEGORY_NAME)} ><Trans>{header.ISA_CATEGORY_NAME}</Trans></a> :
                <a href="#" key={headerIndex} id={`${header.ISA_IDENTIFIER_NAME}id`} className="list-group-item list-group-item-action border-0 " onClick={(e) => this.menuNavigation(e, header.ISA_NAVIGATIONURL)} ><Trans>{header.ISA_IDENTIFIER_NAME}</Trans></a>}

            </>)

        });
    }
    //menu_PC_04 (4/26/2022)-Aparna
    showNewChild = (event, Cat_ID, Cat_Name) => {
        //debugger
        event.preventDefault();
        $(`#non-catalog`).show();
        this.bindChildNewElements(Cat_ID, Cat_Name);

    };
    //menu_PC_06 (4/26/2022)-Aparna
    newSubHeader = (menu, currentMenu) => {
        return menu.filter((item) => item.CATAGORY_ID == currentMenu.CATAGORY_ID);
    }
    filterChildNewMenu = (menu, currentMenu) => {
        return menu.filter((item) => item.ISA_PARENT_IDENT == currentMenu.ISA_IDENTIFIER);
    }
    bindChildNewElements = (Cat_ID, Cat_Name) => {
        //debugger;
        let MenuData = this.state.UserMenuData;
        let subParents = MenuData.filter((x) => x.ISA_CATEGORY_ID == Cat_ID);
        let ParentsWithChild = [];
        //let ParentsWithChild = MenuData.filter((x) => x.ISA_CATEGORY_ID == Cat_ID && x.ISA_PARENT_IDENT != null && x.ISA_PARENT_IDENT != "");
        //let WithoutParent = MenuData.filter((x) => x.ISA_CATEGORY_ID == Cat_ID && (x.ISA_PARENT_IDENT == null || x.ISA_PARENT_IDENT == ""));
        //ParentsWithChild = ParentsWithChild.filter((v, i, a) => a.findIndex(t => (t.ISA_PARENT_IDENT === v.ISA_PARENT_IDENT)) === i);
        //WW-703 Menu Revamping-Deepthi N H
        let childComponents;
        childComponents = subParents.map((parval, parInd) => {
            let IsParent = subParents.filter((x) => x.ISA_PARENT_IDENT == parval.ISA_PARENT_IDENT && x.ISA_PARENT_IDENT != null);
            if (IsParent.length > 0) {
                if (!ParentsWithChild.includes(parval.ISA_PARENT_NAME) || ParentsWithChild.length == 0) {
                    ParentsWithChild.push(parval.ISA_PARENT_NAME);
                    return (<a href="#" key={parInd} className="list-group-item list-group-item-action border-0 menu-arrow" id={`${parval.ISA_PARENT_NAME}id`} onClick={(event) => this.showSubChild(event, parval.ISA_PARENT_IDENT, parval.ISA_PARENT_NAME)} ><Trans>{parval.ISA_PARENT_NAME}</Trans></a>);
                }
            }
            else {
                return (<a href="#" key={parInd} className="list-group-item list-group-item-action border-0 " id={`${parval.ISA_IDENTIFIER_NAME}id`} onClick={(e) => this.menuNavigation(e, parval.ISA_NAVIGATIONURL)} ><Trans>{parval.ISA_IDENTIFIER_NAME}</Trans></a>);
            }

        });

        if (this._isMounted) {
            this.setState({ currentHeader: Cat_Name, childComponents: childComponents });
        }
    }
    ////menu_PC_05 (4/26/2022)-Aparna
    //bindChildNewElements = (Cat_ID) => {
    //    //debugger
    //    let childMenuItems = this.newSubHeader(this.state.userMenu, parentMenu);
    //    console.log("childMenuItems", childMenuItems);
    //    console.log("parentMenu", parentMenu);
    //    //***NEW****wal-158*****
    //    //let submenuChild = filterChildNewMenu(this.state.userMenu,)
    //    //*******END********
    //    let childComponents
    //    let submenu = this.state.PrivSubMenuList.filter((x) => x.Cat_ID == parentMenu.CATAGORY_ID)
    //    console.log("headerMenu", this.state.headerMenu)
    //    if (submenu.length > 0) {
    //        childComponents = submenu.map((childMenu, childindex) => {
    //            let arrow = "menu-arrow"
    //            if (childMenu.IsParent) {
    //                let child = this.state.headerMenu.filter((x) => x.CATAGORY_ID == childMenu.Cat_ID && childMenu.Cat_ID != null && childMenu.IsParent == true && x.ISA_IDENTIFIER == childMenu.ParentID)
    //                console.log("child", child)
    //                let bo = {}
    //                bo = child[0]
    //                /*[05/12/22,WW-387-ID for UI elements, Priyanka D */
    //                return (<a href="#" key={childindex} className="list-group-item list-group-item-action border-0 " id={`${childMenu.Label}id`} onClick={(event) => this.showChild(event, bo, "")} ><Trans>{childMenu.Label}</Trans></a>);
    //            }
    //            else {
    //                /*[05/12/22,WW-387-ID for UI elements, Priyanka D */
    //                return (<a href="#" key={childindex} className="list-group-item list-group-item-action border-0 menu-arrow" id={`${childMenu.Label}id`} onClick={(event) => this.showSubChild(event, childMenu)} ><Trans>{childMenu.Label}</Trans></a>);

    //            }


    //        });
    //    }
    //    else {
    //        childComponents = childMenuItems.map((childMenu, childindex) => {
    //            let subMenu = false
    //            if (parentMenu.CATAGORY_NAME != "User profile") {
    //                if ((childMenu.PROGRAMNAME == "Replenish Review" || childMenu.PROGRAMNAME == "Product Replenishment" || childMenu.PROGRAMNAME == "Add Stock Items" ||
    //                    childMenu.PROGRAMNAME == "Manual Stock Adjustment" || childMenu.PROGRAMNAME == "Cycle Count Analysis" || childMenu.PROGRAMNAME == "Stock Value Report" ||
    //                    childMenu.PROGRAMNAME == "Stock Issue Report" || childMenu.PROGRAMNAME == "Transaction Report" || childMenu.PROGRAMNAME == "Receiving Report" ||
    //                    childMenu.PROGRAMNAME == "Stock Value Report" || childMenu.PROGRAMNAME == "Cycle Count Analysis" ||
    //                    childMenu.PROGRAMNAME == "Open POs" || childMenu.PROGRAMNAME == "RTV" || childMenu.PROGRAMNAME == "RMA" || childMenu.PROGRAMNAME == "Labels by Location" ||
    //                    childMenu.PROGRAMNAME == "Cycle Count Reconciliation" || childMenu.PROGRAMNAME == "Default Putaway Locations" || childMenu.PROGRAMNAME == "Item Holds" ||
    //                    childMenu.PROGRAMNAME == "Bin-to-Bin Transfer" || childMenu.PROGRAMNAME == "Material Storage Locations" || childMenu.PROGRAMNAME == "Expedite PO - Update" ||
    //                    childMenu.PROGRAMNAME == "SDI ASN Entry" || childMenu.PROGRAMNAME == "Reprint Packing" || childMenu.PROGRAMNAME == "Express Putaway" || childMenu.PROGRAMNAME == "Edit User Information")) {
    //                    subMenu = true;
    //                }
    //                //else if (parentMenu.PROGRAMNAME != "RFQ Status" && parentMenu.PROGRAMNAME != "PO Status" && parentMenu.PROGRAMNAME != "Active Users - SDI/Customers")
    //            }
    //            else {
    //                if ((childMenu.PROGRAMNAME != "Active Users - SDI/Customers")) {
    //                    subMenu = true;
    //                }
    //            }
    //            if (subMenu) {
    //                return (<a href="#" key={childindex} className="list-group-item list-group-item-action border-0" id={`${childMenu.PROGRAMNAME}id`} onClick={(event) => this.childMenuClick(event, childMenu)}><Trans>{childMenu.PROGRAMNAME}</Trans></a>
    //                );
    //            }

    //        });
    //    }

    //    //if (parentMenu.PROGRAMNAME == "Inventory") {
    //    //    return (<a href="#" className="list-group-item list-group-item-action border-0" onClick={(event) => this.headerRedirect(event, "/cyclecount")} >Cycle Counting</a>)
    //    //}
    //    if (this._isMounted) {
    //        this.setState({ currentHeader: parentMenu.CATAGORY_NAME, childComponents: childComponents });
    //    }
    //}
    //menu_PC_07 (4/26/2022)-Aparna
    showSubChild = (event, Par_ID, Par_Name) => {
        if (event.preventDefault) {
            event.preventDefault();
        }
        let childComponents;
        let childList = this.state.UserMenuData.filter((x) => x.ISA_PARENT_IDENT == Par_ID);
        if (childList.length > 0) {
            childComponents = childList.map((childVal, childInd) => {
                return (<a href="#" key={childInd} className="list-group-item list-group-item-action border-0 " id={`${childVal.ISA_IDENTIFIER_NAME}id`} onClick={(e) => this.menuNavigation(e, childVal.ISA_NAVIGATIONURL)} ><Trans>{childVal.ISA_IDENTIFIER_NAME}</Trans></a>);
            });
        }
        if (this._isMounted) {
            this.setState({ currentHeader: Par_Name, childComponents: childComponents });
        }
    };
    //showSubChild = (event, Par_ID,Par_Name) => {
    //    //debugger
    //    event.preventDefault();
    //    let childComponents
    //    let subchildmenu = this.state.PrivSubMenuList.filter((x) => x.Cat_ID == parentMenu.Cat_ID && x.Label == parentMenu.Label && x.IsParent == false)
    //    console.log("headerMenu", this.state.headerMenu)
    //    let child
    //    if (subchildmenu.length > 0) {
    //        childComponents = subchildmenu[0].Child.map((childMenu, childindex) => {


    //            child = this.state.userMenu.filter((x) => x.ISA_IDENTIFIER == childMenu.ID)
    //            console.log("child", child)
    //            let bo = {}
    //            bo = child[0]
    //            /*[05/12/22,WW-387-ID for UI elements, Priyanka D */
    //            return (<a href="#" key={childindex} className="list-group-item list-group-item-action border-0 " id={`${childMenu.label}id`} onClick={(event) => this.showChild(event, bo, "")} ><Trans>{childMenu.label}</Trans></a>);
    //        });

    //    }


    //    //if (parentMenu.PROGRAMNAME == "Inventory") {
    //    //    return (<a href="#" className="list-group-item list-group-item-action border-0" onClick={(event) => this.headerRedirect(event, "/cyclecount")} >Cycle Counting</a>)
    //    //}
    //    if (this._isMounted) {
    //        this.setState({ currentHeader: parentMenu.Label, childComponents: childComponents });
    //    }
    //}
    //WW-394 To Add Search In SDIZ Menu - Deepthi
    MenuSearchClick = (event) => {
        //debugger
        let MenuName = event;
        //WW-703 Menu Revamping-Deepthi N H
        let MenuData = this.state.UserMenuData;
        let IsParent = MenuData.filter((x) => x.ISA_PARENT_NAME ? x.ISA_PARENT_NAME.toLowerCase() == MenuName.toLowerCase() : x.ISA_PARENT_NAME == MenuName);
        let IsChild = MenuData.filter((x) => x.ISA_IDENTIFIER_NAME ? x.ISA_IDENTIFIER_NAME.toLowerCase() == MenuName.toLowerCase() : x.ISA_IDENTIFIER_NAME == MenuName);
        if (IsParent.length > 0) {
            $(`#non-catalog`).show();
            let catName = IsParent[0].ISA_CATEGORY_NAME;
            let catId = IsParent[0].ISA_CATEGORY_ID;
            this.bindChildNewElements(catId, catName);
        }
        if (IsChild.length > 0) {
            if (IsChild[0].ISA_PARENT_IDENT != null && IsChild[0].ISA_PARENT_IDENT != "") {
                $(`#non-catalog`).show();
                let parName = IsChild[0].ISA_PARENT_NAME;
                let parID = IsChild[0].ISA_PARENT_IDENT;
                this.showSubChild(event, parID, parName);
            }
            else {
                $(`#non-catalog`).show();
                let catName = IsChild[0].ISA_CATEGORY_NAME;
                let catId = IsChild[0].ISA_CATEGORY_ID;
                this.bindChildNewElements(catId, catName);
            }
        }

    }
    MenuSearchKeyPress = (event) => {
        if (event.keyCode == 13) {
            this.MenuSearchClick(this.state.SelectedMenuName);
        };
    }
    /**
     * 
     * MN_PC_36
     * This method binds the child elements in Hamburgermenu 
     */
    bindChildElements = (parentMenu) => {
        //debugger
        let childMenuItems = this.filterChildMenu(this.state.userMenu, parentMenu);
        console.log("childMenuItems", childMenuItems);
        console.log("parentMenu", parentMenu);
        //***NEW****wal-158*****
        if (parentMenu.PROGRAMNAME == "Order Status") {
            childMenuItems = childMenuItems.filter((x) => x.PROGRAMNAME != "RFQ Status" && x.PROGRAMNAME != "PO Status")
        }
        if (parentMenu.PROGRAMNAME == "User Profile") {
            childMenuItems = childMenuItems.filter((x) => x.PROGRAMNAME != "Active Users - SDI/Customers")
        }
        if (parentMenu.PROGRAMNAME == "SDiMS Online") {
            childMenuItems = childMenuItems.filter((x) => x.PROGRAMNAME == "Replenish Review" || x.PROGRAMNAME == "Product Replenishment")
        }
        if (parentMenu.PROGRAMNAME == "Stock Items") {
            childMenuItems = childMenuItems.filter((x) => x.PROGRAMNAME == "Add Stock Items" || x.PROGRAMNAME == "Manual Stock Adjustment")
        }
        if (parentMenu.PROGRAMNAME == "Reports") {
            childMenuItems = childMenuItems.filter((x) => x.PROGRAMNAME == "Cycle Count Analysis" || x.PROGRAMNAME == "Stock Value Report" || x.PROGRAMNAME == "Stock Issue Report" || x.PROGRAMNAME == "Transaction Report" || x.PROGRAMNAME == "Receiving Report" || x.PROGRAMNAME == "Open POs") //menu_PC_02 -Aparna
        }
        if (parentMenu.PROGRAMNAME == "Receiving") {
            childMenuItems = childMenuItems.filter((x) => x.PROGRAMNAME == "RTV")
        }

        /**
         * adding cycle count reconcilation in inventory menu(9/7/2021)
         * */
        if (parentMenu.PROGRAMNAME == "Inventory") {
            /*[2/24/22, PC_DP_02, Priyanka.D]*/
            //[1/20/22, PC_IH_04, WW-320, Dhevanesam R]
            childMenuItems = childMenuItems.filter((x) => x.PROGRAMNAME == "RMA" || x.PROGRAMNAME == "Cycle Count Reconciliation" || x.PROGRAMNAME == "Default Putaway Locations" || x.PROGRAMNAME == "Item Holds" || x.PROGRAMNAME == "Bin-to-Bin Transfer" || x.PROGRAMNAME == "Material Storage Locations" || x.PROGRAMNAME == "Labels by Location") //BTB_PC_02 - Deepthi N H
            //childMenuItems = childMenuItems.filter((x) => x.PROGRAMNAME == "Cycle Count Reconciliation")
        }
        if (parentMenu.PROGRAMNAME == "SDI Utilities") {
            childMenuItems = childMenuItems.filter((x) => x.PROGRAMNAME == "PO Workbench" || x.PROGRAMNAME == "SDI ASN Entry" || x.PROGRAMNAME == "Reprint Packing")
            //childMenuItems = childMenuItems.filter((x) => x.PROGRAMNAME == "Cycle Count Reconciliation")
        }
        if (parentMenu.PROGRAMNAME == "Beta Menu") {
            childMenuItems = childMenuItems.filter((x) => x.PROGRAMNAME == "Express Putaway")
        }
        //*******END********
        let childComponents = childMenuItems.map((childMenu, childindex) => {
            return (<a href="#" key={childindex} className="list-group-item list-group-item-action border-0" id={`${childMenu.PROGRAMNAME}id`} onClick={(event) => this.childMenuClick(event, childMenu)}><Trans>{childMenu.PROGRAMNAME}</Trans></a>
            );
        });
        //if (parentMenu.PROGRAMNAME == "Inventory") {
        //    return (<a href="#" className="list-group-item list-group-item-action border-0" onClick={(event) => this.headerRedirect(event, "/cyclecount")} >Cycle Counting</a>)
        //}
        if (this._isMounted) {
            this.setState({ currentHeader: parentMenu.PROGRAMNAME, childComponents: childComponents });
        }
    }
    /**
     * MN_PC_50
     * This method binds the Favorite pages
     */
    bindFavPages = () => {
        // Bind fav pages when it have the privilege - Nandhini L
        let UserMenuData = this.state.UserMenuData;

        return this.state.favPages.map((page, index) => {
            let isPageExists = this.pageLevelEnt(UserMenuData, page.PAGE_URL);
            if (isPageExists || this.checkDefaultPages(page.PAGE_URL)) {
                return (
                    <React.Fragment key={index}>
                        <a id={`FavPage-${index}`} href="#" className="list-group-item list-group-item-action border-0 py-1 pl-0" onClick={(event) => this.headerRedirect(event, page.PAGE_URL)}>
                            <span>
                                <img className="custom-fav-icon" src="/Images/favorite.svg" alt="favorite icon" />
                            </span>
                            <Trans>{page.PAGE_TITLE}</Trans>
                        </a>
                    </React.Fragment>
                )
            }
            return null
        })
    };
    /**
     * MN_PC_31
     * This method calls the action method to add
     * Favorite items in cart
     */
    CoreChargeProceedClick = (e) => {
        $('#CoreChargePopUpFav').modal('hide');
        this.setState({ IskitCoreDisplay: false });
        let IsCoreCheck = true;
        this.addFavItemsToCart(IsCoreCheck)

    }

    handleEquipmentYes = () => {
        $('#MenuMixedOrderConfirmPopup').modal('hide');
        cartDelete = true;
        if (mixCartChkFromFavOrder == true) {
            this.addFavOrderItemsToCart(this.state.ORDER_NO);
        } else {
            this.addFavItemsToCart(this.state.IsCoreCheck);
        }
    };

    handleEquipmentNo = () => {
        $('#MenuMixedOrderConfirmPopup').modal('hide');
        cartDelete = false;
    };

    addFavItemsToCart = (IsCoreCheck) => {
        //debugger
        let cartcontain = false;
        let FilteredSelect = [];
        let isalreadyExist = false;
        let cartcontaincount = 0;

        let itemsSelected = this.state.favitems.filter((fav) => fav.checked == true);
        if (itemsSelected.length > 0) {
            // pc-676-152 to 161 equipmentparts mixed cart restriction S.Sanjay11/29/2024
            let cartItems = JSON.parse(localStorage.getItem('CartStorage')) || [];

            if (cartItems != undefined && cartItems != null && cartItems.length > 0) {
                let hasEquipmentItem = cartItems.filter(item => item.ISA_WBS_ELMNT === 'Equipment');
                let hasQuoteItem = cartItems.filter(item => item.ISA_QUOTE_REF && item.ISA_QUOTE_REF.startsWith('WQ'));
                if (!cartDelete && hasEquipmentItem != undefined && hasEquipmentItem != null && hasEquipmentItem.length > 0) {
                    mixCartChkFromFavOrder = false;
                    $('#MenuMixedOrderConfirmPopup').modal('show');
                    this.setState({ IsCoreCheck: IsCoreCheck, cartConfirmationPopupTxt: "Adding an item will remove the equipment items in your shopping cart. Do you want to proceed with this change?" });
                    return;
                }
                else if (!cartDelete && hasQuoteItem != undefined && hasQuoteItem != null && hasQuoteItem.length > 0) { //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
                    mixCartChkFromFavOrder = false;
                    $('#MenuMixedOrderConfirmPopup').modal('show');
                    this.setState({ IsCoreCheck: IsCoreCheck, cartConfirmationPopupTxt: "Adding an item will remove the quote items in your shopping cart. Do you want to proceed with this change?" });
                    return;
                }
            }

            let itemsToAdd = [];
            let corecharge = false

            itemsSelected.forEach((value) => {

                if (value.KIT_ITEMS == " " || value.KIT_ITEMS == null || value.KIT_ITEMS == undefined) {
                    if (value.CORECHARGES == "CORE") {
                        corecharge = true
                    }
                    itemsToAdd.push({
                        ItemID: value.ISA_CP_ITEM_ID,
                        //MFG: locarr.MANUFACTURER.replaceAll('&', '&amp;'),// BUG 2242 replaced '&, &amp' (06/16/2022)-Pavithra R
                        MFGPartNum: value.CLIENT_MFG_PART,
                        SupplierID: value.SUPPLIER_ID,
                        Manufacturer: value.MANUFACTURER,
                        SupplierPartNo: value.ISA_CP_ITEM_ID,
                        Quantity: 1,//eachfilter.QTY_REQUESTED,// WW-295 removeing quantity field (12/15/2021)-Aparna
                        IsKit: false,



                    });
                }
                else if (value.KIT_ITEMS != " " && value.KIT_ITEMS != null && value.KIT_ITEMS != undefined) {


                    let Kit_Components = JSON.parse(value.KIT_ITEMS)
                    let CoreKIT = Kit_Components.filter((item, index) => item.IsCore == true);
                    if (CoreKIT.length > 0) {
                        corecharge = true
                    }

                    Kit_Components.forEach((value) => {
                        itemsToAdd.push({
                            ItemID: value.SupplierPartNumber,
                            MFGPartNum: "",
                            SupplierID: value.SupplierID,
                            Manufacturer: "",
                            SupplierPartNo: value.SupplierPartNumber,
                            Quantity: value.MiniumOrderQty,
                            IsKit: true

                        });
                    });
                }

                //   itemsToAdd.push({ ItemID: value.ISA_CP_ITEM_ID, SupplierPartNo: value.ISA_CP_ITEM_ID, Manufacturer: value.MANUFACTURER, MFGPartNum: value.CLIENT_MFG_PART, SupplierID: value.SUPPLIER_ID, Quantity: 1 });

            });
            if (corecharge == true && IsCoreCheck == false) {
                $('#CoreChargePopUpFavMenu').modal('show');
                return
            }
            ////Minimum Order Quantity Change - Not to Add Items which is already there in the Cart - Deepthi
            //let cartstorage = []
            //if (localStorage.getItem("CartStorage") != null) {
            //    cartstorage = JSON.parse(localStorage.getItem("CartStorage"));
            //}
            //if (cartstorage.length > 0) {
            //    let AlertItemID = []
            //    cartstorage.map((x) => {
            //        let ind = 0;

            //        if (itemsSelected.length > 0) {
            //            itemsSelected.map((z) => {
            //                if (x.Itemid.toLowerCase() == z.ISA_CP_ITEM_ID.toLowerCase() && x.Manufacturer.toLowerCase() == z.MANUFACTURER.toLowerCase() && x.Manufacturerpartnumber.toLowerCase() == z.CLIENT_MFG_PART.toLowerCase()) {

            //                    AlertItemID.push (x.Itemid )
            //                    //alert(AlertMsg);
            //                    //isalreadyExist = true;

            //                    ind = itemsSelected.findIndex(y => x.Itemid.toLowerCase() == y.ISA_CP_ITEM_ID.toLowerCase() && x.Manufacturer.toLowerCase() == y.MANUFACTURER.toLowerCase() && x.Manufacturerpartnumber.toLowerCase() == y.CLIENT_MFG_PART.toLowerCase());
            //                    if (ind != -1) {
            //                        itemsSelected.splice(ind, 1)
            //                        itemsToAdd.splice(ind, 1)
            //                    }
            //                }

            //            })

            //        }


            //    })
            //    if (AlertItemID.length != 0) {
            //        if (AlertItemID.length == 1) {
            //            swal({
            //                allowOutsideClick: false,
            //                closeOnClickOutside: false,
            //                text: "Item " + AlertItemID + " Is Already In Cart"
            //            });

            //        } else if (AlertItemID.length > 0) {
            //            swal({
            //                allowOutsideClick: false,
            //                closeOnClickOutside: false,
            //                text: "Items " + AlertItemID + " Is Already In Cart"
            //            });

            //        }
            //    }
            //}
            //if (cartstorage.length > 0) {
            //    cartstorage.map((x) => {
            //        let ind = itemsSelected.findIndex(y => x.Itemid == y.ISA_CP_ITEM_ID && x.Manufacturer == y.MFG && x.Manufacturerpartnumber == y.MFGPartnum);
            //        if (ind != -1) {
            //            itemsSelected.splice(ind, 1)
            //        }

            //    })
            //}
            //--------------------------&& !isalreadyExist-------------------/Minimum Order Quantity Change - Not to Add Items which is already there in the Cart - Deepthi------------------------------------------------
            console.log("itemsSelected", itemsSelected)
            if (itemsSelected.length > 0) {
                let addFavItemsBO = {
                    Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                    Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                    Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
                    Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
                    LineItems: itemsToAdd,
                    Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
                    Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
                    Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
                    Session_PRODVIEW: CookieService.getLocalStorageValues("Session_PRODVIEW"),
                    Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
                    Session_SDICAT: CookieService.getLocalStorageValues("Session_SDICAT"),
                    Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
                    Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
                    Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
                    Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
                    Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
                    Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
                    Session_CplusDbSQL: CookieService.getLocalStorageValues("Session_CplusDbSQL"),
                    Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"),
                    Session_CARTTAXEXMPTFLAG: CookieService.getLocalStorageValues("Session_CARTTAXEXMPTFLAG"),
                    Session_ZEUSNOCATALOGSITE: CookieService.getLocalStorageValues("Session_ZEUSNOCATALOGSITE"),
                    Session_ZEUS_SITE: CookieService.getLocalStorageValues("Session_ZEUS_SITE"),
                    /*[12/24/21, PC_SC_20], Priyanka D//Passing the Location value */
                    Location: CookieService.getLocalStorageValues("Session_WO_STATE") != null ? CookieService.getLocalStorageValues("Session_WO_STATE") : CookieService.getLocalStorageValues("Session_STATE") != null ? CookieService.getLocalStorageValues("Session_STATE") : "", //WW-1231 WO State Restriction -Vishwa S
                    Session_ID: CookieService.getLocalStorageValues("Session_ID"),//WW-390_PC_09 (4/20/2022)-Aparna
                    //[1/20/23, WW-542_PC_20, Dhevanesam R]
                    ShipToID: CookieService.getLocalStorageValues("HOME_STORE") != null && CookieService.getLocalStorageValues("HOME_STORE") != undefined && CookieService.getLocalStorageValues("HOME_STORE") != "" ? CookieService.getLocalStorageValues("HOME_STORE") : " ",
                    Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
                    SOURCE: "WEB",
                    Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"), //pc-676-152 to 161 equipmentparts mixed cart restriction S.Sanjay11/29/2024
                    EquipmentDelete: cartDelete,
                    Interactive: false
                };
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                MenuAction.addFavItemsTocart(addFavItemsBO);
            }

        }

    };
    /**
    * MN_PC_31
    * This method calls the action method to add
    * Favorite order line items in cart
    */
    addFavOrderItemsToCart = (ORDER_NO) => {
        let itemsSelected = this.state.favOrderLineItems.filter((favOrder) => favOrder.checked == true && favOrder.ORDER_NO == ORDER_NO);
        let itemsToAdd = [];
        if (itemsSelected.length > 0) {
            //pc-676-152 to 161 equipmentparts mixed cart restriction S.Sanjay11/29/2024
            let cartItems = JSON.parse(localStorage.getItem('CartStorage')) || [];
            if (cartItems != undefined && cartItems != null && cartItems.length > 0) {
                let hasEquipmentItem = cartItems.filter(item => item.ISA_WBS_ELMNT === 'Equipment');
                let hasQuoteItem = cartItems.filter(item => item.ISA_QUOTE_REF && item.ISA_QUOTE_REF.startsWith('WQ'));
                if (!cartDelete && hasEquipmentItem != undefined && hasEquipmentItem != null && hasEquipmentItem.length > 0) {
                    mixCartChkFromFavOrder = true;
                    $('#MenuMixedOrderConfirmPopup').modal('show');
                    this.setState({ ORDER_NO: ORDER_NO, cartConfirmationPopupTxt: "Adding an item will remove the equipment items in your shopping cart. Do you want to proceed with this change?" });
                    return;
                }
                else if (!cartDelete && hasQuoteItem != undefined && hasQuoteItem != null && hasQuoteItem.length > 0) { //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
                    mixCartChkFromFavOrder = true;
                    $('#MenuMixedOrderConfirmPopup').modal('show');
                    this.setState({ ORDER_NO: ORDER_NO, cartConfirmationPopupTxt: "Adding an item will remove the quote items in your shopping cart. Do you want to proceed with this change?" });
                    return;
                }
            }

            itemsSelected.forEach((value) => {
                itemsToAdd.push({
                    Order_Number: value.ORDER_NO,
                    Business_unit_om: value.BUSINESS_UNIT_OM,
                    INV_ITEM_ID: value.INV_ITEM_ID,
                    Quantity: value.QTY_REQUESTED,
                    ISA_INTFC_LN: value.ISA_INTFC_LN,
                    MFG_ITM_ID: value.MFG_ITM_ID,
                    ISA_MFG_FREEFORM: value.ISA_MFG_FREEFORM,
                    Descr: value.DESCR254,
                    price: value.ISA_SELL_PRICE,
                    PaintColor: value.LINE_FIELD_C6
                });

            });
            //let cartstorage = []
            //if (localStorage.getItem("CartStorage") != null) {
            //    cartstorage = JSON.parse(localStorage.getItem("CartStorage"));
            //}
            //let cartcontain = false
            //if (cartstorage.length > 0) {
            //    cartstorage.map((x) => {
            //        if (itemsSelected.length > 0) {
            //            itemsSelected.map((y) => {
            //                if (x.Itemid == y.INV_ITEM_ID && x.Manufacturer == y.ISA_MFG_FREEFORM && x.Manufacturerpartnumber == y.MFG_ITM_ID) {

            //                    let ind = itemsSelected.findIndex(y => x.Itemid == y.INV_ITEM_ID && x.Manufacturer == y.ISA_MFG_FREEFORM && x.Manufacturerpartnumber == y.MFG_ITM_ID);
            //                    let AlertMsg = "Item " + x.Itemid + " Is Already In Cart";
            //                    alert(AlertMsg);
            //                    if (ind != -1) {
            //                        itemsSelected.splice(ind, 1)
            //                        itemsToAdd.splice(ind, 1)
            //                    }
            //                }
            //            })

            //        }
            //    })
            //}
            if (itemsSelected.length > 0) {


                let addFavOrderItemsBO = {
                    Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                    Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                    Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
                    Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
                    Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
                    Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
                    LineItems: itemsToAdd,
                    /*[12/24/21, PC_SC_21], Priyanka D//Passing the Location value */
                    Location: CookieService.getLocalStorageValues("LOCATION") != null ? CookieService.getLocalStorageValues("LOCATION").substring(0, 2) : "",
                    Session_ID: CookieService.getLocalStorageValues("Session_ID"),//WW-390_PC_09 (4/20/2022)-Aparna
                    Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"), //pc-676-152 to 161 equipmentparts mixed cart restriction S.Sanjay11/29/2024
                    EquipmentDelete: cartDelete,
                    Interactive: false
                };
                /*[05/06/22, PC_WW-243_03]Priyanka D*/
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                MenuAction.addFavOrderItemsTocart(addFavOrderItemsBO);
            }
            //else {
            //    alert("Item already in cart");
            //}
        }

    };
    /**
    * This method pushes the selected favorite items
    * for adding to cart
    */
    selectFavItem = (index1) => {
        //***NEW(1/7/2021)****
        let { favitems } = this.state;
        if (index1 != "ALL") {
            favitems[index1].checked = favitems[index1].checked == true ? false : true;
        }
        else if (index1 == "ALL") {
            favitems.map((item, index) => {
                favitems[index].checked = true
            })
        }
        console.log("favitems", favitems)
        let Addfav = false
        if (favitems != null && favitems != []) {
            favitems.map((item, index) => {
                if (item.checked == true && item.PRICE > 0) {
                    Addfav = true
                }
            })
        }
        //*END*****
        //this.setState({ favitems: favitems, FavitemSelected: Addfav });
        //let { favitems } = this.state;
        //favitems[index].checked = favitems[index].checked == true ? false : favitems[index].checked == false ? true : true;
        //this.setState(favitems);
    }
    /**
    * This method pushes the selected favorite order line items
    * for adding to cart
    */
    selectFavOrderItem = (lineID, OrderNO, TruckStockCheck) => {
        //*NEW(1/7/2021)**************ADDED*****
        //let { favOrderLineItems } = this.state;
        //let index = favOrderLineItems.findIndex(x => x.ORDER_NO == OrderNO && x.ISA_INTFC_LN == lineID);
        //favOrderLineItems[index].checked = favOrderLineItems[index].checked == true ? false : favOrderLineItems[index].checked == false ? true : true;
        //this.setState(favOrderLineItems);
        //*NEW(1/7/2021)**************ADDED*****
        let { favOrderLineItems } = this.state;
        if (lineID != null && lineID != undefined && lineID != "") {
            let index = favOrderLineItems.findIndex(x => x.ORDER_NO == OrderNO && x.ISA_INTFC_LN == lineID);

            if (TruckStockCheck == false) {
                favOrderLineItems[index].checked = favOrderLineItems[index].checked == true ? false : favOrderLineItems[index].checked == false ? true : true;

            }
        }
        else {
            this.state.favOrderLineItems.map((item, index) => {
                let TruckStockCheck = false
                if (this.state.FavOrderInv != undefined && this.state.FavOrderInv != null) {
                    if (this.state.FavOrderInv.length > 0) {
                        TruckStockCheck = this.state.FavOrderInv.some((x) => {
                            if (item.INV_ITEM_ID == x.INV_ITEM_ID) {
                                if (x.QTY != null) {
                                    let trucksplit = x.QTY.split("^")
                                    return trucksplit[2] == "T"
                                }
                                return false
                            }
                            return false

                        })
                    }
                }

                if (TruckStockCheck == false) {
                    favOrderLineItems[index].checked = favOrderLineItems[index].ORDER_NO == OrderNO && !favOrderLineItems[index].DESCR254.includes("Core Charges") ? true : false
                }
            })

        }
        //console.log("favOrderLineItems", favOrderLineItems)
        this.setState(favOrderLineItems);
        //******END**********
    }
    /**
    * MN_PC_49
    * This method bind the favorite items in HTML
    */
    bindFavItems = () => {
        console.log("favitemsss", this.state.favitems)
        return this.state.favitems.map((item, index) => {
            let imagePath = this.state.apiURL + `Images/noimage_new.png`;
            if (item.IMAGE_NAME) {
                item.IMAGE_NAME = item.IMAGE_NAME.replace('\\', '/');
                if (item.IMAGE_NAME.toLowerCase().indexOf("http") >= 0) {
                    imagePath = item.IMAGE_NAME;
                } else {
                    imagePath = item.IMAGE_NAME.lastIndexOf(`/`) >= 0 ? item.IMAGE_NAME.substring(item.IMAGE_NAME.lastIndexOf("/") + 1, item.IMAGE_NAME.length) : "noimage_new.png";
                    if (imagePath) {
                        imagePath = this.state.apiURL + `Images/${imagePath}`;
                    }
                }
            } else {
                imagePath = this.state.apiURL + `Images/noimage_new.png`;
            }
            const style = {
                image: {
                    position: 'sticky !important',
                    display: 'block',
                    left: '0px !important',
                    top: '0px !important',
                },
            }
            //let UnitPrice = parseFloat(item.PRICE) ? parseFloat(item.PRICE) : 0
            //if (UnitPrice > 0) {
            //    UnitPrice = UnitPrice.toFixed(2)
            //}
            //else {
            //    UnitPrice = 0.00
            //}
            return (<li className="list-group-item border-0 popover-shopping-background" key={index}>
                <div className="popover-item-id custom-checkbox custom-color item-custom-control d-inline-block col-md-12 p-0  custom-dropdown-chk">
                    <input type="checkbox" className="float-right custom-control-input" id={`customCheck${index + 1}`} checked={item.checked} name="example" onClick={() => this.selectFavItem(index)} />
                    <label className="custom-control-label w-100 priority-checkbox priority-checkbox-position profile-update-checkbox cursor-pointer" htmlFor={`customCheck${index + 1}`}>
                        <div className="image-parent col-md-3 text-center float-left p-0"><div className="row justify-content-center">
                            <Image
                                src={imagePath}
                                width={60}
                                height={60}
                                style={style.image}
                                noImageSrc="/Images/noimage_new.png"
                            /></div>
                            {/* <img src={imagePath} className="img-fluid" alt="Fav-Img" /> */}</div>
                        <div className="col-md-9 float-left pr-0">
                            <span className="popover-item-id-label">Item ID :</span>
                            <span className="popover-item-id-value">{item.ISA_CP_ITEM_ID}</span>
                            <div className="popover-item-description"> {item.ITEM_DESC ? item.ITEM_DESC.length > 25 ? `${item.ITEM_DESC.substring(0, 22)}...` : item.ITEM_DESC : ``} </div>
                            {/**********NEW****************
                            <div className="popover-item-description"> {item.PRICE > 0 ? `Unit Price: $ ${UnitPrice}` : `Unit Price: Price on request`}</div>
                            {/**********END****************/}
                        </div>
                    </label>
                </div>

            </li>)
        });
    };
    /**
    * MN_PC_48
    * This method bind the favorite Order in HTML
    */
    bindFavOrderItems = (OrderNo) => {
        let childItems = this.state.favOrderLineItems.filter((item, index) => item.ORDER_NO == OrderNo);
        //*NEW*(1/7/2021)********REMOVED*******
        //if (childItems.length > 5) {
        //    childItems.length = 5;
        //}
        //***END****************
        return childItems.map((childVal, index) => {
            let imagePath = this.state.apiURL + `Images/noimage_new.png`;
            if (this.state.favOrderLineItemImgs.length > 0) {
                let filteredImages = this.state.favOrderLineItemImgs.filter((x) => x.ORDER_NO == OrderNo && x.BUSINESS_UNIT_OM == childVal.BUSINESS_UNIT_OM && x.ISA_INTFC_LN == childVal.ISA_INTFC_LN);
                let IMAGE_NAME = filteredImages.length > 0 ? filteredImages[0].ISA_ORIG_URL : "";
                if (IMAGE_NAME) {
                    if (IMAGE_NAME) {
                        IMAGE_NAME = IMAGE_NAME.replace('\\', '/');
                        //pc-1135-01 image is not showing s.sanjay 08/02/2024
                        let spliturl = IMAGE_NAME.split('|');
                        if (IMAGE_NAME.toLowerCase().indexOf("http") >= 0) {
                            imagePath = spliturl[0];
                        } else {
                            imagePath = IMAGE_NAME.lastIndexOf(`/`) >= 0 ? IMAGE_NAME.substring(IMAGE_NAME.lastIndexOf("/") + 1, IMAGE_NAME.length) : "noimage_new.png";
                            if (imagePath) {
                                imagePath = this.state.apiURL + `Images/${spliturl[0]}`;
                            }
                        }
                    } else {
                        imagePath = this.state.apiURL + `Images/noimage_new.png`;
                    }
                }
            }
            let TruckStockCheck = false
            if (this.state.FavItemInv != undefined && this.state.FavItemInv != null) {
                // console.error("FavItemInv", this.state.FavItemInv)
                if (this.state.FavItemInv.length > 0) {
                    TruckStockCheck = this.state.FavOrderInv.some((x) => {
                        if (x.INV_ITEM_ID == childVal.INV_ITEM_ID) {
                            if (x.QTY != null) {
                                let trucksplit = x.QTY.split("^")
                                return trucksplit[2] == "T"
                            }
                            return false
                        }
                        return false

                    })
                }
            }

            const style = {
                image: {
                    position: 'sticky !important',
                    display: 'block',
                    left: '0px !important',
                    top: '0px !important',
                },
            }

            return (<li className="list-group-item border-0 popover-shopping-background" key={index}>
                {/*[1/6/22], PC_MC_16, WW-286, Dhevanesam R*/}
                {childVal.DESCR254.includes("Core Charges") == false ?
                    <div className={`popover-item-id custom-checkbox custom-color item-custom-control d-inline-block col-md-12 p-0  custom-dropdown-chk ${TruckStockCheck ? "disabled-cbox" : ""}`}>
                        <input type="checkbox" className="float-right custom-control-input" id={`customCheck${index + 1}-chka-${OrderNo}`} checked={childVal.checked} name="example-chka" onChange={() => this.selectFavOrderItem(childVal.ISA_INTFC_LN, OrderNo, TruckStockCheck)} />
                        <label className="custom-control-label w-100 priority-checkbox priority-checkbox-position profile-update-checkbox cursor-pointer" htmlFor={`customCheck${index + 1}-chka-${OrderNo}`}>
                        </label>
                        {/*[1/6/23], PC_WW-587_1, Dhevanesam R*/}
                        <div className="image-parent col-md-3 text-center float-left p-0" onClick={(e) => this.showitemdetails(index, childVal.INV_ITEM_ID, childVal.ISA_MFG_FREEFORM, childVal.MFG_ITM_ID, childVal.VENDOR_ID, e, childVal, "menuFavOrder")}>
                            <div className="row justify-content-center">
                                <Image
                                    src={imagePath}
                                    width={60}
                                    height={60}
                                    style={style.image}
                                    noImageSrc="/Images/noimage_new.png"
                                /></div>
                            {/*<img src={imagePath} className="img-fluid" alt="Fav-Order" /> */}</div>
                        <div className="col-md-9 float-left pr-0" onClick={(e) => this.showitemdetails(index, childVal.INV_ITEM_ID, childVal.ISA_MFG_FREEFORM, childVal.MFG_ITM_ID, childVal.VENDOR_ID, e, childVal, "menuFavOrder")}>
                            <span className="popover-item-id-label font-color-black">Item ID :</span>
                            <span className="popover-item-id-value font-color-black">{childVal.MFG_ITM_ID != " " && childVal.MFG_ITM_ID ? childVal.MFG_ITM_ID : `NONCAT-${childVal.ISA_INTFC_LN}`}</span>
                            <div className="popover-item-description font-color-black"> {childVal.DESCR254 ? childVal.DESCR254.length > 26 ? `${childVal.DESCR254.substring(0, 22)}...` : childVal.DESCR254 : ``} </div>
                            {TruckStockCheck ?
                                <div className="caution-alignment">

                                    <div>
                                        <img src="/Images/caution.svg" className="fav-popover-alert-img" alt="Fav-Img" />
                                    </div>
                                    <div>
                                        <p className="alert-info-style">Truck stock item cannot be added to cart.</p>
                                    </div>
                                </div>

                                : null}
                        </div>
                    </div> : null}
            </li>)
        });

    }

    noncatClick = (e) => {
        let WO = localStorage.getItem("WONum")
        localStorage.setItem('isNoncatClick', "true");

        if (WO != undefined && WO != null && WO.trim() != "") {
            this.noncat(e);
        }
        else {
            $('#WorkOrderPopUp').modal('show');
            this.hideHamBurger();

        }
    }

    noncat = (event) => {
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let IsThirdParty = CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != "0" && CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != null ? true : false;
        let WO_Type = CookieService.getLocalStorageValues("WO_Type") != "" && CookieService.getLocalStorageValues("WO_Type") != null ? CookieService.getLocalStorageValues("WO_Type") : "";

        if (WO_Type.toUpperCase() != 'WALMART' && IsThirdParty != false) {
            this.headerRedirect(event, "/RFQEntry")
        }
        else {
            this.headerRedirect(event, "/WalmartRFQEntry")
        }

    }
    //WW-1325 Nonstock cart Icon on Topnavigation bar -Vishwa S
    //TopNavNoncatClick = (e) => {
    //    let SDIMenuLoc = JSON.parse(localStorage.getItem("SDIMenu"));

    //    let privilege = SDIMenuLoc.find(item => item.ISA_IDENTIFIER_NAME === "Non-Catalog Request");
    //    if (!privilege) {
    //        swal({
    //            allowOutsideClick: false,
    //            closeOnClickOutside: false,
    //            text: "Insufficient privilege to view non-catalog request"
    //        });
    //    }
    //    else {
    //        let WO = localStorage.getItem("WONum")
    //        localStorage.setItem('isTopNavNoncatClick', "true");

    //        let IsThirdParty = CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != "0" && CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != null ? true : false;
    //        let WO_Type = CookieService.getLocalStorageValues("WO_Type");

    //        if (WO != undefined && WO != null && WO.trim() != "") {
    //            if (WO_Type.toUpperCase() == 'WALMART' && IsThirdParty == false) {
    //                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
    //                this.headerRedirect(e, "/WalmartRFQEntry")
    //            }
    //        }
    //        else {
    //            $('#WorkOrderPopUp').modal('show');
    //        }
    //    }
    //}

    //WW-1163 Method to check for #WO and interactive diagram navigation -Vishwa S
    interactiveClick = (e) => {
        let WO = localStorage.getItem("WONum")
        localStorage.setItem('isInteractiveClick', "true");

        if (WO != undefined && WO != null && WO.trim() != "") {
            this.headerRedirect(e, "/interactivediagram/")
        }
        else {
            $('#WorkOrderPopUp').modal('show');
            this.hideHamBurger();
        }
    }
    equipmentClick = (e) => {
        e.preventDefault(); // Ensure default action is prevented
        let WO = localStorage.getItem("WONum");
        localStorage.setItem('isEquipmentClick', "true");

        if (WO && WO.trim()) {
            this.headerRedirect(e, "/Equipments");
        } else {
            this.setState({
                WONum: '',
                WOErrorMsg: ''
            }); // Make sure state is updated here
            $('#WorkOrderPopUp').modal('show');
            this.hideHamBurger();
        }
    }
    WorkOrderFail = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        this.setState({ WOErrorMsg: "Enter valid work order number" });
        $('#WorkOrderPopUp').modal('show');
    }
    KeyPress = (e) => {
        if (e.keyCode == 13) {
            this.ValidateWO();
        }
    }
    ValidateWO = () => {
        if (this.state.WONum.trim() != "") {
            if (CookieService.getLocalStorageValues("Session_CC_VALIDATE_WO") != 'N') {
                let WorkOrderBO = {
                    workOrder: this.state.WONum,
                    Session_THIRDPARTY_COMP_ID: CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != "" ? CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") : "",
                    User_Type: CookieService.getLocalStorageValues("Session_SDIEMP"),
                    is_WO_Parts_Needed: true
                }
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                $('#WorkOrderPopUp').modal('hide');
                MenuAction.WorkOrderCheck(WorkOrderBO)
            }
            else {
                localStorage.setItem('WONum', this.state.WONum);
                $("#WorkOrderNo").addClass("disabledbutton");
                let noncatVariable = localStorage.getItem("isNoncatClick")
                let interactiveVariable = localStorage.getItem("isInteractiveClick")
                let equipmentVariable = localStorage.getItem("isEquipmentClick");

                if (noncatVariable == "true") {
                    this.noncat();
                }
                else if (interactiveVariable == "true") {
                    this.headerRedirect("", "/interactivediagram");
                }
                else if (equipmentVariable == "true") {
                    this.headerRedirect("", "/Equipments");
                }
                else {
                    this.TechVault();
                }
                $('#WorkOrderPopUp').modal('hide');
            }
        }
        else {
            this.setState({ WOErrorMsg: "Please enter work order number" })
        }

    }
    WONumChange = (e) => {
        const NumRegex = SDIConstants.quantityRegEX;
        if (e.target.value === '' || NumRegex.test(e.target.value)) {
            this.setState({ WONum: e.target.value, WOErrorMsg: "" });
        }
    }
    ClearWO = () => {
        this.setState({ WONum: "", WOErrorMsg: "" });
    }
    WOClose = () => {
        $('#WorkOrderPopUp').modal('hide');
        this.setState({
            WONum: "",
            WOErrorMsg: "",
            isEquipmentClick: false,
            isNoncatClick: false,
        });
        localStorage.removeItem('isEquipmentClick');
        localStorage.removeItem('isNoncatClick');
        localStorage.removeItem('isInteractiveClick');
        //localStorage.removeItem('isTopNavNoncatClick'); //WW-1325 -Vishwa S
    }



    WorkOrderResponse = () => {
        localStorage.setItem('WONum', this.state.WONum);
        let loacalloc = ""
        let localWON = ""
        let BilltoStoreLocationLat = ""
        let BilltoStoreLocationLong = ""
        let Workorderresponse = JSON.parse(MenuStore.workorderresponse);
        if (Workorderresponse.WOResponse.length > 0) {
            if (Workorderresponse.WOResponse[0].AssetID != "" && Workorderresponse.WOResponse[0].AssetID != null && Workorderresponse.WOResponse[0].AssetID != undefined && Workorderresponse.WOResponse[0].AssetID != " ") {
                localStorage.setItem('WOAssetID', Workorderresponse.WOResponse[0].AssetID);
                localStorage.setItem('WOAssetTag', Workorderresponse.WOResponse[0].AssetTag);
                if (Workorderresponse.WOResponse[0].WO_Make != "" && Workorderresponse.WOResponse[0].WO_Make != null && Workorderresponse.WOResponse[0].WO_Make != undefined && Workorderresponse.WOResponse[0].WO_Make != " ") {
                    CookieService.updateLocalStorageValues("WO_Make", Workorderresponse.WOResponse[0].WO_Make);
                } if (Workorderresponse.WOResponse[0].WO_Model != "" && Workorderresponse.WOResponse[0].WO_Model != null && Workorderresponse.WOResponse[0].WO_Model != undefined && Workorderresponse.WOResponse[0].WO_Model != " ") {
                    CookieService.updateLocalStorageValues("WO_Model", Workorderresponse.WOResponse[0].WO_Model);
                }
            }
            if (Workorderresponse.WOResponse[0].LOCATION != "" && Workorderresponse.WOResponse[0].LOCATION != null && Workorderresponse.WOResponse[0].LOCATION != undefined && Workorderresponse.WOResponse[0].LOCATION != " ") {
                loacalloc = Workorderresponse.WOResponse[0].LOCATION
                localStorage.setItem("StoreValue", JSON.stringify(loacalloc));
                BilltoStoreLocationLat = Workorderresponse.WOResponse[0].LATITUDE;
                BilltoStoreLocationLong = Workorderresponse.WOResponse[0].LONGITUDE;
                localStorage.setItem("BilltoStoreLocationLat", BilltoStoreLocationLat);
                localStorage.setItem("BilltoStoreLocationLong", BilltoStoreLocationLong);
                console.log("loacalloc", loacalloc);
            }
            if (Workorderresponse.WOResponse[0].Notes != "" && Workorderresponse.WOResponse[0].Notes != null && Workorderresponse.WOResponse[0].Notes != undefined && Workorderresponse.WOResponse[0].Notes != " ") {
                localWON = Workorderresponse.WOResponse[0].Notes;
                //$("#AssetID").attr("disabled", true);
                console.log("Notes", Workorderresponse.WOResponse[0].Notes);

            }
            CookieService.updateLocalStorageValues("Trade", Workorderresponse.WOResponse[0].Trade);
            let homestoreloc = CookieService.getLocalStorageValues("LOCATION");
            CookieService.updateLocalStorageValues("homestoreloc", homestoreloc);
            CookieService.updateLocalStorageValues("LOCATION", Workorderresponse.WOResponse[0].COUNTRY);
            localStorage.setItem("Country", Workorderresponse.WOResponse[0].COUNTRY);
            CookieService.updateLocalStorageValues("WO_Address", Workorderresponse.WOResponse[0].ADDRESS1);
            CookieService.updateLocalStorageValues("WO_Category", Workorderresponse.WOResponse[0].Category);
            CookieService.updateLocalStorageValues("WO_Priority", Workorderresponse.WOResponse[0].Priority);
            CookieService.updateLocalStorageValues("NTEAmount", Workorderresponse.WOResponse[0].NTE);
            CookieService.updateLocalStorageValues("WO_CAT_DESC", Workorderresponse.WOResponse[0].WO_CAT_DESC);
            CookieService.updateLocalStorageValues("WO_Type", Workorderresponse.WOResponse[0].WO_Type);
            CookieService.updateLocalStorageValues("Session_WO_STATE", Workorderresponse.WOResponse[0].STATE); //WW-1231 WO State Restriction -Vishwa S
            CookieService.updateLocalStorageValues("IsBlanketWO", Workorderresponse.WOResponse[0].IsBlanketWO);// Set Stating the Ship to the ISBlanketWO if the user selects the W09301 location

            //WW-1374 Update the WO logo, Problem code long and short description to cookie - Nandhini L 
            CookieService.updateLocalStorageValues("Logo", Workorderresponse.WOResponse[0].Logo);
            CookieService.updateLocalStorageValues("ProblemCodeDescription", Workorderresponse.WOResponse[0].ProblemCodeDescription);
            CookieService.updateLocalStorageValues("Description", Workorderresponse.WOResponse[0].Description);

            if (Workorderresponse.WOParts != undefined && Workorderresponse.WOParts != null) {

                if (Workorderresponse.WOParts.length > 0) {

                    localStorage.setItem("WO_Parts", JSON.stringify(Workorderresponse.WOParts))


                }
            }
        }
        let noncatVariable = localStorage.getItem("isNoncatClick")
        //let topNavNoncatVariable = localStorage.getItem("isTopNavNoncatClick")
        let interactiveVariable = localStorage.getItem("isInteractiveClick")
        let equipmentVariable = localStorage.getItem("isEquipmentClick");

        if (noncatVariable == "true") {
            this.noncat();

        }
        //WW-1163 Interactive diagram navigation check -Vishwa S
        else if (interactiveVariable == "true") {
            this.headerRedirect("", "/interactivediagram");
        }
        else if (equipmentVariable == "true") {
            this.headerRedirect("", "/Equipments");
        }
        //else if (topNavNoncatVariable == "true") { //WW-1325 Nonstock cart Icon on Topnavigation bar -Vishwa S
        //    if (currentPath == "/WalmartRFQEntry") {
        //        window.location.reload();
        //    }
        //    else {
        //        this.headerRedirect("", "/WalmartRFQEntry");
        //    }
        //}
        else {
            this.TechVault();
        }

    }

    isAllOrderItemsUnavailable = (orderNo) => {
        let orderItems = this.state.favOrderLineItems.filter(item => item.ORDER_NO == orderNo);
        let allUnavailable = orderItems.every(item => item.DESCR254.includes("Core Charges") || item.DESCR254.includes("Not Available"));
        return allUnavailable;
    }
    /**
     * MN_PC_48
     * This method bind the favorite Order in HTML
     */
    bindFavOrders = () => {
        return this.state.favorders.map((order, index) => {
            {/*[1/6/22], PC_MC_16, WW-286, Dhevanesam R*/ }
            let orderLineItemCount = this.state.favOrderLineItems.filter((value, index) => value.ORDER_NO == order.ORDER_NO && value.DESCR254.includes("Core Charges") == false).length;
            let allUnavailable = this.isAllOrderItemsUnavailable(order.ORDER_NO); // Check if all items are unavailable
            let childItems = this.state.favOrderLineItems.filter((item, index) => item.ORDER_NO == order.ORDER_NO);
            let itemchecked = false
            childItems.map((val, index) => {
                if (val.checked == true) { itemchecked = true }
            });

            return (
                <li className="dropdown-submenu" key={index}>
                    <a className="dropdown-item popover-shopping-background font-style" onClick={() => this.menuFavOrderClick(order.ORDER_NO)} >
                        {orderLineItemCount > 0 ? <span className="favmenu-right-arrow float-left" /> : null}
                        <span className={orderLineItemCount > 0 ? `ml-3` : `ml-3 pl-1`}> {order.ORDER_NO} <span>({orderLineItemCount})</span> </span>
                    </a>
                    {orderLineItemCount > 0 ? <div className="dropdown-menu dropdown-order-fav  custom-welcome-dropdown FavMenuWidth" aria-labelledby="navbarDropdown-myfav-order">
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-12 p-0">
                                    <ul className="list-group FavMenuWidth-ul">
                                        {this.bindFavOrderItems(order.ORDER_NO)}
                                    </ul>
                                    <div className="list-group-item border-0 mt-0 mb-0">
                                        <div className="col-md-12 text-center border-style pb-4">
                                            <button className="btn btn-primary custom-btn-showall primary-btn pb-2"
                                                onClick={(event) => this.selectFavOrderItem("", order.ORDER_NO)}><Trans>Select All</Trans></button>
                                        </div>
                                    </div>
                                    {!allUnavailable && // Conditionally render the "Add to Cart" button
                                        <div className="list-group-item border-0 pt-0">
                                            {/* {itemchecked == true ? <div className="popover-shopping-addcart float-left itemdetailPrice">
                                        <span>Order total: {this.FavOrderTotalCal(childItems)}</span>
                                    </div> : null}*/}
                                            <div className="popover-shopping-addcart">
                                                <button className="btn btn-primary custom-btn-primary " onClick={() => this.addFavOrderItemsToCart(order.ORDER_NO)}>
                                                    <img src="/Images/item_cart.png" className="addtocart" alt="Add to cart icon" />
                                                    <Trans>Add To Cart</Trans>
                                                </button>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div> : null}
                </li>
            )
        });
    };

    //******NEW*************bindFaviItemCategory****
    bindFavItemCategory = () => {
        let count = 0;
        let cartstorage = []
        let IsCoreCheck = false
        if (localStorage.getItem("CartStorage") != null) {
            cartstorage = JSON.parse(localStorage.getItem("CartStorage"));
        }
        console.log("FavItemCategory", this.state.FavItemCategory);
        return this.state.FavItemCategory.map((order, index) => {
            let catcount = this.state.FavItemCategory.length;
            //let childItems = this.state.favitems.filter((item, index) => item.ISA_CP_ITEM_ID == order.ISA_CP_ITEM_ID);
            //let itemchecked = false
            //childItems.map((val, index) => {
            //    if (val.checked == true) { itemchecked = true }
            //});
            //console.log("favOrderLineItems", this.state.favOrderLineItems)
            count = count + 1;

            if (count <= 5) {
                let allDisabled = this.isAllCheckboxesDisabled(order.FavText);
                return (<li className="dropdown-submenu" key={index}>
                    <a className="dropdown-item popover-shopping-background font-style" onClick={(event) => this.menuFavItemCategroyClick(order.FavText.toUpperCase())} >
                        {catcount > 0 ? <span className="favmenu-right-arrow float-left" /> : null}
                        <span data-toggle="tooltip" title={order.FavText.toUpperCase()} className={catcount > 0 ? `ml-3` : `ml-3 pl-1`}>{order.FavText != " " ? order.FavText.length > 15 ? `${order.FavText.toUpperCase().substring(0, 15)}...` : order.FavText.toUpperCase() : `-`}</span>

                    </a>
                    {catcount > 0 ? <div className="dropdown-menu dropdown-order-fav  custom-welcome-dropdown FavMenuWidth" aria-labelledby="navbarDropdown-myfav-order">{/*right-triangle-dropdownstyle*/}
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-12 p-0">
                                    <ul className="list-group FavMenuWidth-ul">
                                        {this.bindFavItemsData(order.FavText)}
                                    </ul>
                                    <div className="list-group-item border-0 mt-0 mb-0">
                                        {this.bindSelectAll(order.FavText)}

                                    </div>
                                    {!allDisabled &&

                                        <div className="list-group-item border-0 pt-0">
                                            {/* {itemchecked == true ? <div className="popover-shopping-addcart float-left itemdetailPrice">
                                        <span>Order total: {this.FavOrderTotalCal(childItems)}</span>
                                    </div> : null}*/}
                                            <div className="popover-shopping-addcart">
                                                <button className="btn btn-primary custom-btn-primary " onClick={() => this.addFavItemsToCart(IsCoreCheck)}>
                                                    <img src="/Images/item_cart.png" className="addtocart" alt="Add to cart icon" />
                                                    <Trans>Add To Cart</Trans>
                                                </button>
                                            </div>
                                        </div>}
                                </div>
                            </div>
                        </div>
                    </div> : null}

                </li>)
            }
        });
    };
    closePopup = (message) => {
        $('#Altdet').modal('hide');
        if (message != "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: message
            });
        }
        this.setState({ Altdet: false })
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    };
    //WW-542_PC_02 (12/1/2022)-Aparna
    menuFavItemCategroyClick = (Category) => {
        CookieService.updateLocalStorageValues("menuFavItemCategory", Category);
        console.log("menuFavItemCategory", CookieService.getLocalStorageValues("menuFavItemCategory"))
        if (window.location.pathname.toLowerCase() == "/favorites") {
            window.location.reload()
        } else {
            this.props.history.push({
                pathname: `/favorites`,
            });
        }

    }
    //WW-542_PC_04 (12/2/2022) -Aparna
    menuFavOrderClick = (orderNo) => {
        CookieService.updateLocalStorageValues("menuFavOrder", orderNo);
        console.log("menuFavOrder", CookieService.getLocalStorageValues("menuFavOrder"))
        if (window.location.pathname.toLowerCase() == "/favorder") {
            window.location.reload()
        } else {
            this.props.history.push({
                pathname: `/favorder`,
            });
        }

    }
    selectFavItemData = (cat, item, desc, manufacturer, supplier, catalog_flag, index, TruckStockCheck) => {
        //5732 - Select/Unselect all option enabled [5/5/2025] Nachiappan
        if (catalog_flag != "NA" && TruckStockCheck != true) {
            let { favitems, allSelected } = this.state;
            if (cat != null && cat != undefined && cat != "" && cat != " ") {
                let index = favitems.findIndex(x => x.ISA_FAVS_CATEGORY == cat && x.ISA_CP_ITEM_ID == item && x.ITEM_DESC == desc && x.MANUFACTURER == manufacturer && x.SUPPLIER_ID == supplier);
                // Toggle the checked state of the specific item
                if (index !== -1) {
                    favitems[index].checked = !favitems[index].checked;

                    // Check if all items in the same category are selected
                    const allCheckedInCategory = favitems
                        .filter(x => x.ISA_FAVS_CATEGORY === cat) // Filter items by category
                        .every(x => x.checked); // Check if all filtered items are checked

                    // Update the state
                    this.setState({
                        favitems: favitems,
                        allSelected: allCheckedInCategory // Set allSelected based on whether all items in the category are checked
                    });
                }
            } else {
                let ind;
                //this.state.favitems.map((i, index) => {
                ind = favitems.findIndex(x => x.ISA_CP_ITEM_ID == item);
                if (ind !== -1) {
                    favitems[ind].checked = !favitems[ind].checked;

                    // Check if all items in the same category are selected
                    const category = favitems[ind].ISA_FAVS_CATEGORY; // Get the category of the current item
                    const allCheckedInCategory = favitems
                        .filter(x => x.ISA_FAVS_CATEGORY === category) // Filter items by category
                        .every(x => x.checked); // Check if all filtered items are checked

                    // Update the state
                    this.setState({
                        favitems: favitems,
                        allSelected: allCheckedInCategory // Set allSelected based on whether all items in the category are checked
                    });
                }
            }
        }
    }
    //[1/3/23], WW-542_PC_10, Dhevanesam R
    //[1/19/23, WW-587_PC_2, Dhevanesam R]
    showitemdetails = (index, ItemId, manufactpartnum, mfg_std, vendor_id, event, childItem, favtype) => {
        let Itemtypevalue = ItemId.indexOf("NONCAT") > -1 ? "NONCAT" : "CAT";
        CookieService.updateLocalStorageValues("Session_Noncat", Itemtypevalue);
        CookieService.updateLocalStorageValues("ItemDetail_ItemId", ItemId);
        CookieService.updateLocalStorageValues("ItemDetail_ManufacturePartNumber", mfg_std);
        CookieService.updateLocalStorageValues("ItemDetail_ManufactureName", manufactpartnum);
        CookieService.updateLocalStorageValues("ItemDetail_SupplierID", vendor_id);
        let ItemData = {
            vendor_id: vendor_id,
            ItemPrice: childItem.PRICE,
            txtDesc: childItem.ITEM_DESC
        }
        if (Itemtypevalue != "NONCAT") {
            if (window.location.pathname.toLowerCase() == "/itemdetailnew") {
                this.props.history.push({
                    pathname: `\itemdetailnew`,
                    search: `?ItemId=${ItemId}&ManufacturePartNumber=${mfg_std}&ManufactureName=${manufactpartnum}&SupplierID=${vendor_id}`,
                    state: { ItemData: ItemData, origin: 'menu', Suggesstions: true, ItemId: ItemId, ManufacturePartNumber: mfg_std, ManufactureName: manufactpartnum, SupplierID: vendor_id, favType: favtype }
                });
                window.location.reload()
            }
            else {
                //[2/28/22], PC_IC_08, WW-316, Dhevanesam R 
                this.props.history.push({
                    pathname: `\itemdetailnew`,
                    search: `?ItemId=${ItemId}&ManufacturePartNumber=${mfg_std}&ManufactureName=${manufactpartnum}&SupplierID=${vendor_id}`,
                    state: { ItemData: ItemData, origin: 'menu', Suggesstions: true, ItemId: ItemId, ManufacturePartNumber: mfg_std, ManufactureName: manufactpartnum, SupplierID: vendor_id, favType: favtype }
                });
            }
        }
        else {
            if (childItem.LINE_FIELD_C6.toUpperCase() == "WNST" || childItem.LINE_FIELD_C6.toUpperCase() == "WCAT") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Details are not available for Sourced Non-Catalog item"
                });
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Details are not available for Non-Catalog item"
                });
            }

        }

    }

    isAllCheckboxesDisabled = (category) => {
        let itemsInCategory = this.state.favitems.filter(x => x.ISA_FAVS_CATEGORY.toUpperCase() === category.toUpperCase());
        if (category.toUpperCase() === "UNCLASSIFIED") {
            itemsInCategory = this.state.favitems.filter(x => x.ISA_FAVS_CATEGORY === "" || x.ISA_FAVS_CATEGORY === " " || x.ISA_FAVS_CATEGORY === undefined || x.ISA_FAVS_CATEGORY === "UNCLASSIFIED");
        }
        let allDisabled = itemsInCategory.every(item => item.ISA_CATALOG_FLAG === "NA");
        return allDisabled;
    }

    bindFavItemsData = (value) => {

        // console.error("favitemmenu truck", this.state.favitems)
        let val = value;
        let favfav = this.state.favitems.filter((x) => x.ISA_FAVS_CATEGORY.toUpperCase() == value.toUpperCase())
        if (value.toUpperCase() == "UNCLASSIFIED") {
            favfav = this.state.favitems.filter((x) => x.ISA_FAVS_CATEGORY == "" || x.ISA_FAVS_CATEGORY == " " || x.ISA_FAVS_CATEGORY == undefined || x.ISA_FAVS_CATEGORY == "UNCLASSIFIED")
        }
        //[1/5/23, WW-542_PC_13, Dhevanesam R]
        if (favfav.length > 0) {
            favfav = favfav.sort((a, b) => (a.ADD_DTTM > b.ADD_DTTM ? -1 : 1))
        }
        return favfav.map((item, index) => {

            let ind = this.state.favitems.findIndex(x => x.ISA_CP_ITEM_ID == item.ISA_CP_ITEM_ID && x.MANUFACTURER == item.MANUFACTURER && x.SUPPLIER_ID == item.SUPPLIER_ID)
            let imagePath = this.state.apiURL + `Images/noimage_new.png`;
            if (item.IMAGE_NAME) {
                item.IMAGE_NAME = item.IMAGE_NAME.replace('\\', '/');
                if (item.IMAGE_NAME.toLowerCase().indexOf("http") >= 0) {
                    imagePath = item.IMAGE_NAME;
                } else {
                    imagePath = item.IMAGE_NAME.lastIndexOf(`/`) >= 0 ? item.IMAGE_NAME.substring(item.IMAGE_NAME.lastIndexOf("/") + 1, item.IMAGE_NAME.length) : "noimage_new.png";
                    if (imagePath) {
                        imagePath = this.state.apiURL + `Images/${imagePath}`;
                    }
                }
            } else {
                imagePath = this.state.apiURL + `Images/noimage_new.png`;
            }
            let TruckStockCheck = false
            if (this.state.FavItemInv != undefined && this.state.FavItemInv != null) {
                //console.error("FavItemInv", this.state.FavItemInv)
                if (this.state.FavItemInv.length > 0) {
                    TruckStockCheck = this.state.FavItemInv.some((x) => {
                        if (x.INV_ITEM_ID == item.ISA_CP_ITEM_ID) {
                            if (x.QTY != null) {
                                let trucksplit = x.QTY.split("^")
                                return trucksplit[2] == "T"
                            }
                            return false
                        }
                        return false

                    })
                }

            }

            const style = {
                image: {
                    position: 'sticky !important',
                    display: 'block',
                    left: '0px !important',
                    top: '0px !important',
                },
            }
            // WW-685 PC_685_01 Display label for unavaialable item 5/26/2023 Pavithra R


            //let UnitPrice = parseFloat(item.PRICE) ? parseFloat(item.PRICE) : 0
            //if (UnitPrice > 0) {
            //    UnitPrice = UnitPrice.toFixed(2)
            //}
            //else {
            //    UnitPrice = 0.00
            //}
            {/*[1/3/23], WW-542_PC_10, Dhevanesam R*/ }
            {/*[1/19/23, WW-587_PC_1, Dhevanesam R]*/ }
            return (<li className="list-group-item border-0 popover-shopping-background" key={ind}>
                <div className={item.ISA_CATALOG_FLAG == "NA" || TruckStockCheck == true ? "popover-item-id custom-checkbox custom-color item-custom-control d-inline-block col-md-12 p-0 custom-dropdown-chk disabled-cbox" : "popover-item-id custom-checkbox custom-color item-custom-control d-inline-block col-md-12 p-0  custom-dropdown-chk"}>
                    <input type="checkbox" className="float-right custom-control-input" id={`customCheck${ind + 1}`} checked={item.checked} name="example" onClick={() => this.selectFavItemData(item.ISA_FAVS_CATEGORY, item.ISA_CP_ITEM_ID, item.ITEM_DESC, item.MANUFACTURER, item.SUPPLIER_ID, item.ISA_CATALOG_FLAG, ind, TruckStockCheck)} />
                    <label className="custom-control-label w-100 priority-checkbox priority-checkbox-position profile-update-checkbox cursor-pointer" htmlFor={`customCheck${ind + 1}`}>
                    </label>
                    <div className="image-parent col-md-3 text-center float-left p-0" onClick={(e) => this.showitemdetails(index, item.ISA_CP_ITEM_ID, item.MANUFACTURER, item.CLIENT_MFG_PART, item.SUPPLIER_ID, e, item, "menuFavItem")}><div className="row justify-content-center">
                        <Image
                            src={imagePath}
                            width={60}
                            height={60}
                            style={style.image}
                            noImageSrc="/Images/noimage_new.png"
                        /></div>
                        {/* <img src={imagePath} className="img-fluid" alt="Fav-Img" /> */}</div>
                    <div className="col-md-9 float-left pr-0 font-color-black" onClick={(e) => this.showitemdetails(index, item.ISA_CP_ITEM_ID, item.MANUFACTURER, item.CLIENT_MFG_PART, item.SUPPLIER_ID, e, item, "menuFavItem")}>
                        <span className="popover-item-id-label font-color-black">Item ID :</span>
                        <span className="popover-item-id-value font-color-black">{item.CLIENT_MFG_PART}</span>
                        <div className="popover-item-description font-color-black"> {item.ITEM_DESC ? item.ITEM_DESC.length > 25 ? `${item.ITEM_DESC.substring(0, 22)}...` : item.ITEM_DESC : ``} </div>
                        {item.ISA_COMMENTS != "" && item.ISA_COMMENTS != " " && item.ISA_COMMENTS != null && item.ISA_COMMENTS != undefined ?
                            <div className="caution-alignment">

                                <div>
                                    <img src="/Images/caution.svg" className="fav-popover-alert-img" alt="Fav-Img" />
                                </div>
                                <div>
                                    <p className="alert-info-style">{item.ISA_COMMENTS}</p>
                                </div>
                            </div>

                            :
                            TruckStockCheck ?
                                <div className="caution-alignment">

                                    <div>
                                        <img src="/Images/caution.svg" className="fav-popover-alert-img" alt="Fav-Img" />
                                    </div>
                                    <div>
                                        <p className="alert-info-style">Truck stock item cannot be added to cart.</p>
                                    </div>
                                </div>

                                : null}
                        {/**********NEW****************
                            <div className="popover-item-description"> {item.PRICE > 0 ? `Unit Price: $ ${UnitPrice}` : `Unit Price: Price on request`}</div>
                            {/**********END****************/}
                    </div>
                </div>

            </li>)
        });
    };
    bindSelectAll = (value) => {
        const { t } = this.props
        let fav = this.state.favitems.filter((x) => x.ISA_FAVS_CATEGORY.toUpperCase() == value.toUpperCase())
        if (value.toUpperCase() == "UNCLASSIFIED") {
            fav = this.state.favitems.filter((x) => x.ISA_FAVS_CATEGORY == "" || x.ISA_FAVS_CATEGORY == " " || x.ISA_FAVS_CATEGORY == undefined || x.ISA_FAVS_CATEGORY == "UNCLASSIFIED")
        }
        let availItems = fav.filter((x) => x.ISA_CATALOG_FLAG != "NA")
        if (availItems.length > 0) {
            return <div className="col-md-12 text-center border-style pb-4">
                <button className="btn btn-primary custom-btn-showall primary-btn pb-2"
                    onClick={(event) => this.selectAllCat(value)}> {this.state.allSelected ? t("Unselect All") : t("Select All")}</button>
            </div>
            {/* 5732 - All selected state is updated once selected items 4/28/2025 Nachiappan */ }
        }

    }
    /***  <p className="alternate_label" > <img src="/Images/caution.svg" className="img-fluid" alt="Fav-Img"/>Item unavailable, only alternate parts are available</p> **/
    selectAllCat = (selectedcat) => {
        //debugger
        let favcat = [];
        //5732 - All selected state is updated once selected a items 4/28/2025 Nachiappan
        let { favitems, allSelected } = this.state;
        favcat = this.state.favitems.filter((x) => x.ISA_FAVS_CATEGORY == selectedcat)
        if (selectedcat.toUpperCase() == "NOT CLASSIFIED" || selectedcat == " ") {
            favcat = this.state.favitems.filter((x) => x.ISA_FAVS_CATEGORY == "" || x.ISA_FAVS_CATEGORY == " " || x.ISA_FAVS_CATEGORY == undefined)
        }
        //if (index1 != "ALL") {
        //    favitems[index1].checked = favitems[index1].checked == true ? false : true;
        //}
        //else if (index1 == "ALL") {
        //    favitems.map((item, index) => {
        //        favitems[index].checked = true
        //    })
        //}
        console.log("favitems", favitems)
        let Addfav = false
        let ind
        if (favcat != null && favcat != []) {
            favcat.map((item, index) => {
                let TruckStockCheck = false
                if (this.state.FavItemInv != undefined && this.state.FavItemInv != null) {
                    if (this.state.FavItemInv.length > 0) {
                        TruckStockCheck = this.state.FavItemInv.some((x) => {
                            if (x.INV_ITEM_ID == item.ISA_CP_ITEM_ID) {
                                if (x.QTY != null) {
                                    let trucksplit = x.QTY.split("^")
                                    return trucksplit[2] == "T"
                                }
                                return false
                            }
                            return false

                        })
                    }

                }

                //debugger
                if (TruckStockCheck == false) {
                    if (item.ISA_FAVS_CATEGORY == selectedcat) {
                        ind = this.state.favitems.findIndex(x => x.ISA_FAVS_CATEGORY == selectedcat && x.ISA_CP_ITEM_ID == item.ISA_CP_ITEM_ID && x.ITEM_DESC == item.ITEM_DESC && x.MANUFACTURER == item.MANUFACTURER && x.SUPPLIER_ID == item.SUPPLIER_ID)

                    }
                    else {
                        ind = this.state.favitems.findIndex(x => x.ISA_FAVS_CATEGORY == selectedcat && x.ISA_CP_ITEM_ID == item.ISA_CP_ITEM_ID)
                    }
                    if (favitems[ind].ISA_CATALOG_FLAG != "NA") {
                        favitems[ind].checked = !allSelected
                        Addfav = true
                    }
                }
            })
        }
        this.setState({ favitems: favitems, allSelected: !allSelected })
        //this.setState({ favitems: favitems, FavitemSelected: Addfav });
        //let { favitems } = this.state;
        //favitems[index].checked = favitems[index].checked == true ? false : favitems[index].checked == false ? true : true;
        //this.setState(favitems);
    }
    //*************END*********************
    /**
     * MN_PC_39
     * This method bind the cart data in HTML
     */
    bindCartData = () => {

        return this.state.cartItems.map((cart, index) => {
            let Itemdesc = cart.ItemDescription
            if (Itemdesc != null && Itemdesc != undefined) {
                /*[06/13/22,WW-401], Priyanka D */
                Itemdesc = cart.ItemDescription.split("-INVITEMICON-")

            }

            let imagePath = "";
            //pc-1035-02 spliting the url and assignining to image 08/01/2024            
            if (cart.Image != undefined && cart.Image != null) {
                let spliturl = cart.Image.split('|');
                cart.Image = cart.Image.replace('\\', '/');
                if (cart.Image.toLowerCase().indexOf("http") >= 0) {
                    imagePath = spliturl[0];
                } else {
                    imagePath = cart.Image.lastIndexOf(`/`) >= 0 ? cart.Image.substring(cart.Image.lastIndexOf("/") + 1, cart.Image.length) : "noimage_new.png";
                    if (imagePath) {
                        imagePath = `/Images/${spliturl[0]}`;
                    }
                }
            } else {
                imagePath = `/Images/noimage_new.png`;
            }
            const style = {
                image: {
                    position: 'sticky !important',
                    display: 'block',
                    left: '0px !important',
                    top: '0px !important',
                },
            }
            //let UnitPrice = parseFloat(cart.Price) ? parseFloat(cart.Price) : 0
            //if (UnitPrice > 0) {
            //    UnitPrice = UnitPrice.toFixed(2)
            //}
            //else {
            //    UnitPrice = 0.00
            //}
            return (<li className="list-group-item border-0 popover-shopping-background" key={index}>
                <div className="image-parent"><div className="row justify-content-center">
                    <Image
                        src={imagePath}
                        width={60}
                        height={60}
                        style={style.image}
                        noImageSrc="/Images/noimage_new.png"
                    /></div>
                    {/*<img src={imagePath} className="img-fluid" alt="cart-item" />*/} </div>
                <div className="popover-cart-leftpane">
                    <div className="popover-item-id pb-1"> <span className="popover-item-id-label">Item ID :</span> <span className="popover-item-id-value">{cart.Manufacturerpartnumber}</span> </div>
                    {/*'/*[06/13/22,WW-401], Priyanka D */}
                    <div className="popover-item-description pb-1"> {Itemdesc[0] ? Itemdesc[0].length > 26 ? `${Itemdesc[0].substring(0, 22)}...` : Itemdesc[0] : ``}</div>
                    {/**********NEW***************
                    <div className="popover-item-description"> {cart.Price > 0 ? `Unit Price: $ ${UnitPrice}` : `Unit Price: Price on request`}</div>
                    {/**********END****************/}
                </div>
            </li>)
        })

    };
    //WW-1325 Nonstock cart Icon on Topnavigation bar -Vishwa S
    //bindNSTKCartData = () => {

    //    return this.state.NSTKCartItems.map((cart, index) => {
    //        let Itemdesc = cart.DESCR254

    //        const style = {
    //            image: {
    //                position: 'sticky !important',
    //                display: 'block',
    //                left: '10px !important',
    //                top: '10px !important',
    //            },
    //        }

    //        return (<li className="list-group-item popover-shopping-background d-flex notif-cart-item" key={index}>
    //            <img src="images/CartList_Icon.svg" class="img-fluid flex-shrink-0 mr-3" alt="quixote"/>
    //            <div className="flex-grow-1">
    //                <div className="popover-item-i"> <span className="popover-item-id-label">Item ID :</span> <span className="popover-item-id-value">{cart.CLIENT_MFG_PART}</span> </div>

    //                <div className="popover-item-description"> {Itemdesc != undefined && Itemdesc != null ? Itemdesc.length > 26 ? `${Itemdesc.substring(0, 22)}...` : Itemdesc : ``}</div>

    //            </div>
    //        </li>)
    //    })

    //};
    /**
   * Session time out method
   */
    _onAction(e) {
        this.setState({ isTimedOut: false })
    };
    /**
   * Session time out method
   */
    _onActive(e) {
        this.setState({ isTimedOut: false })
    };
    /**
   * Session time out method
   */
    sessionTimeoutMethod = () => {
        let envData = localStorage.getItem("SDIEnvironmentData");
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        CookieService.setCookieValues(SDIConstants.access_token, "", -1);
        // localStorage.clear();
        localStorage.setItem("sessionTimeOutData", envData);
        this.props.history.push({
            pathname: '/sessiontimeout',
        });
    }
    _onIdle(e) {
        console.log('user is idle', e);
        if (isFromLink) {
            //The session should be alive for mobile view panels - Deepthi N H
        }
        else {
            this.sessionTimeoutMethod();
        }

    };

    buildHeaderMegaMenu = (CATAGORY_ID) => {
        //fav-right-arrow
        let { userMenu } = this.state;
        let headerMegaMenu = userMenu.filter((x) => (x.ISA_PARENT_IDENT != null && x.CATAGORY_ID == CATAGORY_ID));
        let noChildHeaders = userMenu.filter((x) => (x.ISA_PARENT_IDENT == null && x.CATAGORY_ID == CATAGORY_ID));
        noChildHeaders.forEach((nochdm, index) => {
            if (this.filterChildMenu(userMenu, nochdm).length == 0) {
                headerMegaMenu = headerMegaMenu.concat(nochdm);
            }
        });
        return headerMegaMenu.map((header, headerIndex) => {
            return (<li className="float-left col-md-3" key={header.PROGRAMNAME + "-" + headerIndex}>
                <a className="dropdown-item" href="#" onClick={(event) => this.childMenuClick(event, header)}>{header.PROGRAMNAME}</a>
            </li>);
        });
    };
    isOdd = (num) => num % 2 > 0 ? true : false;
    buildMegaMenu = () => {
        const { megaMenuCategories } = { ...this.state };
        let rightAllignThreshold = megaMenuCategories.length > 0 ? megaMenuCategories.length / 2 : 0;
        let isOddLength = false;
        let middleIndex = -1;
        if (megaMenuCategories.length > 0) {
            isOddLength = megaMenuCategories.length >= 3 ? this.isOdd(megaMenuCategories.length) : false;
            if (isOddLength)
                middleIndex = (Math.round((megaMenuCategories.length) / 2) - 1);
        }

        return megaMenuCategories.map((title, index) => {
            let allignClass = "";
            if (index >= rightAllignThreshold && index != middleIndex)
                allignClass = "dropdown-menu-right position-mega-menu";
            if (isOddLength && index == middleIndex)
                allignClass = 'center-menu';

            return (<li className="custom-menu-nav nav-item" key={title.CATAGORY_ID}>
                <div className="dropdown nav-megamenu-dropdown d-inline-block">
                    <a className="dropdown-toggle submenu-dropdown-arrow home-page-menu" href="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{title.CATAGORY_NAME}</a>
                    <ul className={"dropdown-menu megamenu-container " + allignClass}>
                        {this.buildHeaderMegaMenu(title.CATAGORY_ID)}
                    </ul>
                </div>
            </li>);
        })
    };
    searchKeyPress = (event) => {
        if (event.keyCode == 13) {
            document.activeElement.blur();
            this.searchClick();
        };
    };
    //ww-643- search pikup [3/13/2023]-PAVITHRA R
    searchClick = () => {

        if (IsImageSearch) {
            $('#Shipment_Method').modal('hide');
            IsImageSearch = false
            this.fileInputRef.current.click();

            return


        }
        else if (this.state.autoCompleteValue.trim() && !IsImageSearch) {
            //WW-1374 Update problem code search as false while other search - Nandhini L 
            CookieService.updateLocalStorageValues("IsProblemCodeSearch", false);

            let Shipment_Method = CookieService.getLocalStorageValues("Shipment_Method")
            if (Shipment_Method == false) {
                this.setState({ autocompleteData: [] })
                console.log("autocomplete", this.state.autocompleteData)
                $('#Shipment_Method').modal('show');
                CookieService.updateLocalStorageValues("Shipment_Method", true)
            }

            else if (this.state.pickupCheck == true || this.state.deliveryShipTo == true) {

                document.getElementById("shipmentmerrorid").innerText = ""

                $('#Shipment_Method').modal('hide');

                //WW-1378_WW-1382- Update search properties to new state - Nandhini L
                CookieService.updateLocalStorageValues('fromSearch', false);
                CookieService.updateLocalStorageValues('pageNo', "");
                CookieService.updateLocalStorageValues('GridType', "");
                CookieService.updateLocalStorageValues('pageCount', "");
                CookieService.updateLocalStorageValues("ImageSearch", "");
                CookieService.updateLocalStorageValues("FilePath", "");
                CookieService.updateLocalStorageValues("FileName", "");
                CookieService.updateLocalStorageValues("SearchUrl", "");

                localStorage.setItem("pageNo", 1)
                let searchkeyvalue = this.state.autoCompleteValue.replace(/&/g, "%26") //WW-875_PC_01
                searchkeyvalue = searchkeyvalue.replace(/#/g, "%23")
                if (currentPath.toLowerCase() == "/searchresults") {
                    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                    let currentpage = window.location.href;
                    if (window.location.href.indexOf(`?`))
                        currentpage = window.location.href.split('?')[0];
                    //window.location.href = currentpage + `?key=${searchkeyvalue.trim()}`;
                    this.props.history.push({
                        pathname: `/searchresults`,
                        search: `?key=${searchkeyvalue.trim()}`,
                        state: { ImageSearch: false, ImageFiles: "", image: "" }
                    });
                    window.location.reload()

                }

                else {
                    this.props.history.push({
                        pathname: `/searchresults`,
                        search: `?key=${searchkeyvalue.trim()}`,
                        state: { ImageSearch: false, ImageFiles: "", image: "" }


                    });


                }

                CookieService.updateLocalStorageValues("searchKey", searchkeyvalue.trim());


            }
        }



    };
    //ww-643- search pikup [3/13/2023]-PAVITHRA R
    // Ticket No-5608 regression test bug Add a IsImageSearch variable as false when closing the shipmentClose pop up [4/10/2025] - Nachiappan

    shpCloseClk = () => {
        $('#Shipment_Method').modal('hide');
        IsImageSearch = false;
        document.getElementById("shipmentmerrorid").innerText = ""
        CookieService.updateLocalStorageValues("Shipment_Method", false);
        localStorage.setItem("pickupcheck", false);
        this.setState({ pickupCheck: false, deliveryShipTo: true });
    }
    //ww-643- search pikup [3/13/2023]-PAVITHRA R
    pickupchange = (Type) => {
        let pickupCheck = false
        let deliveryShipTo = false
        if (Type != 1) {
            deliveryShipTo = false
            pickupCheck = true
            localStorage.setItem("pickupcheck", true);

        }
        else {
            deliveryShipTo = true
            pickupCheck = false
            localStorage.setItem("pickupcheck", false);
        }

        this.setState({
            pickupCheck: pickupCheck, deliveryShipTo: deliveryShipTo
        })


    }



    onLanguageHandle = (event) => {
        //debugger
        let newobj = event;
        let newLang = event.value;
        //const { t, i18n } = useTranslation('common');
        //let { t, i18n } = useTranslation("common");
        //debugger
        CookieService.updateLocalStorageValues("oldlanguage", newLang);

        CookieService.updateLocalStorageValues("newlanguage", newobj);
        console.log("langnewval", CookieService.getLocalStorageValues("newlanguage"));
        let Filecheck = CookieService.getLocalStorageValues("resultMessage");
        if (Filecheck) {
            // const localStorageLanguageCode = CookieService.getLocalStorageValues("newlanguage") ? CookieService.getLocalStorageValues("newlanguage") : options[0];
            const localStorageLanguageCode = newobj
            let result = JSON.parse(Filecheck[0].result)

            const langResult = result[0].messages;
            const displayDateTimeStart = ConvertToEst(result[0].displayDateTimeStart);
            const outageDateTimeStart = ConvertToEst(result[0].outageDateTimeStart);
            const outageDateTimeEnd = ConvertToEst(result[0].outageDateTimeEnd);

            const filteredLangResult = langResult.find(msg => msg.languageCode === localStorageLanguageCode.value);
            let externalMessage = filteredLangResult && filteredLangResult.externalMessage;
            externalMessage = externalMessage
                .replace('outageDateTimeStart', outageDateTimeStart)
                .replace('outageDateTimeEnd', outageDateTimeEnd);

            //externalMessage = externalMessage.replace("unavailable", "<span class='bolded-content'>unavailable</span>");
            $('#OutageMsg').html(externalMessage.replace(/<br\s*\/?>/gi, ' '));

            CookieService.updateLocalStorageValues("displayText", externalMessage);

        }

        i18n.changeLanguage(newLang);
        //this.props.i18n.changeLanguage(newLang)
        this.setState({ language: newobj, DefaultLang: newobj });

    }
    // WW-1336 - Relevant Type Ahead Suggestions - [3/14/2025] - K Surya 
    clearSearch = () => {
        this.setState({
            autoCompleteValue: "", productData: [],suggestionData: []
        });
    }
    // PC_A1QA-179 A1QA-179 Pavithra R Help Page
    PassAuthe = (event) => {
        event.preventDefault()
        let customFields = []
        let PassAutheBO = {
            UserID: CookieService.getLocalStorageValues("Session_AGENTUSERID") == "" ? CookieService.getLocalStorageValues("Session_UserID") : CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            UserBu: CookieService.getLocalStorageValues("Session_AGENTUSERBU") == "" ? CookieService.getLocalStorageValues("Session_BUSUNIT") : CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            EmailID: CookieService.getLocalStorageValues("Session_EMAIL"),
            IsThirdParty: CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != "0" && CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != null ? true : false,
            PassWord: "",
            OrderNumber: "",
            PONumber: "",
            HomepageRequest: true,/*[03/23/23, WW-677_01], Priyanka D */
            customFields: customFields
        }
        HomepageAction.getPassThroughAutheURl(PassAutheBO)
    }
    PassThroughAutheResponse = () => {
        let URl = JSON.parse(HomepageStore.PassThroughAuthe)
        window.open(URl);
        window.preventDefault();/*[03/23/23, WW-677_03], Priyanka D */

    }
    bindContactUs = () => {

        return (<div className="ham-section">
            <div class="text-center pb-2">
                <a href="#" className="btn btn-default logoutbtn" onClick={this.logout}><Trans>Logout</Trans></a>
            </div>
            <div className="">
                {/*WW-779 MPE_PC_12 WW-779 Contact Details - Deepthi N H*/}
                {this.state.Wal_Contact_Flag != null && this.state.Wal_Contact_Flag != "" ? <h5 className="float-left"><Trans>Contact Us</Trans></h5> : null}
                <span className="float-right"><a href="#" className="ham-link" onClick={(e) => this.onClickWebVersion(e)}>{this.state.CurrentBuildName}</a></span>
            </div>
            {this.state.Wal_Contact_Flag != null && this.state.Wal_Contact_Flag != "" ? this.state.Wal_Contact_Flag.toUpperCase() == "P" || this.state.Wal_Contact_Flag.toUpperCase() == "PE" ? <div className="col-md-12 float-left px-0">
                <label className="float-left ham-label " style={{ width: "35%" }}><Trans>Phone</Trans><span>:</span></label>
                <a href={`tel:+${this.state.Wal_Phone_Num}`} className="float-left ham-link">{this.state.Wal_Phone_Num}</a>
            </div> : null : null}
            {this.state.Wal_Contact_Flag != null && this.state.Wal_Contact_Flag != "" ? this.state.Wal_Contact_Flag.toUpperCase() == "E" || this.state.Wal_Contact_Flag.toUpperCase() == "PE" ? <div className="col-md-12 float-left px-0">
                <label className="float-left  ham-label " style={{ width: "35%" }}><Trans>Email</Trans><span>:</span></label>
                <a href={`mailto:${this.state.Wal_Email_Id}`} className="float-left ham-link ">{this.state.Wal_Email_Id}</a>
            </div> : null : null}
        </div>

        );
    }
    OnClickSearchType = (value) => {
        CookieService.updateLocalStorageValues("SearchType", value);
        this.setState({ SearchType: value});
        this.retrieveDataAsynchronously(this.state.autoCompleteValue);
    }

    /**
    * Render method loads the HTML components to page
    */
    render() {
        const { t } = this.props;
        const { runTour } = this.state;
        //if (runTour) {
        //    // Disable scroll bar
        //    document.body.style.overflow = 'hidden';
        //} else {
        //    // Enable scroll bar
        //    document.body.style.overflow = 'auto';
        //}
        //if (isChrome) {
        //    document.body.classList.add('is-chrome');
        //} else if (isSafari) {
        //    document.body.classList.add('is-safari');
        //}
        let displayName = "";
        console.log("langstate", CookieService.getLocalStorageValues("newlanguage"));
        if (CookieService.getLocalStorageValues("Session_USERNAME")) {
            displayName = CookieService.getLocalStorageValues("Session_USERNAME").indexOf(",") >= 0 ? CookieService.getLocalStorageValues("Session_USERNAME").split(",")[1] + " " + CookieService.getLocalStorageValues("Session_USERNAME").split(",")[0] : CookieService.getLocalStorageValues("Session_USERNAME");
            if (CookieService.getLocalStorageValues("Session_AGENTUSERID") != "" && CookieService.getLocalStorageValues("Session_AGENTUSERID")) {
                if (CookieService.getLocalStorageValues("Session_USERTYPE") == "ADMINX") {
                    displayName = displayName + CookieService.getLocalStorageValues("Session_CONAME");
                } else {
                    displayName = displayName + CookieService.getLocalStorageValues("Session_AGENTUSERNAME");
                }
            }
        };

        //const steps = [
        //    {
        //        target: '#navbarDropdown_noncatImg',
        //        content: (
        //            <div className="" id="NSTKCartIconAlertModal">
        //                <div className="d-flex justify-content-between align-items-center mb-2">
        //                    <h2 className="font-12 font-medium mb-0">New Cart for Request for Sourcing Items</h2>
        //                    <nav className="bg-transparent border-0" onClick={() => this.closeNSTKCartAlert()}>
        //                        <img src="images/close-icon.svg" alt="close-icon" />
        //                    </nav>
        //                </div>
        //                <p className="font-12 font-regular mb-0 color-light-black text-left">
        //                    This is a new way to see Request for Sourcing items that have not been submitted.
        //    </p>
        //            </div>
        //        ),
        //        placement: 'bottom',
        //        disableBeacon: true,
        //        spotlightClicks: false, 
        //    },
        //];

        //    var $header = $('.hamburger-header');

        //var $content = $('.hamburger-navigation');
        //var $footer = $('.ham-section');
        //    var $window = $(window).on('resize', function () {
        //        var height = $(this).height() - $header.height() + $footer.height();
        //        $content.height(height);
        //    }).trigger('resize'); //on page load

        //$(function () {
        //***NEW***ADDED***(2/4/2021)***for dynamic height in hambuger menu******
        var $header = $('.hamburger-header');
        var $footer = $('.ham-section');
        //console.log("$header.height()", $header.height());
        //console.log(" $footer.height()", $footer.height());

        // $(window).bind("resize", function () {
        // var height = $(this).height() - ($header.height() + $footer.height());
        //let height = $(this).height() - (62+142+10);
        //if (height < 500) {
        //  $(".hamburger-navigation").css("height", height);
        // console.log("height", height);
        //}


        // })
        // $(window).bind("resize", function () {
        // var height = $(this).height() - ($header.height() + $footer.height());
        var height = $(window).height() - (62 + 210);
        var hg = $(window).height() - (62 + 195);
        //if (height < 500) {
        // $(".hamburger-navigation").css("height", height);
        // $(".subham").css("height", hg);
        //WW-520_PC_01 (10/28/2022)-Aparna
        $(".hamburger-navigation").attr('style', `height:${height}px !important`);
        $(".subham").attr('style', `height:${hg}px !important`);


        //console.log("height", height);
        //}


        // }) 
        //************************END**********************************

        return (<div className={runTour ? 'page-container tour-active' : ''}>
            <React.Fragment>
                <IdleTimer
                    ref={ref => { this.idleTimer = ref }}
                    element={document}
                    onActive={this.onActive}
                    onIdle={this.onIdle}
                    onAction={this.onAction}
                    debounce={250}
                    timeout={this.state.timeout} />
                <div id="hamburger-menu-container" >

                    <div id="hamburger-menu-container-background" className="hmenu-dark-bkg-color hmenu-transparent hmenu-opaque" onClick={(e) => this.handleOutsideClick(e)} >
                    </div>
                    <div id="hamburger-canvas" >
                        <div className="nav-sprite hmenu-close-icon" id="hamgurgerhide" />
                        <h3 className="hamburger-header mb-0"><Trans>Main Menu</Trans></h3>
                        {/*WW-394 To Add Search In SDIZ Menu - Deepthi*/}
                        <div className="d-flex">
                            <div className=" input-group charge-code-group p-3" style={{ zIndex: "9999" }}>
                                <Autocomplete
                                    getItemValue={this.getItemMenuValue}
                                    items={this.state.SuggestionMenu}
                                    renderItem={this.rendermenuItem}
                                    value={this.state.SelectedMenuName}
                                    onChange={e => this.onChangeItem(e)}
                                    onSelect={(e) => this.onSelectItem(e)}
                                    inputProps={{ placeholder: t("Search Panel"), className: "form-control float-left sdi-leftnav-search", width: "246px" }}
                                />
                                <div className="input-group-append" >
                                    <span className="input-group-text" onClick={(e) => this.MenuSearchClick(this.state.SelectedMenuName)} >
                                        <span className="shopping-search-icon" />
                                    </span>
                                </div>


                                {/* {this.state.ERRWO ? <span className=" W-100 errorspan1" style={{ fontSize: '10px' }}>Enter Std Cost</span> : null}*/}
                            </div>
                        </div>
                        <div className="list-group hamburger-navigation" id="centerham" >
                            {this.bindHeaderNewElements()}

                            <div className="h-line" />
                            <a href="#" className="list-group-item list-group-item-action border-0" id="MyAccountid" onClick={(event) => this.headerRedirect(event, "/profile" + this.state.myAccQS)}>{t("User Profile")}</a>{/** removing userprofile  from menu (8/3/ 2022)-Aparna */}
                            {/*9/21/22, Bug - 2659, To show fav item and fav order panels as default, Dhevanesam R] */}
                            <a href="#" className="list-group-item list-group-item-action border-0" id="FavOrderid" onClick={(event) => this.headerRedirect(event, "/favorder")}>{t("Favorite")} {t("order_key")}</a>
                            <a href="#" className="list-group-item list-group-item-action border-0" id="FavItemid" onClick={(event) => this.headerRedirect(event, "/favorites")}>{t("Favorite Item")}</a>
                            {this.state.favPages.length > 0 ? <a href="#" className="list-group-item list-group-item-action border-0 menu-arrow" id="FavPagesid" onClick={this.favPagelinkClick.bind(this)} >{t("Favorite")} {t("Page")}</a> : null}


                            {/* <a href="#" className="list-group-item list-group-item-action border-0 " onClick={(event) => this.headerRedirect(event, "/cyclecountrecon")} >Reconciliation</a>*/}
                            {/*<a href="#" className="btn btn-default logoutbtn" onClick={this.logout}>Logout</a>*************RMOVED*/}
                        </div>
                        {this.bindContactUs()}
                    </div>
                    <div id={`non-catalog`} >
                        <div className="nav-sprite hmenu-close-icon" id="hamgurgerhide" onClick={this.hideHamBurger} />
                        <h3 className="hamburger-header mb-3"><img className="mr-3 back-icon" title="Back" id="back" src="/Images/Hamleft-arrow.svg" onClick={this.showParent} /><Trans>{this.state.currentHeader != "" ? this.state.currentHeader : "Main Menu"}</Trans></h3>
                        <span className="hamburger-hidden-title"><Trans>{this.state.currentHeader}</Trans></span>
                        <div className="list-group hamburger-navigation pt-2 subham">
                            <Trans>{this.state.childComponents}</Trans>
                        </div>
                        {this.bindContactUs()}
                    </div>


                </div>
                {isFromLink == false ? <div className="fixed-top">
                    <nav className="navbar navbar-expand-lg navbar-light bg-dark-sdi-nav mobile-menu"> <span className="navbar-brand-business-unit"> {CookieService.getLocalStorageValues("Session_CONAME")} </span>
                        <div className="collapse navbar-collapse">

                            <ul className="navbar-nav ml-auto sdi-primary-nav">
                                {this.state.hasOrderStatus ? <li className="nav-item active"> <a className="nav-link" id="idOrderStatus" href="#" onClick={(event) => this.headerRedirect(event, "/OrderStatus2")}><Trans>Order Status</Trans></a> </li> : null}
                                {this.state.hasFavOrder ? <li className="nav-item dropdown fav-order-dropdown">
                                    <a className="nav-link dropdown-toggle custom-dropdown-toggle " id="idmyfavorder" href="#" aria-haspopup="true" aria-expanded="false" onClick={(event) => this.headerRedirect(event, "/favorder")}><Trans>My favorite order</Trans></a>
                                    {this.state.favOrdersCount > 0 ? <ul className="dropdown-menu custom-dropdown menu-align">
                                        {this.bindFavOrders()}
                                        {this.state.favOrdersCount > 5 ? <li className="list-group-item border-0">
                                            <div className="col-md-12 text-center border-0 p-0">
                                                <button className="btn btn-primary custom-btn-showall primary-btn col-md-12 " onClick={(event) => this.headerRedirect(event, "/favorder")}>{t("Show")} {t("All")}</button>
                                            </div>
                                        </li> : null}
                                    </ul> :
                                        <div className="dropdown-menu  custom-welcome-dropdown dropdown-style-show dropdown-width" aria-labelledby="navbarDropdown-myfav-order">
                                            <div className="col-md-12">
                                                <div className="text-center col-md-12">
                                                    <span className="cc-help-info">{t("No record")}</span>
                                                </div>
                                            </div>
                                        </div>}
                                </li> : null}
                                {/*9/21/22, Bug - 2659, To show fav item and fav order panels as default, Dhevanesam R] */}
                                <li className="nav-item dropdown mt-1 fav-order-dropdown" id="FavItemLi">
                                    <a className="nav-link custom-nav-link dropdown-toggle custom-dropdown-toggle" href="#" id="navbarDropdown-myfav-order" id="idfavitem" role="button" aria-haspopup="true" aria-expanded="false" onClick={(event) => this.headerRedirect(event, "/favorites")}><Trans>My favorite item</Trans></a>
                                    {this.state.favitemcatcount > 0 ? <ul className="dropdown-menu custom-dropdown menu-align menu-align-favcat">
                                        {this.bindFavItemCategory()}
                                        {this.state.favitemcatcount > 5 ? <li className="list-group-item border-0">
                                            <div className="col-md-12 text-center border-0 p-0">
                                                {/*[12/6/21, PC_MC_01, Bug - 1652, Dhevanesam R]*/}
                                                <button className="btn btn-primary custom-btn-showall primary-btn col-md-12 " onClick={(event) => this.headerRedirect(event, "/favorites")}>{t("Show")} {t("All")}</button>
                                            </div>
                                        </li> : null}
                                    </ul>
                                        : <div className="dropdown-menu  custom-welcome-dropdown dropdown-style-show dropdown-width" aria-labelledby="navbarDropdown-myfav-order">
                                            <div className="col-md-12">
                                                <div className="text-center col-md-12">
                                                    <span className="cc-help-info">{t("No record")}</span>
                                                </div>
                                            </div>
                                        </div>}
                                </li>

                                {this.state.hasReqApproval ? <li className="nav-item"> <a className="nav-link" href="#" id="idrequestorapproval" onClick={(event) => this.headerRedirect(event, "/needquote")}>{t("r_a")}({this.state.requestorApprovalCount})</a> </li> : null}
                                {this.state.hasOrderApproval ? <li className="nav-item"> <a className="nav-link" href="#" id="idorderapproval" onClick={(event) => this.headerRedirect(event, "/needapprove?TYPE=W&FROM=MENU")}>{t("Order Approval")}({this.state.orderApprovalCount})</a> </li> : null}
                            </ul>
                        </div>
                    </nav>
                    {isFromLink == false ? <nav className="navbar navbar-expand-lg navbar-light bg-dark-sdi-nav border-0 main-menu d-flex justify-content-between" style={{ "padding-top": "2px" }}>
                        <div className="row">
                            <button className="navbar-toggler float-left display-block" type="button" id="hamburgermenu"> <span className="navbar-toggler-icon" /> </button>
                            <a className="navbar-brand  pt-0" href="#" onClick={(event) => {
                                event.preventDefault();
                                this.props.history.push({
                                    pathname: '/homepage',
                                });
                            }}> <img src={this.state.logo} className="sdi-logo" alt="SDI Logo" />
                            </a>
                        </div>
                        {currentPath.toLowerCase() != "/homepage" ? <div className="row custom-header-search">
                            {/* WW-1336 - Relevant Type Ahead Suggestions - [3/14/2025] - K Surya */}

                            <div className=" input-group desktop-search targetdiv search-autocomplete position-relative" style={{ width: "100%" }} ref={this.wrapperRef}>
                                {/*<Autocomplete
                                getItemValue={this.getItemValue}
                                items={this.state.autocompleteData}
                                renderItem={this.renderItem}
                                value={this.state.autoCompleteValue}
                                onChange={this.onChange}
                                onSelect={this.onSelect}
                                inputProps={{ placeholder: "Search for Product", className: "form-control charge-code-control", onKeyDown: this.searchKeyPress }}

                            
                                {/* WW-1336 - Relevant Type Ahead Suggestions - [3/14/2025] - K Surya */}
                                <div className="col-md-12 col-lg-10 mx-auto p-0 search-autocomplete home-search targetmenumx" ref={this.wrapperRef}>

                                    <div className="input-group dropdown-search mr-2 custom-header-search-input mb-2">
                                        <div className="input-group-prepend">
                                            <button className="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" id="filterButton" aria-expanded="false" ><Trans>{this.state.SearchType}</Trans></button>
                                            <div className="dropdown-menu header-search-dropdown-menuwidth" >

                                                <a
                                                    className="dropdown-item"
                                                    onClick={() => this.OnClickSearchType("All")}
                                                >
                                                    <Trans>All</Trans>
                                                </a>
                                                <a
                                                    className="dropdown-item"
                                                    onClick={() => this.OnClickSearchType("Sup P.#")}
                                                >
                                                    <Trans>Supplier Part #</Trans>
                                                </a>
                                                <a
                                                    className="dropdown-item"
                                                    onClick={() => this.OnClickSearchType("MFG P.#")}
                                                >
                                                    <Trans>Manufacturer Part #</Trans>
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    <input type="text" placeholder={t("Search for product")} className="form-control w-100 targetmenuinput" value={this.state.autoCompleteValue} onChange={(e) => this.onChange(e)} onKeyDown={(e) => this.searchKeyPress(e)} onFocus={() => { this.handleShowElement() }} />
                                    {this.state.autoCompleteValue.trim().length > 0 && this.state.elementIsShow ? this.displaySuggestions() : null}
                                    <span className={this.state.autoCompleteValue.trim().length > 0 ? "search-cancel-header-image cursor-pointer" : "d-none"} onClick={() => this.clearSearch()}></span>
                                    <span className="dropdown-search-icon" id="searchIcon" onClick={() => { this.searchClick() }} />
                                    <img
                                        className="custom-file-attach-icon" src="Images/capture_icon_black.svg"
                                        alt="Select File"
                                        onClick={() => this.handleImageClk()}
                                        style={{ cursor: 'pointer' }}
                                    />
                                    <input
                                        type="file"
                                        title=" "
                                        ref={this.fileInputRef}
                                        id="Imgfile" name="ImgC"
                                        accept="image/jpeg, image/png"
                                        style={{ display: 'none' }}
                                        onChange={this.handleFileChangeClick} />


                                </div>
                            </div>
                        </div> : null}
                        <div className="row">
                            <div className="collapse navbar-collapse">
                                <ul className="navbar-nav ml-auto pr-3">
                                    <li className="nav-item dropdown custom-display"> <a className="nav-link dropdown-toggle sdi-logged-user user-dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" > <Trans>WelcomeKey</Trans><span>!</span> {displayName} </a>
                                        <div className="dropdown-menu custom-welcome-dropdown  dropdown-triangle dropdown-style-show fav-page-width WelcomeArrow" aria-labelledby="navbarDropdown">
                                            <div className="col-md-12">
                                                <div className="row">
                                                    <div className="col-md-7 border-right">
                                                        <h2 className="custom-welcome-dropdown-header">{t("my")} {t("Favorite")} {t("Page")}</h2>
                                                        <div className="list-group custom-list-group">
                                                            {this.bindFavPages()}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-5">
                                                        <h2 className="custom-welcome-dropdown-header"><Trans>My Account</Trans></h2>
                                                        <div className="list-group custom-list-group">
                                                            <a href="#" id="myaccountid" className="list-group-item list-group-item-action border-0 py-1 pl-0" onClick={(event) => this.headerRedirect(event, "/profile" + this.state.myAccQS)}><Trans>My Profile</Trans></a>
                                                            {this.state.AnswerlabVisible ? <a href="#" id="answerlabid" className="list-group-item list-group-item-action border-0 py-1 pl-0" onClick={(event) => {
                                                                event.preventDefault();
                                                                window.open('https://sdiextest.atlassian.net/servicedesk/customer/portals')
                                                            }}>{t("answer_lab")}</a> : null}
                                                            {this.state.isHelpAccess ? <a href="#" id="helpid" className="list-group-item list-group-item-action border-0 py-1 pl-0" onClick={(event) => this.PassAuthe(event)} // PC_A1QA-179 A1QA-179 Pavithra R Help Page


                                                            >{t("Incidents")}</a> : null}
                                                            <a href="#" id="termofpurchaseid" className="list-group-item list-group-item-action border-0 py-1 pl-0" data-toggle="modal" data-target="#pricing">{t("term_of_purchase")}</a>
                                                            <a href="#" id="logoutid" className="list-group-item list-group-item-action border-0 py-1 pl-0" onClick={this.logout}>{t("Logout")}</a> </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>

                                    <li className="sdi-top-margin-width">
                                        <Select
                                            id="pickupstore_DD"
                                            name="PickupStoreSelected"
                                            className="DropDown-Font-Size"
                                            onChange={(e) => this.onLanguageHandle(e)}
                                            value={this.state.language}
                                            defaultValue={options[0]}
                                            options={options}
                                            components={{ Option: IconOption }}

                                        //options={this.Bindpickupstore()}
                                        />

                                        {/*  <select className="form-control" onChange={(e) => this.onLanguageHandle(e)} value={this.state.language}>
                                   
                                    <option value="en"><div><img
                                        alt="United States"
                                        src="http://purecatamphetamine.github.io/country-flag-icons/3x2/US.svg" />English</div></option>
                                    <option value="es"><div><img
                                        alt="United States"
                                        src="http://purecatamphetamine.github.io/country-flag-icons/3x2/MX.svg" />Spanish</div></option>
                                    <option value="fr"><div><img
                                        alt="United States"
                                        src="http://purecatamphetamine.github.io/country-flag-icons/3x2/FR.svg" />French</div></option>
                                </select> */}
                                    </li>
                                    {/*WW-670-The shopping cart icon on the far right and the bell icon next it it on the left.*/}
                                    <li className="nav-item d-flex">
                                        <a className="nav-link custom-nav-link dropdown-toggle notification-icon-arrow px-0 rotate-loading notif-section" href="#" id="navbarDropdown-notification" role="button" aria-haspopup="true" aria-expanded="false" onClick={(event) => this.headerRedirect(event, "/usernotification")}><img src="/Images/bell-icon.png" alt="Notification Icon" />
                                            {/*NEW**CHANGED**(2/3/2021****(classname changed)****className={`cart-count ${this.state.cartCount < 10 ? 'null-count' : ''}`}*/}
                                            {runTour ? <span className=""></span> : this.state.notificationCount != -1 ? <span className={`cart-count ${this.state.notificationCount < 10 ? 'null-count' : this.state.notificationCount > 99 ? 'threedigit-count' : ''}`} id="notification">{this.state.notificationCount > 99 ? `99+` : `${this.state.notificationCount}`}</span> :
                                                <RotatingLines
                                                    strokeColor="#ffc107"
                                                    strokeWidth="5"
                                                    animationDuration="0.75"
                                                    width="15"
                                                    visible={true}
                                                />
                                            } </a>

                                    </li>
                                    {/*<li className="nav-item dropdown cart-dropdown fav-order-dropdown d-flex">
                                        <span className={runTour ? 'nav-link custom-nav-link dropdown-toggle notification-icon-arrow px-0 rotate-loading noncat-cart-highlight highlight' : 'nav-link custom-nav-link dropdown-toggle notification-icon-arrow px-0 rotate-loading noncat-cart-highlight'} href="#" id="navbarDropdown_noncat" role="button" aria-haspopup="true" aria-expanded="false" onClick={(event) => { if (!runTour) this.TopNavNoncatClick(event); }}><img id="navbarDropdown_noncatImg" src="/Images/WALNonCatCart-Icon.svg" alt="Noncatalog Cart Icon" />
                                        {/*NEW**CHANGED**(2/3/2021****(classname changed)****className={`cart-count ${this.state.cartCount < 10 ? 'null-count' : ''}`}*/}
                                    {/*{runTour ? <span className=""></span> : (this.state.NSTKCartCount != -1 ? <span className={`cart-count ${this.state.NSTKCartCount < 10 ? 'null-count' : this.state.NSTKCartCount > 99 ? 'threedigit-count' : ''}`} id="nonCatCartCount">{this.state.NSTKCartCount > 99 ? `99+` : `${this.state.NSTKCartCount}`}</span> :
                                            <RotatingLines
                                                strokeColor="#ffc107"
                                                strokeWidth="5"
                                                animationDuration="0.75"
                                                width="15"
                                                visible={true}
                                            />
                                        )}</span>

                                    <div className="dropdown-menu dropdown-menu-cart custom-welcome-dropdown custom-dropdown-style mobile-index non-catalog-cart" aria-labelledby="navbarDropdown-notification">
                                        <div className="col-md-12">
                                            {this.state.NSTKCartCount > 0 ? <div className="row">
                                                <div className="col-md-12 p-0">
                                                    <h2 class="font-16 font-medium">Walmart source request items</h2>
                                                        <ul className="list-group FavItemWidth-ul pr-4">





                                                        {this.bindNSTKCartData()}

                                                    </ul>
                                                    <div className="list-group-item border-0 pt-0 mt-3">

                                                        <div className="popover-shopping-addcart">
                                                            <button className="btn btn-primary custom-btn-primary" onClick={(event) => this.TopNavNoncatClick(event)}>
                                                                <img src="/Images/NonCatItem_cart.svg" className="addtocart mr-2" alt="Add to cart icon" />
                                                                Go to Cart
                                                              </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div> : <div className="text-center col-md-12">
                                                    <span className="cc-help-info">{t("No record")}</span>
                                                </div>}
                                        </div>
                                    </div>
                                    </li>

                               {/* WW-1331 Accept transfer icon*/}
                                    <li className="nav-item dropdown cart-dropdown fav-order-dropdown d-flex ml-3">
                                        <a className="nav-link custom-nav-link dropdown-toggle notification-icon-arrow px-0 rotate-loading cart-section" href="#" id="navbarDropdown-shoppingcart" role="button" aria-haspopup="true" aria-expanded="false" onClick={(event) => this.headerRedirect(event, "/AcceptTransfer")}><img src="/Images/additional-icon.svg" alt="Accept Transfer Icon" />
                                            {runTour ? <span className=""></span> : this.state.TransferCartCount != -1 ? <span className={`cart-count ${this.state.TransferCartCount < 10 ? 'null-count' : this.state.TransferCartCount > 99 ? 'threedigit-count' : ''}`} id="cartCount">{this.state.TransferCartCount > 99 ? `99+` : `${this.state.TransferCartCount}`}</span> :
                                                <RotatingLines
                                                    strokeColor="#ffc107"
                                                    strokeWidth="5"
                                                    animationDuration="0.75"
                                                    width="15"
                                                    visible={true}
                                                />
                                            }</a>
                                    </li>

                                    <li className="nav-item dropdown cart-dropdown fav-order-dropdown d-flex ml-3 ">
                                        <a className="nav-link custom-nav-link dropdown-toggle notification-icon-arrow px-0 rotate-loading cart-section" href="#" id="navbarDropdown-shoppingcart" role="button" aria-haspopup="true" aria-expanded="false" onClick={(event) => this.headerRedirect(event, "/shoppingcart")}><img src="/Images/sdi-shopping-cart-icon.png" alt="Shopping Cart Icon" />
                                            {/*NEW**CHANGED**(2/3/2021****(classname changed)****className={`cart-count ${this.state.cartCount < 10 ? 'null-count' : ''}`}*/}
                                            {runTour ? <span className=""></span> : this.state.cartCount != -1 ? <span className={`cart-count ${this.state.cartCount < 10 ? 'null-count' : this.state.cartCount > 99 ? 'threedigit-count' : ''}`} id="cartCount">{this.state.cartCount > 99 ? `99+` : `${this.state.cartCount}`}</span> :
                                                <RotatingLines
                                                    strokeColor="#ffc107"
                                                    strokeWidth="5"
                                                    animationDuration="0.75"
                                                    width="15"
                                                    visible={true}
                                                />
                                            }</a>

                                        <div className="dropdown-menu dropdown-menu-cart custom-welcome-dropdown custom-dropdown-style mobile-index" aria-labelledby="navbarDropdown-notification">
                                            <div className="col-md-12">
                                                {this.state.cartCount > 0 ? <div className="row">
                                                    <div className="col-md-12 p-0">
                                                        <ul className="list-group FavItemWidth-ul">





                                                            {this.bindCartData()}
                                                            {/* <li className="list-group-item border-0">
                                                        {this.state.cartCount > 5 ?<div className="col-md-12 text-center border-style pb-4">
                                                            <button className="btn btn-primary custom-btn-showall primary-btn px-4" onClick={(event) => this.headerRedirect(event, "/shoppingcart")}>Show All</button>
                                                        </div> : null}
                                                    </li> 
                                                    <li className="list-group-item border-0 pt-0">
                                                        <div className="popover-shopping-addcart">
                                                            <button className="btn btn-primary custom-btn-primary" onClick={(event) => this.headerRedirect(event, "/shoppingcart")}>
                                                                <img src="/Images/item_cart.png" className="addtocart mr-2" alt="Add to cart icon" />
                                                                Go to Cart
                                                              </button>
                                                        </div>
                                                    </li>*/}
                                                        </ul>
                                                        <div className="list-group-item border-0 pt-0 mt-3">
                                                            {/*<div className="popover-shopping-addcart float-left itemdetailPrice">
                                                            <span>Order total: {this.OrderTotalCal()}</span>
                                                        </div>*/}
                                                            <div className="popover-shopping-addcart">
                                                                <button className="btn btn-primary custom-btn-primary" onClick={(event) => this.headerRedirect(event, "/shoppingcart")}>
                                                                    <img src="/Images/item_cart.png" className="addtocart mr-2" alt="Add to cart icon" />
                                                                    Go to Cart
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> : <div className="text-center col-md-12">
                                                    <span className="cc-help-info">{t("No record")}</span>
                                                </div>}
                                            </div>
                                        </div>
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </nav> : null}
                    {/* WW-1336 - Relevant Type Ahead Suggestions - [3/14/2025] - K Surya */}
                    {currentPath.toLowerCase() != "/homepage" && isFromLink != true ? <div className="col-md-12 targetmenumobile input-group charge-code-group py-1 bg-white mobile-search search-autocomplete px-0 mx-3" ref={this.wrapperRefMobile} >
                        {/* WW-1336 - Relevant Type Ahead Suggestions - [3/14/2025] - K Surya */}

                        <div className=" input-group  targetdiv search-autocomplete position-relative" style={{ width: "100%" }} >
                            {/*<Autocomplete
                                getItemValue={this.getItemValue}
                                items={this.state.autocompleteData}
                                renderItem={this.renderItem}
                                value={this.state.autoCompleteValue}
                                onChange={this.onChange}
                                onSelect={this.onSelect}
                                inputProps={{ placeholder: "Search for Product", className: "form-control charge-code-control", onKeyDown: this.searchKeyPress }}

                            
                                {/* WW-1336 - Relevant Type Ahead Suggestions - [3/14/2025] - K Surya */}
                            <div className="col-md-12 col-lg-10 mx-auto p-0 search-autocomplete home-search targetmenumx" >

                                <div className="input-group dropdown-search mr-2 custom-header-search-input mb-2">
                                    <div className="input-group-prepend">
                                        <button className="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" id="filterButton" aria-expanded="false" ><Trans>{this.state.SearchType}</Trans></button>
                                        <div className="dropdown-menu header-search-dropdown-menuwidth" >
                                            <a
                                                className="dropdown-item"
                                                onClick={() => this.OnClickSearchType("All")}
                                            >
                                                <Trans>All</Trans>
                                            </a>
                                            <a
                                                className="dropdown-item"
                                                onClick={() => this.OnClickSearchType("Sup P.#")}
                                            >
                                                <Trans>Supplier Part #</Trans>
                                            </a>
                                            <a
                                                className="dropdown-item"
                                                onClick={() => this.OnClickSearchType("MFG P.#")}
                                            >
                                                <Trans>Manufacturer Part #</Trans>
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                <input type="text" placeholder={t("Search for product")} className="form-control w-100 targetmenuinput" value={this.state.autoCompleteValue} onChange={(e) => this.onChange(e)} onKeyDown={(e) => this.searchKeyPress(e)} onFocus={() => { this.handleShowElement() }} />
                                {this.state.autoCompleteValue.trim().length > 0 && this.state.elementIsShowMobile ? this.displaySuggestions() : null}
                                <span className={this.state.autoCompleteValue.trim().length > 0 ? "search-cancel-header-image cursor-pointer" : "d-none"} onClick={() => this.clearSearch()}></span>
                                <span className="dropdown-search-icon" id="searchIcon" onClick={() => { this.searchClick() }} />

                            </div>
                        </div>
                    </div> : null}
                    {/*<nav className="navbar navbar-expand-lg navbar-light border-bottom bg-white py-0">
                    <div className="col-md-12 collapse navbar-collapse p-0">
                        <div className="col-md-12 p-0">
                            <ul className="row m-0 header-align p-0">
                                {this.buildMegaMenu()}
                            </ul>
                        </div> 
                    </div>
                </nav>*/}
                    {isFromLink == false ? <section className="breadcrumb-section bg-white">
                        {this.state.breadCrumpDetails.length > 0 ? <nav aria-label="breadcrumb" className="d-inline-block">
                            <ol className="breadcrumb custom_breadcrumb mb-0 pl-4">
                                {/* <li class="breadcrumb-item"><a href="#">Home</a></li> */}
                                {this.bindBreadCrump()}
                            </ol>
                        </nav> : null}
                        <div className="alert-text float-right">
                            {this.state.lblTestVisible ? <span className="alert-text-title">{this.state.lblTest}</span> : null}
                            {this.state.lblTestVisible ? <span className="px-2">{this.state.lblVersion}</span> : null}
                        </div>
                    </section> : null}
                    {isFromLink == false ? <div className="alert-text float-right mobile-alert-txt bg-white">
                        {this.state.lblTestVisible ? <span className="alert-text-title">{this.state.lblTest}</span> : null}
                        {this.state.lblTestVisible ? <span className="px-2">{this.state.lblVersion}</span> : null}
                    </div> : null}
                </div> : null}
                <div className=" modal modal-shipment-method" id="Shipment_Method" data-backdrop="static" data-keyboard="false" aria-modal="true">
                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content" style={{ width: "88%" }}>

                            <div className="modal-header">
                                <h4 className="modal-title mt-1"><Trans>Search Criteria</Trans></h4>
                                <button type="button" className="btn close-btn" data-dismiss="modal" onClick={() => this.shpCloseClk()}>
                                    X
                                </button>
                            </div>

                            {/* Modal Header */}
                            <div className=" modal-title mt-3 modal-shippingmethod-header">
                                <h4 className="modal-title shipmehtod-title mt-1 ml-3" style={{ display: "inline" }}><Trans>Shipment Method</Trans></h4>
                            </div>
                            {/* Modal body */}

                            <div className="modal-body  pt-0">
                                <div className="col-12 p-0 mt-2">
                                    <label className="custom-radiobtn pb-3 mb-0 mr-4"><Trans>Pickup</Trans>

                                        <input type="radio" id="pickup1" checked={this.state.pickUp} name="ship2" onChange={() => this.pickupchange(0)} />
                                        <span className="checkmark checkmark-org" style={{ top: "2px", left: "2px" }} />
                                    </label>
                                    <label className="custom-radiobtn"><Trans>Ship To</Trans>
                                        <input type="radio" id="deliveryshipto" checked={this.state.deliveryShipTo} name="pick2" onChange={() => this.pickupchange(1)} />

                                        <span className="checkmark checkmark-org" style={{ top: "2px", left: "3px" }} />

                                    </label>
                                    <div className="d-flex shiment-info">
                                        <span className="mt-1">
                                            <img className="mr-2 " src="images/PO-Info.svg" /></span>
                                        <label className="confirm-content shipment-font"><Trans>{`Search results will be based on your selection`}</Trans></label>
                                    </div>
                                </div>
                                <span id="shipmentmerrorid" className="DropDown-Font-Size errorcolour"></span>
                                <div className="col-md-12 mt-2 text-right p-0">
                                    <button
                                        className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-3 mt-3"
                                        data-dismiss="modal"
                                        onClick={() => this.shpCloseClk()}
                                    >
                                        <Trans>Cancel</Trans>
                                    </button>
                                    <button
                                        className="btn btn-primary custom-btn-primary primary-btn px-4 mt-3"
                                        id="subdecbtn"
                                        onClick={() => this.searchClick()}
                                        onKeyDown={this.searchKeyPress}
                                    >
                                        <Trans>Apply</Trans>
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                {this.state.Altdet == true ?
                    <div className="modal" id="Altdet" data-backdrop="static" data-keyboard="false">
                        <AlterpartsComponent altDetails={this.state.AlternatePartdetail} flagTable={this.state.filteredFlagTable} closePopup={this.closePopup}  {...this.props} />
                    </div> : null}
                <div className="modal" id="pricing">
                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1">{t("Catalog")} {t("Price")}</h4>
                                <button type="button" className="btn close-btn" data-dismiss="modal">
                                    X
                                </button>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="col-md-12 float-left p-0">
                                    <p className="extended-content  mb-0">{t("In the absence of written agreement to the contrary between customer and SDI, all pricing contained in this catalog is subject to change by SDI at any time without notice.")}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal" id="CoreChargePopUpFavMenu" data-backdrop="static" data-keyboard="false">

                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1" />

                            </div>
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row text-center">
                                    <div className="col-md-12 my-4">
                                        <span className="question-mark-icon" />
                                    </div>
                                    <div className="col-12 mb-4">
                                        <label className="confirm-content d-block"><Trans>The Item you have chosen has a CORE RETURN REQUIREMENT, a CORE Charge fee will be charged at time of purchase and refunded upon return of the associated CORE to the supplier.</Trans></label>
                                        <label className="confirm-content d-block"><Trans>By choosing to PROCEED, You acknowledge that you will ensure the CORE is returned as required!</Trans></label>

                                        <label className="confirm-content d-block"><Trans>If you want to remove the item, you can remove it from the shoppingcart </Trans></label>
                                    </div>
                                    <div className="col-md-12 text-center mb-2">
                                        {/**Added SelectedItemForCheaper to addtocart (which throwed exception)(9/5/2022)-Aparna*/}
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={(e) => { this.CoreChargeProceedClick(e) }}><Trans>Proceed</Trans></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="modal" id="BuildDetailsPopUp">
                    <div className="modal-dialog modal-md modal-dialog-centered sdi-release-modal">
                        <div className="modal-content">
                            {/* Modal body */}
                            <div className="modal-header">
                                <div>
                                    <h5 className="modal-title sdi-release-font-bold" id="exampleModalLongTitle">What’s New</h5>
                                    <p className="sdi-version-label mb-0">{`${this.state.CurrentBuildName} - `}<span>{this.state.CurrentBuildDate}</span></p>
                                </div>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={(e) => this.closeReleaseNotes(e)}>
                                    <img src="images/close-icon.png" alt="close-icon" />
                                </button>
                            </div>
                            <div className="modal-body sdi-release-modal-body">
                                {/* Release caption starts here */}
                                <p className="sdi-release-caption">We're listening you! Based on feedback from our customers the new features in
                                    this version include</p>
                                {/* Release content starts here */}
                                <div className="text-left">
                                    <h2 className="sdi-new-feature">
                                        <span>NEW FEATURES</span>
                                        <span className="sdi-release-history">
                                            <a href="#"><img src="images/history.svg" onClick={e => this.onClickHistoryIcon(e)} alt="history-icon" className="sdi-view-history" title="View Version History" /></a>
                                        </span>
                                    </h2>
                                    <ul className="sdi-line-gap">
                                        {this.state.VersionData.length > 0 ? this.bindReleaseNotesTasks() : null}
                                    </ul>
                                </div>
                                {/* Release content ends here */}
                                {/* Bug Fix content starts here */}
                                {/* <div className="text-left">
                                <h2 className="sdi-new-feature">
                                    <span>BUG FIXES</span>
                                </h2>
                                <ul className="sdi-line-gap">
                                    <li>Can search for items that I do not have privileges for in hamburger menu</li>
                                    <li>Items appear but when we select to add to the cart get an empty screen for Suggested Supplier and
                    cannot proceed to place order.</li>
                                    <li>Delivery date is inserted but after Quoting the delivery date becomes null.</li>
                                    <li>Inventory Items are not at the top of search results.</li>
                                    <li>'Refrigerant' label is not displayed.</li>
                                </ul>
                            </div>*/}
                                {/* Bug Fix content ends here */}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal userid Home-WO" id="WorkOrderPopUp" data-backdrop="static" data-keyboard="false" >
                    <div className="modal-dialog home-wo-input custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1">Work Order #</h4>
                                <button type="button" className="btn close-btn" data-dismiss="modal" onClick={() => this.WOClose()}>
                                    X
                                </button>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row justify-content-center">
                                    <div className="col-md-11 my-3">
                                        <div className="row">
                                            <label class="confirm-content d-block ml-3">Please enter a WO# to continue</label>
                                            <div className="col-lg-12 col-md-12 input-group charge-code-group float-left ">
                                                <input type="text" className={`form-control charge-code-control`} placeholder="Enter WO#" id="WONUMMENU" maxLength="9" onKeyDown={this.KeyPress} pattern="[0-9]*" value={this.state.WONum} onChange={this.WONumChange} defaultValue={''} />

                                                {this.state.WONum != undefined && this.state.WONum != null && this.state.WONum != "" && this.state.WONum != " " ?
                                                    < span class="search-cancel-header cursor-pointer" style={{ right: "58px" }} onClick={() => this.ClearWO()}  > </span> : null
                                                }
                                                <div className="input-group-append" >
                                                    <span className="input-group-text" onClick={() => this.ValidateWO()} >
                                                        <span className="shopping-search-icon" />
                                                    </span>
                                                </div>
                                                {this.state.WOErrorMsg.length > 0 ? <span className="errorspan12 text-left my-2" id="StatusMsgbilltostore">{this.state.WOErrorMsg}</span> : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* <!--MixedCart Confirmation popup Modal Starts here-->*/}
                <div className="modal fade p-0" id="MenuMixedOrderConfirmPopup" data-backdrop="static"
                    tabIndex={-1}
                    role="dialog"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-m modal-dialog-centered mixedcart-confirmation-modal" role="document">
                        <div className="modal-content border-0">
                            <div className="modal-header sp-delv-header align-items-center px-4">
                                <h5 className="modal-title" id="exampleModalLongTitle">
                                    Confirmation
                                </h5>
                            </div>
                            <div className="modal-body font-15 px-4">
                                {this.state.cartConfirmationPopupTxt}
                            </div>

                            {/*button*/}
                            <div className="modal-footer border-0 px-4">
                                <button className="btn btn-light-grey font-14 font-medium mr-3 px-4"
                                    type="button"
                                    data-dismiss="modal" onClick={() => this.handleEquipmentNo()}  >No</button>

                                <button
                                    className="btn btn-custom-primary font-14 font-medium px-4" onClick={() => this.handleEquipmentYes()}
                                    type="button">Yes</button>

                            </div>
                            {/*button*/}
                        </div>
                    </div>
                </div>
                {/*<!--MixedCart Confirmation popup Modal Ends here-->*/}

            </React.Fragment>
            {/*<Joyride
                steps={steps}
                run={runTour}
                continuous={false}
                showSkipButton={false}
                disableOverlayClose={true}
                styles={{
                    options: {
                        zIndex: 10000,
                    },
                    buttonClose: {
                        display: 'none', // Hide close button if needed
                    },
                    spotlight: {
                        backgroundColor: 'transparent', // Hide the spotlight (hotspot) circle
                    },
                    overlay: {
                        backgroundColor: 'rgba(0, 0, 0, 0.5)', // Override if needed
                    },
                }}
            />*/}
        </div>);

    };
};

export default withTranslation()(withAuth0(MenuComponent)); //WW-721_PC_07
